var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs, _defs2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g2, _defs0, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _g3, _defs1, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _defs16, _defs17, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _g4, _defs18, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _g5, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _g6, _defs37, _defs38, _path355, _path356, _defs39, _defs40, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _g7, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _g8, _g9, _g0, _path605;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Capa_1",
    width: 782.6,
    height: 58.937,
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2260",
    type: "text/css"
  }, ".st0{fill:#f4d700}.st1{fill:#bd0033}.st2{fill:none}.st3{fill:#caae17}.st6{fill:#fff}.st7{fill:#008a74}.st15{fill:#0066ac}.st16{fill:#d7d8dc}.st61{fill:#211915}.st64{fill:#99132e}.st66{fill-rule:evenodd;clip-rule:evenodd;fill:#ffed00}.st67{fill:#020202}.st68{fill:#2d2d2d}.st69{fill:#193062}")), /*#__PURE__*/React.createElement("g", {
    id: "g4233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4153"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect2262",
    d: "M19.8 0h104.3v58.8H19.8z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect2264",
    d: "M124.7 0H187v58.8h-62.3z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4133"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2266",
    d: "M32.8 21.7h-.2c-.1 0-.2-.2-.2-.2l-.1-.1-.1-.2s-.2-.3-.1-.5.2-.3.3-.3c.1-.1.3-.1.3-.1l.2-.1c.1 0 .3-.1.3-.1s.1 0 .1-.1h.2l.2-.1H35c.1 0 .3.1.3.1s.3.1.4.2c.1 0 .4.1.5.1.1.1.2.2.3.2.1.1.1.2.1.2v.2c0 .1-.1.2-.1.2l-.1.2-.2.1s-.1.1-.2.1-1.1-.2-1.7-.2c-.5.2-1.5.4-1.5.4",
    className: "st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2268",
    d: "M32.8 21.7h-.2c-.1 0-.2-.2-.2-.2l-.1-.1-.1-.2s-.2-.3-.1-.5.2-.3.3-.3c.1-.1.3-.1.3-.1l.2-.1c.1 0 .3-.1.3-.1s.1 0 .1-.1h.2l.2-.1H35c.1 0 .3.1.3.1s.3.1.4.2c.1 0 .4.1.5.1.1.1.2.2.3.2.1.1.1.2.1.2v.2c0 .1-.1.2-.1.2l-.1.2-.2.1s-.1.1-.2.1-1.1-.2-1.7-.2c-.5.2-1.5.4-1.5.4z",
    className: "st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path2270",
    d: "M34.2 20.3c0-.3.1-.6.3-.6.2 0 .3.2.3.6 0 .3-.1.6-.3.6-.2-.1-.3-.3-.3-.6",
    className: "st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path2272",
    d: "M34.2 20.3c0-.3.1-.6.3-.6.2 0 .3.2.3.6 0 .3-.1.6-.3.6-.2-.1-.3-.3-.3-.6z",
    className: "st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path2274",
    d: "M34.3 20.3c0-.3.1-.5.1-.5.1 0 .1.2.1.5s-.1.5-.1.5-.1-.3-.1-.5",
    className: "st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path2276",
    d: "M34.3 20.3c0-.3.1-.5.1-.5.1 0 .1.2.1.5s-.1.5-.1.5-.1-.3-.1-.5z",
    className: "st2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path2278",
    d: "M34.3 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.2 0-.2-.1-.2-.2",
    className: "st3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2280",
    d: "M34.4 19.3h-.1v-.1h.1v-.1h.1v.1h.1v.1h-.1v.3h.1v.1h-.3v-.1h.1z",
    className: "st3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2282",
    d: "M34.4 19.3h-.1v-.1h.1v-.1h.1v.1h.1v.1h-.1v.3h.1v.1h-.3v-.1h.1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2292"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M34.3 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.2 0-.2-.1-.2-.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137812448273628669960000004892016427188146058_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    id: "use2287",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon2290",
    d: "M34.4 19.3h-.1v-.1h.1v-.1h.1v.1h.1v.1h-.1v.3h.2v.1h-.5v-.1h.2z",
    clipPath: "url(#SVGID_00000137812448273628669960000004892016427188146058_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2304"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000097458799695154411880000015707171694662256824_",
    d: "M34.3 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.2 0-.2-.1-.2-.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072267387947819934650000009447991270354158986_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097458799695154411880000015707171694662256824_",
    id: "use2299",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon2302",
    d: "M34.4 19.3h-.1v-.1h.1v-.1h.1v.1h.1v.1h-.1v.3h.2v.1h-.5v-.1h.2z",
    clipPath: "url(#SVGID_00000072267387947819934650000009447991270354158986_)",
    style: {
      fill: "none"
    }
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path2310",
    d: "M34.5 19.5c.1 0 .1.1.1.2s-.1.2-.2.2-.2-.1-.2-.2.1-.2.1-.2",
    className: "st2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path2312",
    d: "M34.5 21.7h-1v-.6l-.1-.3c-.3-.4-.5-.6-.6-.6 0-.1 0-.1.1-.2.2-.2.8.2 1.1.8 0 .1.1.1.1.2h.8c0-.1.1-.1.1-.2.4-.6.9-1 1.1-.8.1 0 .1.1.1.2-.1-.1-.3.2-.6.6V21.7z",
    className: "st3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path2314",
    d: "M34.5 21.7h-1v-.6l-.1-.3c-.3-.4-.5-.6-.6-.6 0-.1 0-.1.1-.2.2-.2.8.2 1.1.8 0 .1.1.1.1.2h.8c0-.1.1-.1.1-.2.4-.6.9-1 1.1-.8.1 0 .1.1.1.2-.1-.1-.3.2-.6.6V21.7z",
    className: "st2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path2316",
    d: "M36.2 20.2c-.2-.1-.6.3-1 .8m-2.5-.8c.2-.1.6.3 1 .8",
    className: "st2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path2318",
    d: "M33 22.2c0-.1-.1-.2-.1-.2.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2 0 0 0 .1-.1.2 0 .1-.1.2-.1.2-.4-.1-.8-.2-1.4-.2-.6 0-1.1.1-1.4.2-.1-.1-.1-.2-.1-.2Z",
    className: "st3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path2320",
    d: "M33 22.2c0-.1-.1-.2-.1-.2.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2 0 0 0 .1-.1.2 0 .1-.1.2-.1.2-.4-.1-.8-.2-1.4-.2-.6 0-1.1.1-1.4.2-.1-.1-.1-.2-.1-.2Z",
    className: "st2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path2322",
    d: "M34.5 22.7c.5 0 1.1-.1 1.3-.1.1 0 .2-.1.2-.2 0 0 0-.1-.1-.1-.3-.1-.9-.2-1.4-.2-.6 0-1.1.1-1.4.2 0 0-.1 0-.1.1s.1.1.2.2c.2 0 .7.1 1.3.1",
    className: "st3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path2324",
    d: "M34.5 22.7c.5 0 1.1-.1 1.3-.1.1 0 .2-.1.2-.2 0 0 0-.1-.1-.1-.3-.1-.9-.2-1.4-.2-.6 0-1.1.1-1.4.2 0 0-.1 0-.1.1s.1.1.2.2c.2 0 .7.1 1.3.1z",
    className: "st2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path2326",
    d: "m36.1 21.7-.1-.1s-.1.1-.3.1c-.1 0-.2-.2-.2-.2s-.2.1-.3.1c-.1 0-.2-.1-.2-.1s-.1.1-.3.1c-.1 0-.3-.2-.3-.2s-.1.2-.3.2c-.1 0-.2-.1-.2-.1l-.2.2c-.2 0-.3-.1-.3-.1s-.1.2-.2.2-.3-.1-.3-.1v.1h-.1v.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2z",
    className: "st3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path2328",
    d: "m36.1 21.7-.1-.1s-.1.1-.3.1c-.1 0-.2-.2-.2-.2s-.2.1-.3.1c-.1 0-.2-.1-.2-.1s-.1.1-.3.1c-.1 0-.3-.2-.3-.2s-.1.2-.3.2c-.1 0-.2-.1-.2-.1l-.2.2c-.2 0-.3-.1-.3-.1s-.1.2-.2.2-.3-.1-.3-.1v.1h-.1v.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2z",
    className: "st2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path2330",
    d: "M34.5 21.1s0 .1 0 0c0 .2.2.3.3.3.1 0 .2-.1.2-.2v-.1.1c0 .1.1.2.2.2s.2-.1.2-.2l.1-.1v.2c0 .1.1.2.2.2s.1 0 .2-.1v-.1.1c0 .1 0 .1.1.2 0 0 .1 0 .2-.1l.2-.2v.1s-.1.2-.2.2-.1.1-.2.1-.1-.1-.1-.1h-.2c-.1 0-.2-.1-.3-.2-.1.1-.1.1-.2.1s-.2 0-.3-.1c-.1.1-.1.1-.2.1s-.2-.1-.3-.2c-.1.1-.2.2-.3.2-.1 0-.2 0-.2-.1-.1.1-.2.1-.3.1-.1 0-.2 0-.2-.1 0 .1-.2.2-.3.2h-.2c0 .1-.1.1-.1.1-.1 0-.1 0-.2-.1l-.2-.2v-.1l.2.2c.1.1.2.1.2.1.1 0 .1-.1.1-.2v-.1.1c0 .1.1.1.2.1s.2-.1.2-.2v-.2l.1.1c0 .1.1.2.2.2s.2-.1.2-.2v-.1.1c0 .1.1.2.2.2.3 0 .4-.1.5-.3-.1.1-.1 0 0 0z",
    className: "st3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path2332",
    d: "M34.5 21.1s0 .1 0 0c0 .2.2.3.3.3.1 0 .2-.1.2-.2v-.1.1c0 .1.1.2.2.2s.2-.1.2-.2l.1-.1v.2c0 .1.1.2.2.2s.1 0 .2-.1v-.1.1c0 .1 0 .1.1.2 0 0 .1 0 .2-.1l.2-.2v.1s-.1.2-.2.2-.1.1-.2.1-.1-.1-.1-.1h-.2c-.1 0-.2-.1-.3-.2-.1.1-.1.1-.2.1s-.2 0-.3-.1c-.1.1-.1.1-.2.1s-.2-.1-.3-.2c-.1.1-.2.2-.3.2-.1 0-.2 0-.2-.1-.1.1-.2.1-.3.1-.1 0-.2 0-.2-.1 0 .1-.2.2-.3.2h-.2c0 .1-.1.1-.1.1-.1 0-.1 0-.2-.1l-.2-.2v-.1l.2.2c.1.1.2.1.2.1.1 0 .1-.1.1-.2v-.1.1c0 .1.1.1.2.1s.2-.1.2-.2v-.2l.1.1c0 .1.1.2.2.2s.2-.1.2-.2v-.1.1c0 .1.1.2.2.2.3 0 .4-.1.5-.3-.1.1-.1 0 0 0z",
    className: "st2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path2334",
    d: "M34.5 21.7c-.6 0-1.2.1-1.6.2h-.1v-.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2v.1h-.1c-.2-.1-.8-.2-1.4-.2",
    className: "st3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path2336",
    d: "M34.5 21.7c-.6 0-1.2.1-1.6.2h-.1v-.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2v.1h-.1c-.2-.1-.8-.2-1.4-.2z",
    className: "st2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path2338",
    d: "M33.8 22c0-.1.1-.1 0 0 .1-.1.2-.1.2 0h-.2c.1 0 0 0 0 0",
    className: "st6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path2340",
    d: "M33.8 22c0-.1.1-.1 0 0 .1-.1.2-.1.2 0h-.2c.1 0 0 0 0 0z",
    className: "st2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path2342",
    d: "M34.5 22h-.2s-.1 0-.1-.1c0 0 0-.1.1-.1h.4s.1 0 .1.1c0 0 0 .1-.1.1z",
    className: "st1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path2344",
    d: "M34.5 22h-.2s-.1 0-.1-.1c0 0 0-.1.1-.1h.4s.1 0 .1.1c0 0 0 .1-.1.1z",
    className: "st2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path2346",
    d: "M33.4 22.1c-.1 0-.2 0-.2-.1 0 0 0-.1.1-.1h.2s.1 0 .1.1c0 0 0 .1-.2.1z",
    className: "st7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path2348",
    d: "M33.4 22.1c-.1 0-.2 0-.2-.1 0 0 0-.1.1-.1h.2s.1 0 .1.1c0 0 0 .1-.2.1z",
    className: "st2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2350",
    d: "M32.9 22.1h.2l-.1.1h-.1z",
    className: "st1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2352",
    d: "M32.9 22.1h.2l-.1.1h-.1z",
    className: "st2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path2354",
    d: "M34.9 22c0-.1 0-.1 0 0 .1-.1.2-.1.2 0h-.2",
    className: "st6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path2356",
    d: "M34.9 22c0-.1 0-.1 0 0 .1-.1.2-.1.2 0h-.2z",
    className: "st2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path2358",
    d: "M35.5 22.1c.1 0 .2 0 .2-.1 0 0 0-.1-.1-.1h-.2s-.1 0-.1.1c0 0 0 .1.2.1z",
    className: "st7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path2360",
    d: "M35.5 22.1c.1 0 .2 0 .2-.1 0 0 0-.1-.1-.1h-.2s-.1 0-.1.1c0 0 0 .1.2.1z",
    className: "st2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2362",
    d: "M36 22.1h-.2l.1.1h.1z",
    className: "st1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2364",
    d: "M36 22.1h-.2l.1.1h.1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2453"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000172433266790265858980000010871438596633126306_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2377"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000905518028895031210000017789526330426063270_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080890066540136336820000013127920493204214159_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000905518028895031210000017789526330426063270_",
    id: "use2372",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2375",
    d: "M34.9 22v.8",
    clipPath: "url(#SVGID_00000080890066540136336820000013127920493204214159_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2389"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000048469177177425497950000018302995898090129319_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163768697992508743610000011961079000225464723_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048469177177425497950000018302995898090129319_",
    id: "use2384",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2387",
    d: "M34.7 22v.8",
    clipPath: "url(#SVGID_00000163768697992508743610000011961079000225464723_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2401"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096030815476173370120000009216417336495735728_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075867053312408702440000003341199733035849604_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096030815476173370120000009216417336495735728_",
    id: "use2396",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2399",
    d: "M34 22v.8m.1-.8v.8m.2-.8v.8m.2-.8v.8",
    clipPath: "url(#SVGID_00000075867053312408702440000003341199733035849604_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2413"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044865699689692185720000000485359761737159591_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129203184122612713070000011682758067012598426_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044865699689692185720000000485359761737159591_",
    id: "use2408",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2411",
    d: "M33.9 22v.8",
    clipPath: "url(#SVGID_00000129203184122612713070000011682758067012598426_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2425"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008136188460626379310000005008170168031207324_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001643197246641686490000014714362851803974581_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008136188460626379310000005008170168031207324_",
    id: "use2420",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2423",
    d: "M33.6 22v.8m.1-.8v.8",
    clipPath: "url(#SVGID_00000001643197246641686490000014714362851803974581_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2437"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000094591381925907182780000009757670074486000802_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116941843207494819680000017036739467475429775_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094591381925907182780000009757670074486000802_",
    id: "use2432",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2435",
    d: "M33.5 22v.8",
    clipPath: "url(#SVGID_00000116941843207494819680000017036739467475429775_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2449"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116929491668832047620000010923031326521498542_",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183207861778614324960000010455540698369595528_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116929491668832047620000010923031326521498542_",
    id: "use2444",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2447",
    d: "M33.3 22v.8",
    clipPath: "url(#SVGID_00000183207861778614324960000010455540698369595528_)",
    style: {
      fill: "none"
    }
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path2455",
    d: "M34.5 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.4 0-.8.1-1.3.1z",
    className: "st2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path2457",
    d: "M36.1 21.4s0-.1 0 0c-.1-.1-.1-.1 0 0-.2 0-.1.1 0 0-.1.1-.1.1 0 0",
    className: "st3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path2459",
    d: "M36.1 21.4s0-.1 0 0c-.1-.1-.1-.1 0 0-.2 0-.1.1 0 0-.1.1-.1.1 0 0z",
    className: "st2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path2461",
    d: "M35 21.2s0-.1 0 0c-.1-.1-.1-.1 0 0-.1 0 0 .1 0 0 0 .1 0 0 0 0",
    className: "st3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path2463",
    d: "M35 21.2s0-.1 0 0c-.1-.1-.1-.1 0 0-.1 0 0 .1 0 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path2465",
    d: "M33.9 21.2s0-.1 0 0c.1-.1.1-.1 0 0 .1 0 .1.1 0 0 0 .1 0 0 0 0",
    className: "st3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path2467",
    d: "M33.9 21.2s0-.1 0 0c.1-.1.1-.1 0 0 .1 0 .1.1 0 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path2469",
    d: "M32.8 21.4s0-.1 0 0c.1-.1.1-.1 0 0 .2 0 .2.1 0 0 .1.1.1.1 0 0",
    className: "st3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path2471",
    d: "M32.8 21.4s0-.1 0 0c.1-.1.1-.1 0 0 .2 0 .2.1 0 0 .1.1.1.1 0 0z",
    className: "st2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2473",
    d: "m34.6 20.7-.1-.1-.2.1.1.3h.1z",
    className: "st3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2475",
    d: "m34.6 20.7-.1-.1-.2.1.1.3h.1z",
    className: "st2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2477",
    d: "M34.1 20.9V21.2l.3-.1.1-.1h-.1z",
    className: "st3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2479",
    d: "M34.1 20.9V21.2l.3-.1.1-.1h-.1z",
    className: "st2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2481",
    d: "M34.8 20.9V21.2l-.3-.1V21z",
    className: "st3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2483",
    d: "M34.8 20.9V21.2l-.3-.1V21z",
    className: "st2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2485",
    d: "m33.5 20.8-.2-.1-.2.2.2.2h.1z",
    className: "st3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2487",
    d: "m33.5 20.8-.2-.1-.2.2.2.2h.1z",
    className: "st2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2489",
    d: "M33 21.1v.1l.1.1.2-.1.1-.1h-.1z",
    className: "st3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2491",
    d: "M33 21.1v.1l.1.1.2-.1.1-.1h-.1z",
    className: "st2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2493",
    d: "m33.6 20.9.2.2-.1.1h-.3v-.1z",
    className: "st3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2495",
    d: "m33.6 20.9.2.2-.1.1h-.3v-.1z",
    className: "st2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2497",
    d: "m32.6 21.2.1.1v.1h-.4z",
    className: "st3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2499",
    d: "m32.6 21.2.1.1v.1h-.4z",
    className: "st2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path2501",
    d: "M33.3 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1-.1 0-.1-.1",
    className: "st3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "path2503",
    d: "M33.3 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1-.1 0-.1-.1z",
    className: "st2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2505",
    d: "m35.4 20.8.2-.1.2.2-.2.2h-.1z",
    className: "st3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2507",
    d: "m35.4 20.8.2-.1.2.2-.2.2h-.1z",
    className: "st2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2509",
    d: "M35.9 21.1v.1l-.1.1-.2-.1-.1-.1h.1z",
    className: "st3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2511",
    d: "M35.9 21.1v.1l-.1.1-.2-.1-.1-.1h.1z",
    className: "st2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2513",
    d: "m35.3 20.9-.2.2.1.1h.3v-.1z",
    className: "st3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2515",
    d: "m35.3 20.9-.2.2.1.1h.3v-.1z",
    className: "st2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2517",
    d: "m36.3 21.2-.1.1v.1h.3z",
    className: "st3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2519",
    d: "m36.3 21.2-.1.1v.1h.3z",
    className: "st2"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "path2521",
    d: "M34.3 21c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1",
    className: "st3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "path2523",
    d: "M34.3 21c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1z",
    className: "st2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "path2525",
    d: "M35.4 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1",
    className: "st3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "path2527",
    d: "M35.4 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1z",
    className: "st2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "path2529",
    d: "M32.3 21.4s-.1-.1-.1-.2l-.1-.1.1-.1h.1s.1 0 .1.1c-.1.2-.1.3-.1.3",
    className: "st3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "path2531",
    d: "M32.3 21.4s-.1-.1-.1-.2l-.1-.1.1-.1h.1s.1 0 .1.1c-.1.2-.1.3-.1.3z",
    className: "st2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "path2533",
    d: "m32.3 21.4.1.1h-.1v-.1",
    className: "st3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "path2535",
    d: "m32.3 21.4.1.1h-.1z",
    className: "st2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "path2537",
    d: "M36.6 21.4s.1-.1.1-.2l.1-.1-.1-.1h-.1s-.1 0-.1.1c0 .2 0 .3.1.3-.1 0-.1 0 0 0",
    className: "st3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "path2539",
    d: "M36.6 21.4s.1-.1.1-.2l.1-.1-.1-.1h-.1s-.1 0-.1.1c0 .2 0 .3.1.3-.1 0-.1 0 0 0z",
    className: "st2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "path2541",
    d: "m36.6 21.4-.1.1h.1v-.1",
    className: "st3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "path2543",
    d: "m36.6 21.4-.1.1h.1z",
    className: "st2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "rect2545",
    d: "M32.1 22.7h4.7V24h-4.7z",
    className: "st3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "rect2547",
    d: "M32.1 22.7h4.7V24h-4.7z",
    className: "st2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "path2549",
    d: "M32.6 24.8s.1 0 0 0h3.7c-.1 0-.2-.2-.2-.3 0-.1.1-.3.2-.3h-3.7c.1 0 .2.2.2.3 0 .2-.1.3-.2.3",
    className: "st3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "path2551",
    d: "M32.6 24.8s.1 0 0 0h3.7c-.1 0-.2-.2-.2-.3 0-.1.1-.3.2-.3h-3.7c.1 0 .2.2.2.3 0 .2-.1.3-.2.3z",
    className: "st2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "path2553",
    d: "M32.7 24.8h3.5c.1 0 .2.1.2.2s-.1.2-.2.2h-3.5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2",
    className: "st3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "path2555",
    d: "M32.7 24.8h3.5c.1 0 .2.1.2.2s-.1.2-.2.2h-3.5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2z",
    className: "st2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "path2557",
    d: "M32.7 24h3.5c.1 0 .2.1.2.1 0 .1-.1.1-.2.1h-3.5c-.1 0-.2-.1-.2-.1 0-.1.1-.1.2-.1",
    className: "st3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "path2559",
    d: "M32.7 24h3.5c.1 0 .2.1.2.1 0 .1-.1.1-.2.1h-3.5c-.1 0-.2-.1-.2-.1 0-.1.1-.1.2-.1z",
    className: "st2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "path2561",
    d: "M37.7 45.7c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st15"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "path2563",
    d: "M37.7 45.7c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "path2565",
    d: "M37.7 46.3c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st16"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "path2567",
    d: "M37.7 46.3c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "path2569",
    d: "M37.7 46.8c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st15"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "path2571",
    d: "M37.7 46.8c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "path2573",
    d: "M37.7 47.9c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v-.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st16"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "path2575",
    d: "M37.7 47.9c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v-.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "path2577",
    d: "M37.7 48.4c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v-.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st15"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "path2579",
    d: "M37.7 48.4c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2v-.5c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2z",
    className: "st2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "path2581",
    d: "M32.6 43.5c0 .4-.3.7-.6.7h4.8c-.3 0-.6-.3-.6-.6v-.1h-3.6c.1 0 0 0 0 0",
    className: "st3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "path2583",
    d: "M32.6 43.5c0 .4-.3.7-.6.7h4.8c-.3 0-.6-.3-.6-.6v-.1h-3.6c.1 0 0 0 0 0z",
    className: "st2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "path2585",
    d: "M32.7 43.2h3.5c.1 0 .2.1.2.2s-.1.2-.2.2h-3.5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2",
    className: "st3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "path2587",
    d: "M32.7 43.2h3.5c.1 0 .2.1.2.2s-.1.2-.2.2h-3.5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2z",
    className: "st2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "rect2589",
    d: "M32.1 44.3h4.8v1.3h-4.8z",
    className: "st3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "rect2591",
    d: "M32.1 44.3h4.8v1.3h-4.8z",
    className: "st2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "path2593",
    d: "M31.7 38.6c-.5.3-.8.6-.7.7 0 .1.2.2.4.4.3.3.5.7.4.9.3-.2.5-.6.5-1-.1-.4-.3-.7-.6-1",
    className: "st1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "path2595",
    d: "M31.7 38.6c-.5.3-.8.6-.7.7 0 .1.2.2.4.4.3.3.5.7.4.9.3-.2.5-.6.5-1-.1-.4-.3-.7-.6-1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2612"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g2598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054243231329561117460000011783580355543520934_",
    d: "M32.7 25.4h3.4V43h-3.4z",
    className: "st16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2608"
  }, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000153688591356728199750000018246677943997945734_",
    d: "M32.7 25.4h3.4V43h-3.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132786390004426743950000009969028502829331592_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153688591356728199750000018246677943997945734_",
    id: "use2603",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2606",
    d: "M35.6 24.9v18.6m-.4-18.6v18.6",
    clipPath: "url(#SVGID_00000132786390004426743950000009969028502829331592_)",
    style: {
      fill: "none"
    }
  })))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "rect2614",
    d: "M32.7 25.4h3.4V43h-3.4z",
    className: "st2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "path2616",
    d: "M39.6 32c-.7-.3-2-.6-3.5-.6-.5 0-1.1.1-1.6.2-2 .4-3.6 1.2-3.5 1.9v.1s-.8-1.8-.8-1.9c-.1-.8 1.6-1.7 3.8-2.1.7-.1 1.4-.2 2-.2 1.4 0 2.7.2 3.5.5z",
    className: "st1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "path2618",
    d: "M39.6 32c-.7-.3-2-.6-3.5-.6-.5 0-1.1.1-1.6.2-2 .4-3.6 1.2-3.5 1.9v.1s-.8-1.8-.8-1.9c-.1-.8 1.6-1.7 3.8-2.1.7-.1 1.4-.2 2-.2 1.4 0 2.7.2 3.5.5z",
    className: "st2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "path2620",
    d: "M32.7 34.2c-.9-.1-1.6-.3-1.7-.8-.1-.3.3-.7.8-1 .3 0 .5.1.8.1z",
    className: "st1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "path2622",
    d: "M32.7 34.2c-.9-.1-1.6-.3-1.7-.8-.1-.3.3-.7.8-1 .3 0 .5.1.8.1z",
    className: "st2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "path2624",
    d: "M36.2 32.8c.6.1 1 .2 1.3.4.1.2-.4.7-1.3 1.3z",
    className: "st1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "path2626",
    d: "M36.2 32.8c.6.1 1 .2 1.3.4.1.2-.4.7-1.3 1.3z",
    className: "st2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "path2628",
    d: "M30.6 37.6c-.1-.3.8-.9 2.1-1.4.6-.2 1.1-.5 1.7-.7 1.8-.8 3.1-1.8 3-2.2.1.1.2 1.8.2 1.8.2.3-1.1 1.3-2.7 2.1-.5.3-1.7.7-2.2.9-.9.3-1.9 1-1.8 1.3z",
    className: "st1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "path2630",
    d: "M30.6 37.6c-.1-.3.8-.9 2.1-1.4.6-.2 1.1-.5 1.7-.7 1.8-.8 3.1-1.8 3-2.2.1.1.2 1.8.2 1.8.2.3-1.1 1.3-2.7 2.1-.5.3-1.7.7-2.2.9-.9.3-1.9 1-1.8 1.3z",
    className: "st2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "path2632",
    d: "m32.3 30.5.1-.1c.1 0 .3 0 .3.2 0 .1 0 .3-.1.3 0 0-.1 0-.1.1zm.2.6c.4-.2.7-.4.6-.7-.1-.2-.3-.3-.6-.1l-.6.2.5 1.3c.1 0 .1-.1.2-.1s.1 0 .2-.1z",
    className: "st3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "path2634",
    d: "M33.8 29.9h-.4l.3 1.4.9-.2v-.2c-.2 0-.3.1-.5.1z",
    className: "st3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "path2636",
    d: "m35.7 31.1.6-1.5h-.2c-.1.4-.2.7-.4 1.1-.2-.3-.4-.7-.5-1h-.4c.3.5.5.9.8 1.4h.1c-.1 0-.1 0 0 0",
    className: "st3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "path2638",
    d: "M37.6 30c0-.1.1-.1.1-.2-.1 0-.2-.1-.4-.1-.4 0-.6.1-.6.4-.1.5.7.5.7.8 0 .1-.2.2-.3.2-.2 0-.3-.1-.3-.3 0 .1-.1.2-.1.3.1.1.3.1.4.1.4 0 .7-.1.7-.4.1-.5-.7-.5-.7-.8 0-.1.1-.2.3-.2l.2.2z",
    className: "st3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "path2640",
    d: "M65.7 21.3s-.2.2-.3.2c-.1 0-.3-.1-.3-.1s-.1.1-.2.1-.3-.1-.3-.1-.1.2-.2.2-.2-.1-.2-.1 0 .1-.1.1H64l-.1-.1-.1-.2-.1-.1-.1-.2v-.1c0-.1.2-.3.5-.4h.4c.1-.1.4-.2.7-.2.3 0 .5.1.6.2.1-.1.4-.2.6-.2.3 0 .6.1.7.2h.4c.3.1.5.2.5.4v.1l-.1.2-.1.1-.1.2-.1.1h-.1c-.1 0-.1-.1-.1-.1s-.1.1-.2.1-.2-.2-.2-.2-.2.2-.3.1c-.1 0-.2-.1-.2-.1s-.1.1-.3.1c-.3 0-.5-.2-.5-.2",
    className: "st1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "path2642",
    d: "M65.7 21.3s-.2.2-.3.2c-.1 0-.3-.1-.3-.1s-.1.1-.2.1-.3-.1-.3-.1-.1.2-.2.2-.2-.1-.2-.1 0 .1-.1.1H64l-.1-.1-.1-.2-.1-.1-.1-.2v-.1c0-.1.2-.3.5-.4h.4c.1-.1.4-.2.7-.2.3 0 .5.1.6.2.1-.1.4-.2.6-.2.3 0 .6.1.7.2h.4c.3.1.5.2.5.4v.1l-.1.2-.1.1-.1.2-.1.1h-.1c-.1 0-.1-.1-.1-.1s-.1.1-.2.1-.2-.2-.2-.2-.2.2-.3.1c-.1 0-.2-.1-.2-.1s-.1.1-.3.1c-.3 0-.5-.2-.5-.2z",
    className: "st2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "path2644",
    d: "M65.4 20.4c0-.2.1-.4.3-.4.2 0 .3.2.3.4s-.1.4-.3.4c-.1 0-.3-.2-.3-.4",
    className: "st3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "path2646",
    d: "M65.4 20.4c0-.2.1-.4.3-.4.2 0 .3.2.3.4s-.1.4-.3.4c-.1 0-.3-.2-.3-.4z",
    className: "st2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "path2648",
    d: "M65.6 20.4c0-.2.1-.4.1-.4.1 0 .1.2.1.4s-.1.4-.1.4-.1-.2-.1-.4",
    className: "st3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "path2650",
    d: "M65.6 20.4c0-.2.1-.4.1-.4.1 0 .1.2.1.4s-.1.4-.1.4-.1-.2-.1-.4z",
    className: "st2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "path2652",
    d: "M64.2 22.2c0-.1-.1-.2-.1-.2.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2 0 0 0 .1-.1.2 0 .1-.1.2-.1.2-.4-.1-.8-.2-1.4-.2-.6 0-1.1.1-1.4.2 0-.1 0-.2-.1-.2z",
    className: "st3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "path2654",
    d: "M64.2 22.2c0-.1-.1-.2-.1-.2.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2 0 0 0 .1-.1.2 0 .1-.1.2-.1.2-.4-.1-.8-.2-1.4-.2-.6 0-1.1.1-1.4.2 0-.1 0-.2-.1-.2z",
    className: "st2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "path2656",
    d: "M65.7 22.7c.5 0 1.1-.1 1.3-.1.1 0 .2-.1.2-.2 0 0 0-.1-.1-.1-.3-.1-.9-.2-1.4-.2-.6 0-1.1.1-1.4.2 0 0-.1 0-.1.1s.1.1.2.2c.3 0 .8.1 1.3.1",
    className: "st3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "path2658",
    d: "M65.7 22.7c.5 0 1.1-.1 1.3-.1.1 0 .2-.1.2-.2 0 0 0-.1-.1-.1-.3-.1-.9-.2-1.4-.2-.6 0-1.1.1-1.4.2 0 0-.1 0-.1.1s.1.1.2.2c.3 0 .8.1 1.3.1z",
    className: "st2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "path2660",
    d: "M67 20.6c0-.1 0-.1 0 0 .1-.1.2-.1.2 0 0 0-.1.1-.2 0 0 .1 0 0 0 0",
    className: "st6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "path2662",
    d: "M67 20.6c0-.1 0-.1 0 0 .1-.1.2-.1.2 0 0 0-.1.1-.2 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "path2664",
    d: "M66.1 19.9s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0zm.3 0s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0zm.3.1s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0zm.2.2s.1-.1 0 0c.1-.1.2-.1.2 0s0 .1-.2 0c.1.1 0 .1 0 0z",
    className: "st6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "path2666",
    d: "M67.9 21.2V21c0-.4-.3-.6-.6-.6-.1 0-.2 0-.3.1",
    className: "st2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "path2668",
    d: "M66.9 20.8c0-.1.1-.1.1-.2 0-.3-.2-.5-.6-.5-.1 0-.3 0-.3.1",
    className: "st2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "path2670",
    d: "M67.2 20.2c0-.1 0-.1 0 0 .1-.1.2-.1.2 0-.1 0-.1.1-.2 0 0 .1 0 0 0 0zm.3 0c0-.1 0-.1 0 0 .1-.1.2-.1.2 0-.1 0-.1.1-.2 0 0 .1 0 0 0 0zm.2.1s.1-.1 0 0c.1-.1.2-.1.2 0s0 .1-.2 0c.1.1 0 .1 0 0zm.3.3c0-.1 0-.1 0 0 .1-.1.2-.1.2 0-.1 0-.1.1-.2 0 0 .1 0 0 0 0zm0 .3s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0z",
    className: "st6"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "path2672",
    d: "m67.4 21.7-.1-.1s-.1.1-.3.1c-.1 0-.2-.2-.2-.2s-.2.1-.3.1c-.1 0-.2-.1-.2-.1s-.1.1-.3.1c-.1 0-.3-.2-.3-.2s-.1.2-.3.2c-.1 0-.2-.1-.2-.1l-.2.2c-.2 0-.3-.1-.3-.1s-.1.2-.2.2-.3-.1-.3-.1v.1h-.1v.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2z",
    className: "st3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "path2674",
    d: "m67.4 21.7-.1-.1s-.1.1-.3.1c-.1 0-.2-.2-.2-.2s-.2.1-.3.1c-.1 0-.2-.1-.2-.1s-.1.1-.3.1c-.1 0-.3-.2-.3-.2s-.1.2-.3.2c-.1 0-.2-.1-.2-.1l-.2.2c-.2 0-.3-.1-.3-.1s-.1.2-.2.2-.3-.1-.3-.1v.1h-.1v.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2z",
    className: "st2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "path2676",
    d: "M64.3 20.6c0-.1 0-.1 0 0 .1-.1.2-.1.2 0 0 0-.1.1-.2 0 0 .1 0 0 0 0",
    className: "st6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "path2678",
    d: "M64.3 20.6c0-.1 0-.1 0 0 .1-.1.2-.1.2 0 0 0-.1.1-.2 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "path2680",
    d: "M65.2 19.9s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0zm-.3 0s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0zm-.3.1s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0zm-.2.2s0-.1 0 0c.1-.1.2-.1.2 0-.1.1-.1.1-.2 0 0 .1 0 .1 0 0z",
    className: "st6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "path2682",
    d: "M63.5 21.2V21c0-.4.3-.6.6-.6.1 0 .2 0 .3.1",
    className: "st2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "path2684",
    d: "M64.6 20.8c0-.1-.1-.1-.1-.2 0-.3.2-.5.6-.5.1 0 .3 0 .3.1",
    className: "st2"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "path2686",
    d: "M64.1 20.2c0-.1.1-.1 0 0 .1-.1.2-.1.2 0 0 0 0 .1-.2 0 .1.1 0 0 0 0zm-.3 0c0-.1.1-.1 0 0 .1-.1.2-.1.2 0 0 0 0 .1-.2 0 .1.1 0 0 0 0zm-.3.1s.1-.1 0 0c.1-.1.2-.1.2 0s0 .1-.2 0c.1.1 0 .1 0 0zm-.2.3c0-.1.1-.1 0 0 .1-.1.2-.1.2 0 0 0 0 .1-.2 0 .1.1 0 0 0 0zm0 .3s0-.1 0 0c.1-.1.2-.1.2 0s-.1.1-.2 0c0 .1 0 .1 0 0z",
    className: "st6"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "path2688",
    d: "M65.7 21.1c.1 0 .1.1 0 0 0 .2.2.3.3.3.1 0 .2-.1.2-.2v-.1.1c0 .1.1.2.2.2s.2-.1.2-.2l.1-.1v.2c0 .1.1.2.2.2s.1 0 .2-.1v-.1.1c0 .1 0 .1.1.2 0 0 .1 0 .2-.1l.2-.2v.1s-.1.2-.2.2-.1.1-.2.1-.1-.1-.1-.1h-.2c-.1 0-.3-.1-.3-.2-.1.1-.1.1-.2.1s-.2 0-.3-.1c-.1.1-.1.1-.2.1s-.2-.1-.3-.2c-.1.1-.2.2-.3.2-.1 0-.2 0-.2-.1-.1.1-.2.1-.3.1-.1 0-.2 0-.2-.1 0 .1-.2.2-.3.2h-.2c0 .1-.1.1-.1.1-.1 0-.1 0-.2-.1l-.2-.2v-.1l.2.2c.1.1.2.1.2.1.1 0 .1-.1.1-.2v-.1.1c0 .1.1.1.2.1s.2-.1.2-.2v-.2l.1.1c0 .1.1.2.2.2s.2-.1.2-.2v-.1.1c0 .1.1.2.2.2.4 0 .5-.1.5-.3 0 .1 0 0 0 0z",
    className: "st3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "path2690",
    d: "M65.7 21.1c.1 0 .1.1 0 0 0 .2.2.3.3.3.1 0 .2-.1.2-.2v-.1.1c0 .1.1.2.2.2s.2-.1.2-.2l.1-.1v.2c0 .1.1.2.2.2s.1 0 .2-.1v-.1.1c0 .1 0 .1.1.2 0 0 .1 0 .2-.1l.2-.2v.1s-.1.2-.2.2-.1.1-.2.1-.1-.1-.1-.1h-.2c-.1 0-.3-.1-.3-.2-.1.1-.1.1-.2.1s-.2 0-.3-.1c-.1.1-.1.1-.2.1s-.2-.1-.3-.2c-.1.1-.2.2-.3.2-.1 0-.2 0-.2-.1-.1.1-.2.1-.3.1-.1 0-.2 0-.2-.1 0 .1-.2.2-.3.2h-.2c0 .1-.1.1-.1.1-.1 0-.1 0-.2-.1l-.2-.2v-.1l.2.2c.1.1.2.1.2.1.1 0 .1-.1.1-.2v-.1.1c0 .1.1.1.2.1s.2-.1.2-.2v-.2l.1.1c0 .1.1.2.2.2s.2-.1.2-.2v-.1.1c0 .1.1.2.2.2.4 0 .5-.1.5-.3 0 .1 0 0 0 0z",
    className: "st2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "path2692",
    d: "M65.7 21.7c-.6 0-1.2.1-1.6.2H64v-.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2v.1h-.1c-.2-.1-.7-.2-1.4-.2",
    className: "st3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "path2694",
    d: "M65.7 21.7c-.6 0-1.2.1-1.6.2H64v-.1c.4-.1 1-.2 1.6-.2.6 0 1.2.1 1.6.2v.1h-.1c-.2-.1-.7-.2-1.4-.2z",
    className: "st2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "path2696",
    d: "M65.1 22c0-.1.1-.1 0 0 .1-.1.2-.1.2 0h-.2c.1 0 0 0 0 0",
    className: "st6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "path2698",
    d: "M65.1 22c0-.1.1-.1 0 0 .1-.1.2-.1.2 0h-.2c.1 0 0 0 0 0z",
    className: "st2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "path2700",
    d: "M65.7 22h-.2s-.1 0-.1-.1c0 0 0-.1.1-.1h.5s.1 0 .1.1c0 0 0 .1-.1.1z",
    className: "st1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "path2702",
    d: "M65.7 22h-.2s-.1 0-.1-.1c0 0 0-.1.1-.1h.5s.1 0 .1.1c0 0 0 .1-.1.1z",
    className: "st2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "path2704",
    d: "M64.7 22.1c-.1 0-.2 0-.2-.1 0 0 0-.1.1-.1h.2s.1 0 .1.1c0 0 0 .1-.2.1z",
    className: "st7"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "path2706",
    d: "M64.7 22.1c-.1 0-.2 0-.2-.1 0 0 0-.1.1-.1h.2s.1 0 .1.1c0 0 0 .1-.2.1z",
    className: "st2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2708",
    d: "M64.2 22.1h.1v.1h-.2z",
    className: "st1"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2710",
    d: "M64.2 22.1h.1v.1h-.2z",
    className: "st2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "path2712",
    d: "M66.2 22c0-.1 0-.1 0 0 .1-.1.2-.1.2 0h-.2",
    className: "st6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "path2714",
    d: "M66.2 22c0-.1 0-.1 0 0 .1-.1.2-.1.2 0h-.2z",
    className: "st2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "path2716",
    d: "M66.7 22.1c.1 0 .2 0 .2-.1 0 0 0-.1-.1-.1h-.2s-.1 0-.1.1c0 0 0 .1.2.1z",
    className: "st7"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "path2718",
    d: "M66.7 22.1c.1 0 .2 0 .2-.1 0 0 0-.1-.1-.1h-.2s-.1 0-.1.1c0 0 0 .1.2.1z",
    className: "st2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2720",
    d: "M67.3 22.1h-.2l.1.1h.1z",
    className: "st1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2722",
    d: "M67.3 22.1h-.2l.1.1h.1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2811"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g2725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000032610073423046431120000008915243191245833401_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2735"
  }, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168815894117807225340000000410960722413539496_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030481289522906958790000009192127554284815750_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168815894117807225340000000410960722413539496_",
    id: "use2730",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2733",
    d: "M66.2 22v.8",
    clipPath: "url(#SVGID_00000030481289522906958790000009192127554284815750_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2747"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083774800639712737260000006144484632574194616_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181085282484202552900000002694495625663357603_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083774800639712737260000006144484632574194616_",
    id: "use2742",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2745",
    d: "M65.9 22v.8",
    clipPath: "url(#SVGID_00000181085282484202552900000002694495625663357603_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2759"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115476199467407611120000007756896928622937528_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140703872880479904680000015784394703465267845_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115476199467407611120000007756896928622937528_",
    id: "use2754",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2757",
    d: "M65.3 22v.8m.1-.8v.8m.2-.8v.8m.2-.8v.8",
    clipPath: "url(#SVGID_00000140703872880479904680000015784394703465267845_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2771"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133492599885220750850000004020829116824419992_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055680009951590642720000008113129756247149984_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133492599885220750850000004020829116824419992_",
    id: "use2766",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2769",
    d: "M65.2 22v.8",
    clipPath: "url(#SVGID_00000055680009951590642720000008113129756247149984_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2783"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067223662921616901840000011273473262133354907_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071527751329868100940000016607375250396861344_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067223662921616901840000011273473262133354907_",
    id: "use2778",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2781",
    d: "M64.9 22v.8m.1-.8v.8",
    clipPath: "url(#SVGID_00000071527751329868100940000016607375250396861344_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2795"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008870047804945533090000011244363647428860834_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109749158773321348230000004170107115889810343_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008870047804945533090000011244363647428860834_",
    id: "use2790",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2793",
    d: "M64.8 22v.8",
    clipPath: "url(#SVGID_00000109749158773321348230000004170107115889810343_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2807"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146460118496828747040000006950088411990664873_",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093861357824770438940000017636410680142085310_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146460118496828747040000006950088411990664873_",
    id: "use2802",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line2805",
    d: "M64.6 22v.8",
    clipPath: "url(#SVGID_00000093861357824770438940000017636410680142085310_)",
    style: {
      fill: "none"
    }
  })))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "path2813",
    d: "M65.7 22.6c-.5 0-1 0-1.3-.1.4-.1.8-.2 1.3-.2s1 .1 1.3.2c-.3 0-.8.1-1.3.1z",
    className: "st2"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "path2815",
    d: "M67.3 21.4c.1 0 0-.1 0 0-.1-.1-.1-.1 0 0-.1 0-.1.1 0 0 0 .1 0 .1 0 0",
    className: "st3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "path2817",
    d: "M67.3 21.4c.1 0 0-.1 0 0-.1-.1-.1-.1 0 0-.1 0-.1.1 0 0 0 .1 0 .1 0 0z",
    className: "st2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "path2819",
    d: "M66.3 21.2s0-.1 0 0c-.1-.1-.1-.1 0 0-.1 0-.1.1 0 0 0 .1 0 0 0 0",
    className: "st3"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "path2821",
    d: "M66.3 21.2s0-.1 0 0c-.1-.1-.1-.1 0 0-.1 0-.1.1 0 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "path2823",
    d: "M65.1 21.2s.1-.1 0 0c.1-.1.1-.1 0 0 .2 0 .1.1 0 0 .1.1.1 0 0 0",
    className: "st3"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "path2825",
    d: "M65.1 21.2s.1-.1 0 0c.1-.1.1-.1 0 0 .2 0 .1.1 0 0 .1.1.1 0 0 0z",
    className: "st2"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "path2827",
    d: "M64.1 21.4s0-.1 0 0c.1-.1.1-.1 0 0 .1 0 .1.1 0 0 .1.1 0 .1 0 0",
    className: "st3"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "path2829",
    d: "M64.1 21.4s0-.1 0 0c.1-.1.1-.1 0 0 .1 0 .1.1 0 0 .1.1 0 .1 0 0z",
    className: "st2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2831",
    d: "m65.9 20.7-.2-.1-.1.1.1.3h.1z",
    className: "st3"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2833",
    d: "m65.9 20.7-.2-.1-.1.1.1.3h.1z",
    className: "st2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2835",
    d: "m65.4 20.9-.1.1.1.2.3-.1V21z",
    className: "st3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2837",
    d: "m65.4 20.9-.1.1.1.2.3-.1V21z",
    className: "st2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2839",
    d: "m66 20.9.1.1-.1.2-.2-.1-.1-.1h.1z",
    className: "st3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2841",
    d: "m66 20.9.1.1-.1.2-.2-.1-.1-.1h.1z",
    className: "st2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2843",
    d: "m64.8 20.8-.2-.1-.2.2.2.2h.1z",
    className: "st3"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2845",
    d: "m64.8 20.8-.2-.1-.2.2.2.2h.1z",
    className: "st2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2847",
    d: "M64.3 21.1v.1l.1.1.2-.1.1-.1h-.1z",
    className: "st3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2849",
    d: "M64.3 21.1v.1l.1.1.2-.1.1-.1h-.1z",
    className: "st2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2851",
    d: "m64.9 20.9.1.2v.1h-.3v-.1z",
    className: "st3"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2853",
    d: "m64.9 20.9.1.2v.1h-.3v-.1z",
    className: "st2"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2855",
    d: "m63.9 21.2.1.1v.1h-.4z",
    className: "st3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2857",
    d: "m63.9 21.2.1.1v.1h-.4z",
    className: "st2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "path2859",
    d: "M64.6 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1-.1 0-.1-.1",
    className: "st3"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "path2861",
    d: "M64.6 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1-.1 0-.1-.1z",
    className: "st2"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2863",
    d: "m66.7 20.8.2-.1.2.2-.2.2h-.1z",
    className: "st3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2865",
    d: "m66.7 20.8.2-.1.2.2-.2.2h-.1z",
    className: "st2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2867",
    d: "M67.2 21.1v.1l-.1.1-.3-.1v-.1h.1z",
    className: "st3"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2869",
    d: "M67.2 21.1v.1l-.1.1-.3-.1v-.1h.1z",
    className: "st2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2871",
    d: "m66.5 20.9-.1.2.1.1h.3v-.1z",
    className: "st3"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2873",
    d: "m66.5 20.9-.1.2.1.1h.3v-.1z",
    className: "st2"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2875",
    d: "m67.6 21.2-.1.1v.1h.3z",
    className: "st3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2877",
    d: "m67.6 21.2-.1.1v.1h.3z",
    className: "st2"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M65.6 21c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1",
    className: "st3"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M65.6 21c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1z",
    className: "st2"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M66.7 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1",
    className: "st3"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M66.7 21.1c0-.1 0-.1.1-.1s.1 0 .1.1 0 .1-.1.1c0 0-.1 0-.1-.1z",
    className: "st2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M65.5 19.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st3"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2889",
    d: "M65.7 19.5h-.2v-.1h.2v-.1h.1v.1h.1v.1h-.1v.3h.1v.1h-.3v-.1h.1z",
    className: "st3"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "polygon2891",
    d: "M65.7 19.5h-.2v-.1h.2v-.1h.1v.1h.1v.1h-.1v.3h.1v.1h-.3v-.1h.1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2901"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116925196428824226640000002179459989870831797_",
    d: "M65.5 19.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170982744795452157700000005797241633396373378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116925196428824226640000002179459989870831797_",
    id: "use2896",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon2899",
    d: "M65.7 19.5h-.2v-.1h.2v-.1h.1v.1h.1v.1h-.1v.3h.2v.1h-.5v-.1h.2z",
    clipPath: "url(#SVGID_00000170982744795452157700000005797241633396373378_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2913"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173152582554639922220000012799422668919245954_",
    d: "M65.5 19.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162313169986496335020000009369544952114658235_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173152582554639922220000012799422668919245954_",
    id: "use2908",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon2911",
    d: "M65.7 19.5h-.2v-.1h.2v-.1h.1v.1h.1v.1h-.1v.3h.2v.1h-.5v-.1h.2z",
    clipPath: "url(#SVGID_00000162313169986496335020000009369544952114658235_)",
    style: {
      fill: "none"
    }
  })))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "path2919",
    d: "M65.8 19.7c.1 0 .1.1.1.2s-.1.2-.2.2-.2-.1-.2-.2.1-.2.1-.2",
    className: "st2"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "path2921",
    d: "M63.6 21.4s-.1-.1-.1-.2l-.1-.1.1-.1h.1s.1 0 .1.1c-.1.2-.1.3-.1.3",
    className: "st3"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "path2923",
    d: "M63.6 21.4s-.1-.1-.1-.2l-.1-.1.1-.1h.1s.1 0 .1.1c-.1.2-.1.3-.1.3z",
    className: "st2"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "path2925",
    d: "m63.6 21.4.1.1h-.1v-.1",
    className: "st3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "path2927",
    d: "m63.6 21.4.1.1h-.1z",
    className: "st2"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "path2929",
    d: "M67.8 21.4s.1-.1.1-.2l.1-.1-.1-.1h-.1l-.1.1c.1.2.1.3.1.3",
    className: "st3"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "path2931",
    d: "M67.8 21.4s.1-.1.1-.2l.1-.1-.1-.1h-.1l-.1.1c.1.2.1.3.1.3z",
    className: "st2"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "path2933",
    d: "m67.8 21.4-.1.1h.1c.1 0 .1-.1 0-.1",
    className: "st3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "path2935",
    d: "m67.8 21.4-.1.1h.1c.1 0 .1-.1 0-.1z",
    className: "st2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "rect2937",
    d: "M63.4 22.7h4.7V24h-4.7z",
    className: "st3"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "rect2939",
    d: "M63.4 22.7h4.7V24h-4.7z",
    className: "st2"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "path2941",
    d: "M67.6 24.8s-.1 0 0 0h-3.7c.1 0 .2-.2.2-.3 0-.1-.1-.3-.2-.3h3.7c-.1 0-.2.2-.2.3 0 .2.1.3.2.3",
    className: "st3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "path2943",
    d: "M67.6 24.8s-.1 0 0 0h-3.7c.1 0 .2-.2.2-.3 0-.1-.1-.3-.2-.3h3.7c-.1 0-.2.2-.2.3 0 .2.1.3.2.3z",
    className: "st2"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "path2945",
    d: "M64 24.8h3.5c.1 0 .2.1.2.2s-.1.2-.2.2H64c-.1 0-.2-.1-.2-.2s.1-.2.2-.2",
    className: "st3"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "path2947",
    d: "M64 24.8h3.5c.1 0 .2.1.2.2s-.1.2-.2.2H64c-.1 0-.2-.1-.2-.2s.1-.2.2-.2z",
    className: "st2"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "path2949",
    d: "M64 24h3.5c.1 0 .2.1.2.1 0 .1-.1.1-.2.1H64c-.1 0-.2-.1-.2-.1 0-.1.1-.1.2-.1",
    className: "st3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "path2951",
    d: "M64 24h3.5c.1 0 .2.1.2.1 0 .1-.1.1-.2.1H64c-.1 0-.2-.1-.2-.1 0-.1.1-.1.2-.1Z",
    className: "st2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "path2953",
    d: "M62.5 45.7c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v.5c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st15"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "path2955",
    d: "M62.5 45.7c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v.5c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st2"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "path2957",
    d: "M62.5 46.3c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v.5c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st16"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "path2959",
    d: "M62.5 46.3c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v.5c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "path2961",
    d: "M62.5 46.8c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v.5c-.3 0-.6-.1-.8-.2-.1-.1-.4-.1-.7-.1-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.3-.2-.6-.2-.9-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st15"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "path2963",
    d: "M62.5 46.8c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v.5c-.3 0-.6-.1-.8-.2-.1-.1-.4-.1-.7-.1-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.3-.2-.6-.2-.9-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st2"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "path2965",
    d: "M62.5 47.9c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v-.5c-.3 0-.6-.1-.8-.2-.1-.2-.4-.2-.7-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.3-.2-.6-.2-.9-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st16"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "path2967",
    d: "M62.5 47.9c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v-.5c-.3 0-.6-.1-.8-.2-.1-.2-.4-.2-.7-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.3-.2-.6-.2-.9-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st2"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "path2969",
    d: "M62.5 48.4c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v-.5c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st15"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "path2971",
    d: "M62.5 48.4c.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2.3 0 .6-.1.8-.2.2-.1.5-.2.8-.2.3 0 .6.1.8.2.2.1.5.2.8.2v-.5c-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2-.3 0-.6-.1-.8-.2-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.2.1-.5.2-.8.2z",
    className: "st2"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "path2973",
    d: "M67.6 43.5c0 .4.3.7.6.7h-4.8c.3 0 .6-.3.6-.6v-.1h3.6c-.1 0 0 0 0 0",
    className: "st3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "path2975",
    d: "M67.6 43.5c0 .4.3.7.6.7h-4.8c.3 0 .6-.3.6-.6v-.1h3.6c-.1 0 0 0 0 0z",
    className: "st2"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "path2977",
    d: "M64 43.2h3.5c.1 0 .2.1.2.2s-.1.2-.2.2H64c-.1 0-.2-.1-.2-.2s.1-.2.2-.2",
    className: "st3"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "path2979",
    d: "M64 43.2h3.5c.1 0 .2.1.2.2s-.1.2-.2.2H64c-.1 0-.2-.1-.2-.2s.1-.2.2-.2z",
    className: "st2"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "rect2981",
    d: "M63.3 44.3h4.8v1.3h-4.8z",
    className: "st3"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "rect2983",
    d: "M63.3 44.3h4.8v1.3h-4.8z",
    className: "st2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "path2985",
    d: "M68.5 38.6c.5.3.8.6.7.7 0 .1-.2.2-.4.4-.3.3-.5.7-.4.9-.3-.2-.5-.6-.5-1 .1-.4.3-.7.6-1",
    className: "st1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "path2987",
    d: "M68.5 38.6c.5.3.8.6.7.7 0 .1-.2.2-.4.4-.3.3-.5.7-.4.9-.3-.2-.5-.6-.5-1 .1-.4.3-.7.6-1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3004"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g2990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000039097585427989156210000006411525779519420038_",
    d: "M64 25.4h3.4V43H64z",
    className: "st16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3000"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", {
    id: "defs2993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000176737483044172879240000010565873870780137383_",
    d: "M64 25.4h3.4V43H64z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147216389921352918320000009610844900082219953_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176737483044172879240000010565873870780137383_",
    id: "use2995",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2998",
    d: "M66.9 24.9v18.6m-.4-18.6v18.6",
    clipPath: "url(#SVGID_00000147216389921352918320000009610844900082219953_)",
    style: {
      fill: "none"
    }
  })))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "rect3006",
    d: "M64 25.4h3.4V43H64z",
    className: "st2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "path3008",
    d: "M60.6 32c.7-.3 2-.6 3.5-.6.5 0 1.1.1 1.6.2 2 .4 3.6 1.2 3.5 1.9v.1s.8-1.8.8-1.9c.1-.8-1.6-1.7-3.9-2.1-.7-.1-1.4-.2-2-.2-1.4 0-2.7.2-3.5.5z",
    className: "st1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    d: "M60.6 32c.7-.3 2-.6 3.5-.6.5 0 1.1.1 1.6.2 2 .4 3.6 1.2 3.5 1.9v.1s.8-1.8.8-1.9c.1-.8-1.6-1.7-3.9-2.1-.7-.1-1.4-.2-2-.2-1.4 0-2.7.2-3.5.5z",
    className: "st2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "path3012",
    d: "M67.5 34.2c.9-.1 1.6-.3 1.7-.8.1-.3-.3-.7-.8-1-.3 0-.5.1-.8.1z",
    className: "st1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    d: "M67.5 34.2c.9-.1 1.6-.3 1.7-.8.1-.3-.3-.7-.8-1-.3 0-.5.1-.8.1z",
    className: "st2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "path3016",
    d: "M64 32.8c-.6.1-1 .2-1.3.4-.1.2.4.7 1.3 1.3z",
    className: "st1"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    d: "M64 32.8c-.6.1-1 .2-1.3.4-.1.2.4.7 1.3 1.3z",
    className: "st2"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "path3020",
    d: "M69.6 37.6c.1-.3-.8-.9-2.1-1.4-.6-.2-1.1-.5-1.7-.7-1.8-.8-3.1-1.8-3-2.2-.1.1-.2 1.8-.2 1.8-.2.3 1.1 1.3 2.7 2.1.5.3 1.7.7 2.2.9 1 .3 1.9 1 1.8 1.3z",
    className: "st1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    d: "M69.6 37.6c.1-.3-.8-.9-2.1-1.4-.6-.2-1.1-.5-1.7-.7-1.8-.8-3.1-1.8-3-2.2-.1.1-.2 1.8-.2 1.8-.2.3 1.1 1.3 2.7 2.1.5.3 1.7.7 2.2.9 1 .3 1.9 1 1.8 1.3z",
    className: "st2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "path3024",
    d: "M62.7 31.2c.1-.5.3-1 .5-1.5H63c-.1.4-.2.7-.3 1.1-.2-.3-.4-.6-.6-1h-.4c.3.4.6.9.9 1.3h.1c-.1.1 0 .1 0 .1",
    className: "st3"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "path3026",
    d: "M64 29.7h-.4v1.4h.9v-.2h-.6z",
    className: "st3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "path3028",
    d: "M65.5 29.9c.2 0 .3 0 .4.1v-.2l-1.3-.1v.2h.5l-.1 1.2h.4z",
    className: "st3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "path3030",
    d: "M66.7 30.1c.1 0 .3.1.3.2v.1c0 .2-.2.3-.4.2zm-.7 1.2h.2c.1 0 .1 0 .2.1l.1-.7c0 .1.1.2.1.3l.2.5h.2c.1 0 .1 0 .2.1l-.1-.1c-.1-.2-.2-.4-.3-.7.2 0 .4-.1.5-.3 0-.1 0-.2-.1-.3-.1-.1-.3-.1-.4-.1l-.5-.1Z",
    className: "st3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "path3032",
    d: "m68 31.4.4-.3-.1.5zm.4.3c0 .2 0 .3-.1.5.1 0 .1.1.2.1s.1.1.2.1l.1-1.6h-.1s-.1 0-.1-.1l-1.3.9s.1 0 .1.1c0 0 .1 0 .1.1.1-.1.2-.2.4-.3z",
    className: "st3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "path3034",
    d: "M44.8 16.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5z",
    className: "st2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "path3036",
    d: "M50 13c1.4 0 2.6.2 3.4.6.5.2 1.1.4 1.8.5.5.1 1 .1 1.4.1.6 0 1.4.2 2.2.6.7.3 1.3.7 1.6 1.1l-.3.1-.1.9-.9 1.1-.5.4-1.1.9H57l-.2.5L50 19l-6.9.9-.2-.5h-.5l-1.1-.9-.4-.5-.9-1.1-.1-.9-.3-.3c.4-.4 1-.8 1.6-1.1.8-.4 1.7-.6 2.2-.6.4 0 .9 0 1.4-.1.7-.1 1.3-.3 1.8-.5.8-.2 2-.4 3.4-.4",
    className: "st1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "path3038",
    d: "M50 13c1.4 0 2.6.2 3.4.6.5.2 1.1.4 1.8.5.5.1 1 .1 1.4.1.6 0 1.4.2 2.2.6.7.3 1.3.7 1.6 1.1l-.3.1-.1.9-.9 1.1-.5.4-1.1.9H57l-.2.5L50 19l-6.9.9-.2-.5h-.5l-1.1-.9-.4-.5-.9-1.1-.1-.9-.3-.3c.4-.4 1-.8 1.6-1.1.8-.4 1.7-.6 2.2-.6.4 0 .9 0 1.4-.1.7-.1 1.3-.3 1.8-.5.8-.2 2-.4 3.4-.4z",
    className: "st2"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "path3040",
    d: "M50.1 20.4c-2.6 0-4.9.3-6.6.9.1-.1.1-.2 0-.7-.3-.6-.6-.6-.6-.6 1.8-.6 4.4-.9 7.2-.9s5.4.4 7.2.9c0 0-.3 0-.5.5s-.2.6 0 .7c-1.8-.5-4.1-.8-6.7-.8",
    className: "st3"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "path3042",
    d: "M50.1 20.4c-2.6 0-4.9.3-6.6.9.1-.1.1-.2 0-.7-.3-.6-.6-.6-.6-.6 1.8-.6 4.4-.9 7.2-.9s5.4.4 7.2.9c0 0-.3 0-.5.5s-.2.6 0 .7c-1.8-.5-4.1-.8-6.7-.8z",
    className: "st2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "path3044",
    d: "M50.1 19.1c-2.8 0-5.3.4-7.2.9-.1 0-.2 0-.3-.1 0-.1 0-.3.1-.3 1.8-.6 4.4-1 7.3-1 2.9 0 5.5.4 7.3 1 .1 0 .2.2.1.3 0 .1-.2.2-.3.1-1.7-.6-4.2-.9-7-.9",
    className: "st3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "path3046",
    d: "M50.1 19.1c-2.8 0-5.3.4-7.2.9-.1 0-.2 0-.3-.1 0-.1 0-.3.1-.3 1.8-.6 4.4-1 7.3-1 2.9 0 5.5.4 7.3 1 .1 0 .2.2.1.3 0 .1-.2.2-.3.1-1.7-.6-4.2-.9-7-.9z",
    className: "st2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "path3048",
    d: "M50.1 22.6c-2.6 0-4.9-.3-6.5-.8-.1 0-.2-.2-.2-.3 0-.1.1-.2.2-.3 1.6-.5 4-.8 6.5-.8 2.6 0 4.9.3 6.5.8.1 0 .2.1.2.3 0 .1-.1.2-.2.3-1.7.5-4 .8-6.5.8",
    className: "st3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "path3050",
    d: "M50.1 22.6c-2.6 0-4.9-.3-6.5-.8-.1 0-.2-.2-.2-.3 0-.1.1-.2.2-.3 1.6-.5 4-.8 6.5-.8 2.6 0 4.9.3 6.5.8.1 0 .2.1.2.3 0 .1-.1.2-.2.3-1.7.5-4 .8-6.5.8z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3271"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g3053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000053516319536455474000000013804709825051265711_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3063"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020362516280926588360000014127110348493148316_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121256825190600157670000015108239227235259061_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020362516280926588360000014127110348493148316_",
    id: "use3058",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3061",
    d: "M50.1 20.5v2.9",
    clipPath: "url(#SVGID_00000121256825190600157670000015108239227235259061_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3075"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044865730824388605210000017371050025240117896_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026128690762465773250000005524975318498569140_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044865730824388605210000017371050025240117896_",
    id: "use3070",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3073",
    d: "M49.7 20.5v2.9",
    clipPath: "url(#SVGID_00000026128690762465773250000005524975318498569140_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3087"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139291290113596948000000012817825179582579594_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099663459192148381210000012255861526031867803_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139291290113596948000000012817825179582579594_",
    id: "use3082",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3085",
    d: "M49.4 20.5v2.9",
    clipPath: "url(#SVGID_00000099663459192148381210000012255861526031867803_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3099"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020367313501893742440000005235993245419023267_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075131006688878153980000017058680534340549550_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020367313501893742440000005235993245419023267_",
    id: "use3094",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3097",
    d: "M49.1 20.5v2.9",
    clipPath: "url(#SVGID_00000075131006688878153980000017058680534340549550_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3111"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067213565037401415010000010282640046852957108_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075855214643256615990000011699641297653927084_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067213565037401415010000010282640046852957108_",
    id: "use3106",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3109",
    d: "M48.7 20.5v2.9",
    clipPath: "url(#SVGID_00000075855214643256615990000011699641297653927084_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3123"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119816561772999977530000000476220795184138899_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111180552899859678520000006210726306490418839_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119816561772999977530000000476220795184138899_",
    id: "use3118",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3121",
    d: "M48.2 20.5v2.9m.2-2.9v2.9",
    clipPath: "url(#SVGID_00000111180552899859678520000006210726306490418839_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3135"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000176725491914740157640000000117069755419716750_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114063562992083921980000000187468628225903494_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176725491914740157640000000117069755419716750_",
    id: "use3130",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3133",
    d: "M47.6 20.5v2.9m.3-2.9v2.9",
    clipPath: "url(#SVGID_00000114063562992083921980000000187468628225903494_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3147"
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000167393216936344095530000003105814986729019034_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092434711599576965760000002458111437502026645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167393216936344095530000003105814986729019034_",
    id: "use3142",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3145",
    d: "M46.9 20.5v2.9m.3-2.9v2.9m.2-2.9v2.9",
    clipPath: "url(#SVGID_00000092434711599576965760000002458111437502026645_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3159"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000120556394797261146480000017761985270295036315_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065059793836633099200000004352683662193326256_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120556394797261146480000017761985270295036315_",
    id: "use3154",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3157",
    d: "M46.7 20.5v2.9",
    clipPath: "url(#SVGID_00000065059793836633099200000004352683662193326256_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3171"
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062914253362325862550000013975265086479359911_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166655591341232824850000001167337020754529456_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062914253362325862550000013975265086479359911_",
    id: "use3166",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3169",
    d: "M46.4 20.5v2.9",
    clipPath: "url(#SVGID_00000166655591341232824850000001167337020754529456_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3183"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000061431110177976922170000009700817798789179830_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052066465847922998020000003711702108404107426_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061431110177976922170000009700817798789179830_",
    id: "use3178",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3181",
    d: "M46.2 20.5v2.9",
    clipPath: "url(#SVGID_00000052066465847922998020000003711702108404107426_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3195"
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054982773491427139880000006891091935296313255_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005229695840327633450000011553640544838751417_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054982773491427139880000006891091935296313255_",
    id: "use3190",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3193",
    d: "M45.7 20.5v2.9m.2-2.9v2.9",
    clipPath: "url(#SVGID_00000005229695840327633450000011553640544838751417_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3207"
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000025434867816612881020000018173416816155668624_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132051870817308187060000009592086324475271318_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025434867816612881020000018173416816155668624_",
    id: "use3202",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3205",
    d: "M45.4 20.5v2.9",
    clipPath: "url(#SVGID_00000132051870817308187060000009592086324475271318_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3219"
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114795182089435618380000000581068035059272608_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119096652338976741910000011586873953959325830_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114795182089435618380000000581068035059272608_",
    id: "use3214",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3217",
    d: "M45.1 20.4v3",
    clipPath: "url(#SVGID_00000119096652338976741910000011586873953959325830_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3231"
  }, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000107559987661810615130000001768723625748021933_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052820964140049745040000012397614708384433808_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107559987661810615130000001768723625748021933_",
    id: "use3226",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3229",
    d: "M44.9 20.4v3",
    clipPath: "url(#SVGID_00000052820964140049745040000012397614708384433808_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3243"
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031172027807994315990000012254167244675164829_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160907673328176043790000000089420833072675751_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031172027807994315990000012254167244675164829_",
    id: "use3238",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3241",
    d: "M44.6 20.4v3",
    clipPath: "url(#SVGID_00000160907673328176043790000000089420833072675751_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3255"
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000171696939692101207920000012028445142604193426_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100376826944230254210000014755693355512804003_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171696939692101207920000012028445142604193426_",
    id: "use3250",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line3253",
    d: "M44.4 20.4v3",
    clipPath: "url(#SVGID_00000100376826944230254210000014755693355512804003_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3267"
  }, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128456825592522759680000010790941123104466323_",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170275446914332454780000007914462758570857616_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128456825592522759680000010790941123104466323_",
    id: "use3262",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3265",
    d: "M51.6 20.5v2.9m-.7-2.9v2.9m-.4-2.9v2.9",
    clipPath: "url(#SVGID_00000170275446914332454780000007914462758570857616_)",
    style: {
      fill: "none"
    }
  })))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "path3273",
    d: "M50.1 22.2c-2.3 0-4.4-.3-6-.7 1.6-.4 3.7-.7 6-.7s4.4.3 6 .7c-1.6.4-3.7.7-6 .7z",
    className: "st2"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "path3275",
    d: "M48.1 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "path3277",
    d: "M48.1 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "path3279",
    d: "M50.1 19.9h-.7c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h1.4c.1 0 .2.1.2.2s-.1.2-.2.2z",
    className: "st1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "path3281",
    d: "M50.1 19.9h-.7c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h1.4c.1 0 .2.1.2.2s-.1.2-.2.2z",
    className: "st2"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "path3283",
    d: "m46.6 20.1-.5.1c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3l.5-.1.5-.1c.1 0 .2.1.3.2 0 .1-.1.2-.2.3z",
    className: "st7"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "path3285",
    d: "m46.6 20.1-.5.1c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3l.5-.1.5-.1c.1 0 .2.1.3.2 0 .1-.1.2-.2.3z",
    className: "st2"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "path3287",
    d: "M44.6 20.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "path3289",
    d: "M44.6 20.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3291",
    d: "m43.3 20.2.7.1-.5.5-.4-.2z",
    className: "st1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3293",
    d: "m43.3 20.2.7.1-.5.5-.4-.2z",
    className: "st2"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "path3295",
    d: "m53.5 20.1.5.1c.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3l-.5-.1-.5-.1c-.1 0-.2.1-.3.2 0 .1.1.2.2.3z",
    className: "st7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "path3297",
    d: "m53.5 20.1.5.1c.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3l-.5-.1-.5-.1c-.1 0-.2.1-.3.2 0 .1.1.2.2.3z",
    className: "st2"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "path3299",
    d: "M51.6 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "path3301",
    d: "M51.6 19.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "path3303",
    d: "M55.1 20.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "path3305",
    d: "M55.1 20.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3307",
    d: "m56.8 20.2-.7.1.6.5.4-.2z",
    className: "st1"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3309",
    d: "m56.8 20.2-.7.1.6.5.4-.2z",
    className: "st2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "path3311",
    d: "M43.8 21.6c1.6-.5 3.8-.8 6.3-.8s4.7.3 6.3.8",
    className: "st2"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "path3313",
    d: "m44.9 14.9.3.2.4-.8c-.5-.3-.8-.8-.8-1.4v-.2c0-1 1.2-1.8 2.6-1.8.7 0 1.4.2 1.9.5V11c-.5-.3-1.2-.5-1.9-.5-1.6 0-2.9 1-2.9 2.1v.2c0 .6.3 1.2.7 1.5z",
    className: "st3"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "path3315",
    d: "m44.9 14.9.3.2.4-.8c-.5-.3-.8-.8-.8-1.4v-.2c0-1 1.2-1.8 2.6-1.8.7 0 1.4.2 1.9.5V11c-.5-.3-1.2-.5-1.9-.5-1.6 0-2.9 1-2.9 2.1v.2c0 .6.3 1.2.7 1.5z",
    className: "st2"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "path3317",
    d: "M44.9 14.9c-.6-.4-.9-1-.9-1.7s.5-1.4 1.2-1.9c-.4.4-.7.8-.7 1.4v.2c0 .6.3 1.2.7 1.5z",
    className: "st3"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "path3319",
    d: "M44.9 14.9c-.6-.4-.9-1-.9-1.7s.5-1.4 1.2-1.9c-.4.4-.7.8-.7 1.4v.2c0 .6.3 1.2.7 1.5z",
    className: "st2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "path3321",
    d: "M40 15.7c-.3-.4-.5-.8-.5-1.4 0-.3.1-.6.2-.9.4-1 1.8-1.7 3.5-1.7.5 0 .9.1 1.3.1-.1.1-.2.2-.2.3-.3-.1-.7-.1-1.1-.1-1.5 0-2.8.6-3.2 1.5-.1.2-.2.5-.2.7 0 .5.2 1 .6 1.3l-.6 1-.3-.2z",
    className: "st3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "path3323",
    d: "M40 15.7c-.3-.4-.5-.8-.5-1.4 0-.3.1-.6.2-.9.4-1 1.8-1.7 3.5-1.7.5 0 .9.1 1.3.1-.1.1-.2.2-.2.3-.3-.1-.7-.1-1.1-.1-1.5 0-2.8.6-3.2 1.5-.1.2-.2.5-.2.7 0 .5.2 1 .6 1.3l-.6 1-.3-.2z",
    className: "st2"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "path3325",
    d: "M40.6 12.5c-.4.3-.7.6-.9 1-.1.3-.2.6-.2.9 0 .5.2 1 .5 1.4l-.3.6c-.3-.4-.5-.9-.5-1.5 0-1.1.5-1.9 1.4-2.4",
    className: "st3"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "path3327",
    d: "M40.6 12.5c-.4.3-.7.6-.9 1-.1.3-.2.6-.2.9 0 .5.2 1 .5 1.4l-.3.6c-.3-.4-.5-.9-.5-1.5 0-1.1.5-1.9 1.4-2.4z",
    className: "st2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "path3329",
    d: "M50 10.4c.4 0 .7.3.8.6.1.3.1.7.1 1v.2c0 .8.1 1.5.3 1.9L50 15.3l-1.1-1.1c.2-.4.3-1.1.3-1.9v-.2c0-.4 0-.7.1-1 0-.4.4-.7.7-.7",
    className: "st3"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "path3331",
    d: "M50 10.4c.4 0 .7.3.8.6.1.3.1.7.1 1v.2c0 .8.1 1.5.3 1.9L50 15.3l-1.1-1.1c.2-.4.3-1.1.3-1.9v-.2c0-.4 0-.7.1-1 0-.4.4-.7.7-.7z",
    className: "st2"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "path3333",
    d: "M50 10.8c.2 0 .4.1.4.3 0 .3.1.6.1 1v.2c0 .7.1 1.4.3 1.8l-.8.7-.7-.7c.1-.4.2-1 .3-1.8v-.2c0-.3 0-.7.1-1 0-.2.2-.3.3-.3",
    className: "st3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "path3335",
    d: "M50 10.8c.2 0 .4.1.4.3 0 .3.1.6.1 1v.2c0 .7.1 1.4.3 1.8l-.8.7-.7-.7c.1-.4.2-1 .3-1.8v-.2c0-.3 0-.7.1-1 0-.2.2-.3.3-.3z",
    className: "st2"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "path3337",
    d: "m55.2 14.9-.3.2-.4-.8c.5-.3.8-.8.8-1.4v-.2c0-1-1.2-1.8-2.6-1.8-.7 0-1.4.2-1.9.5V11c.5-.3 1.2-.5 1.9-.5 1.6 0 2.9 1 2.9 2.1v.2c0 .6-.3 1.2-.7 1.5z",
    className: "st3"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "path3339",
    d: "m55.2 14.9-.3.2-.4-.8c.5-.3.8-.8.8-1.4v-.2c0-1-1.2-1.8-2.6-1.8-.7 0-1.4.2-1.9.5V11c.5-.3 1.2-.5 1.9-.5 1.6 0 2.9 1 2.9 2.1v.2c0 .6-.3 1.2-.7 1.5z",
    className: "st2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "path3341",
    d: "M55.2 14.9c.6-.4.9-1 .9-1.7s-.5-1.4-1.2-1.9c.4.4.7.8.7 1.4v.2c0 .6-.3 1.2-.7 1.5z",
    className: "st3"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "path3343",
    d: "M55.2 14.9c.6-.4.9-1 .9-1.7s-.5-1.4-1.2-1.9c.4.4.7.8.7 1.4v.2c0 .6-.3 1.2-.7 1.5z",
    className: "st2"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "path3345",
    d: "M60.1 15.7c.3-.4.5-.8.5-1.4 0-.3-.1-.6-.2-.9-.4-1-1.8-1.7-3.5-1.7-.5 0-.9.1-1.3.1.1.1.2.2.2.3.3-.1.7-.1 1.1-.1 1.5 0 2.8.6 3.2 1.5.1.2.2.5.2.7 0 .5-.2 1-.6 1.3l.6 1 .3-.2z",
    className: "st3"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "path3347",
    d: "M60.1 15.7c.3-.4.5-.8.5-1.4 0-.3-.1-.6-.2-.9-.4-1-1.8-1.7-3.5-1.7-.5 0-.9.1-1.3.1.1.1.2.2.2.3.3-.1.7-.1 1.1-.1 1.5 0 2.8.6 3.2 1.5.1.2.2.5.2.7 0 .5-.2 1-.6 1.3l.6 1 .3-.2z",
    className: "st2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "path3349",
    d: "M59.5 12.5c.4.3.7.6.9 1 .1.3.2.6.2.9 0 .5-.2 1-.5 1.4l.3.6c.3-.4.5-.9.5-1.5 0-1.1-.5-1.9-1.4-2.4",
    className: "st3"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "path3351",
    d: "M59.5 12.5c.4.3.7.6.9 1 .1.3.2.6.2.9 0 .5-.2 1-.5 1.4l.3.6c.3-.4.5-.9.5-1.5 0-1.1-.5-1.9-1.4-2.4z",
    className: "st2"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "line3353",
    d: "M50.1 13.9",
    className: "st2"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "path3355",
    d: "M49.7 14.3c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4c-.3 0-.4-.1-.4-.4",
    className: "st6"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "path3357",
    d: "M49.7 14.3c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4c-.3 0-.4-.1-.4-.4z",
    className: "st2"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "path3359",
    d: "M49.7 13.6c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4c-.3 0-.4-.2-.4-.4",
    className: "st6"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "path3361",
    d: "M49.7 13.6c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4c-.3 0-.4-.2-.4-.4z",
    className: "st2"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "path3363",
    d: "M49.7 12.7c0-.2.1-.3.3-.3.2 0 .3.1.3.3 0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3",
    className: "st6"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "path3365",
    d: "M49.7 12.7c0-.2.1-.3.3-.3.2 0 .3.1.3.3 0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3z",
    className: "st2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "path3367",
    d: "M49.8 12c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "path3369",
    d: "M49.8 12c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "path3371",
    d: "M49.9 11.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.2 0-.2-.1-.2-.2",
    className: "st6"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "path3373",
    d: "M49.9 11.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.2 0-.2-.1-.2-.2z",
    className: "st2"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "path3375",
    d: "M50.1 16.7h.3v.4c0 .6.5 1 1 1s.8-.3 1-.7l.1-.4v.4c.1.5.5.9 1 .9.6 0 1-.5 1-1v-.1l.3-.3.2.4c-.1.1-.1.3-.1.4 0 .5.4 1 1 1 .3 0 .6-.2.8-.4l.2-.3v.3c0 .3.1.6.5.7 0 0 .4 0 .8-.4.5-.3.8-.6.8-.6v.4s-.4.7-.8.9c-.2.1-.6.3-.9.3-.3-.1-.5-.3-.6-.6-.2.1-.5.2-.7.2-.6 0-1.1-.3-1.3-.9-.3.3-.6.5-1.1.5-.5 0-.9-.2-1.2-.6-.3.3-.6.4-1 .4-.5 0-1-.3-1.2-.7-.3.4-.7.7-1.2.7-.4 0-.8-.2-1-.4-.3.3-.7.6-1.2.6-.4 0-.8-.2-1.1-.5-.2.5-.7.9-1.3.9-.3 0-.5-.1-.7-.2-.1.3-.3.6-.6.6s-.6-.1-.9-.3c-.4-.3-.8-.9-.8-.9V18l.7.7c.5.4.8.4.8.4.3-.1.5-.4.5-.7v-.3l.2.3c.2.3.5.4.8.4.5 0 1-.4 1-1 0-.2 0-.3-.1-.4l.2-.4.3.3v.1c0 .6.5 1 1 1s1-.4 1-.9v-.4l.1.4c.1.4.5.7 1 .7.6 0 1-.5 1-1 0-.1 0-.2-.1-.4z",
    className: "st3"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "path3377",
    d: "M50.1 16.7h.3v.4c0 .6.5 1 1 1s.8-.3 1-.7l.1-.4v.4c.1.5.5.9 1 .9.6 0 1-.5 1-1v-.1l.3-.3.2.4c-.1.1-.1.3-.1.4 0 .5.4 1 1 1 .3 0 .6-.2.8-.4l.2-.3v.3c0 .3.1.6.5.7 0 0 .4 0 .8-.4.5-.3.8-.6.8-.6v.4s-.4.7-.8.9c-.2.1-.6.3-.9.3-.3-.1-.5-.3-.6-.6-.2.1-.5.2-.7.2-.6 0-1.1-.3-1.3-.9-.3.3-.6.5-1.1.5-.5 0-.9-.2-1.2-.6-.3.3-.6.4-1 .4-.5 0-1-.3-1.2-.7-.3.4-.7.7-1.2.7-.4 0-.8-.2-1-.4-.3.3-.7.6-1.2.6-.4 0-.8-.2-1.1-.5-.2.5-.7.9-1.3.9-.3 0-.5-.1-.7-.2-.1.3-.3.6-.6.6s-.6-.1-.9-.3c-.4-.3-.8-.9-.8-.9V18l.7.7c.5.4.8.4.8.4.3-.1.5-.4.5-.7v-.3l.2.3c.2.3.5.4.8.4.5 0 1-.4 1-1 0-.2 0-.3-.1-.4l.2-.4.3.3v.1c0 .6.5 1 1 1s1-.4 1-.9v-.4l.1.4c.1.4.5.7 1 .7.6 0 1-.5 1-1 0-.1 0-.2-.1-.4z",
    className: "st2"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "path3379",
    d: "M57.2 18.1c.1-.2 0-.4-.1-.4s-.3.1-.3.3c-.1.2 0 .4.1.4s.2-.1.3-.3",
    className: "st6"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "path3381",
    d: "M57.2 18.1c.1-.2 0-.4-.1-.4s-.3.1-.3.3c-.1.2 0 .4.1.4s.2-.1.3-.3z",
    className: "st2"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "path3383",
    d: "M52.7 17.2c0-.2-.1-.4-.2-.4s-.3.1-.3.3c0 .2.1.4.2.4s.3-.1.3-.3",
    className: "st6"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "path3385",
    d: "M52.7 17.2c0-.2-.1-.4-.2-.4s-.3.1-.3.3c0 .2.1.4.2.4s.3-.1.3-.3z",
    className: "st2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "path3387",
    d: "M47.5 17.2c0-.2.1-.4.2-.4s.3.1.3.3c0 .2-.1.4-.2.4-.2 0-.3-.1-.3-.3",
    className: "st6"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "path3389",
    d: "M47.5 17.2c0-.2.1-.4.2-.4s.3.1.3.3c0 .2-.1.4-.2.4-.2 0-.3-.1-.3-.3z",
    className: "st2"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "path3391",
    d: "M43 18.1c-.1-.2 0-.4.1-.4s.3.1.3.3c.1.2 0 .4-.1.4s-.2-.1-.3-.3",
    className: "st6"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "path3393",
    d: "M43 18.1c-.1-.2 0-.4.1-.4s.3.1.3.3c.1.2 0 .4-.1.4s-.2-.1-.3-.3z",
    className: "st2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "path3395",
    d: "M44.9 14.9c.2.1.4.4.5.7 0 0 0-.1.1-.1.1-.1.2-.1.2-.1s0 .2-.1.3c0 .1 0 .3-.1.5 0 .2-.1.4-.1.4-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.2l-.3-.3c-.1-.2-.2-.4-.2-.5 0-.1-.2-.3-.2-.3h.2c.1 0 .2.1.2.1.2-.2.3-.5.4-.8",
    className: "st3"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "path3397",
    d: "M44.9 14.9c.2.1.4.4.5.7 0 0 0-.1.1-.1.1-.1.2-.1.2-.1s0 .2-.1.3c0 .1 0 .3-.1.5 0 .2-.1.4-.1.4-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.2l-.3-.3c-.1-.2-.2-.4-.2-.5 0-.1-.2-.3-.2-.3h.2c.1 0 .2.1.2.1.2-.2.3-.5.4-.8z",
    className: "st2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "path3399",
    d: "M45 17.2c-.1-.1-.1-.1-.1-.2v-.3l-.4-.2h-.7l.1.1c.1.1.1.2.1.2-.3.1-.5.3-.6.5.2.2.5.2.8.2V17.8s.1-.1.2-.1.3-.1.5-.2c0-.1.1-.3.1-.3",
    className: "st3"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "path3401",
    d: "M45 17.2c-.1-.1-.1-.1-.1-.2v-.3l-.4-.2h-.7l.1.1c.1.1.1.2.1.2-.3.1-.5.3-.6.5.2.2.5.2.8.2V17.8s.1-.1.2-.1.3-.1.5-.2c0-.1.1-.3.1-.3z",
    className: "st2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "path3403",
    d: "M45.6 17.1c0-.1.1-.2.1-.3 0-.1-.1-.2-.1-.2s.1-.2.3-.3c.1-.1.4-.2.5-.2.1 0 .2-.1.2-.1V16.3c.3 0 .5.1.8.2-.1.2-.4.4-.6.5 0 0 0 .1.1.2 0 .1.1.1.1.1h-.7c-.5-.1-.7-.2-.7-.2",
    className: "st3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "path3405",
    d: "M45.6 17.1c0-.1.1-.2.1-.3 0-.1-.1-.2-.1-.2s.1-.2.3-.3c.1-.1.4-.2.5-.2.1 0 .2-.1.2-.1V16.3c.3 0 .5.1.8.2-.1.2-.4.4-.6.5 0 0 0 .1.1.2 0 .1.1.1.1.1h-.7c-.5-.1-.7-.2-.7-.2z",
    className: "st2"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "path3407",
    d: "M44.8 16.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5",
    className: "st1"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "path3409",
    d: "M44.8 16.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5z",
    className: "st2"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "path3411",
    d: "M50.1 14.2c.2.2.4.5.4.8 0 0 0-.1.2-.1.2-.1.3 0 .3 0s-.1.2-.1.3c0 .1-.1.3-.2.6l-.2.4c-.1-.1-.2-.2-.3-.2-.1 0-.3.1-.4.2l-.2-.4c-.1-.2-.1-.5-.2-.6 0-.1-.1-.3-.1-.3h.3l.2.1c-.1-.3 0-.6.3-.8",
    className: "st3"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "path3413",
    d: "M50.1 14.2c.2.2.4.5.4.8 0 0 0-.1.2-.1.2-.1.3 0 .3 0s-.1.2-.1.3c0 .1-.1.3-.2.6l-.2.4c-.1-.1-.2-.2-.3-.2-.1 0-.3.1-.4.2l-.2-.4c-.1-.2-.1-.5-.2-.6 0-.1-.1-.3-.1-.3h.3l.2.1c-.1-.3 0-.6.3-.8z",
    className: "st2"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "path3415",
    d: "M49.7 16.8c-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3l-.4-.2c-.2-.1-.5-.1-.5-.1-.1 0-.3-.1-.3-.1v.1c0 .1.1.2.1.2-.3 0-.6.2-.8.4.2.2.5.4.8.4 0 0 0 .1-.1.2v.1s.2 0 .3-.1c.1 0 .4-.1.5-.1l.4-.2",
    className: "st3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "path3417",
    d: "M49.7 16.8c-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3l-.4-.2c-.2-.1-.5-.1-.5-.1-.1 0-.3-.1-.3-.1v.1c0 .1.1.2.1.2-.3 0-.6.2-.8.4.2.2.5.4.8.4 0 0 0 .1-.1.2v.1s.2 0 .3-.1c.1 0 .4-.1.5-.1l.4-.2z",
    className: "st2"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "path3419",
    d: "M50.4 16.8c.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3l.4-.2c.2-.1.5-.1.5-.1.1 0 .3-.1.3-.1v.1c0 .1-.1.2-.1.2.3 0 .6.2.8.4-.2.2-.5.4-.8.4 0 0 0 .1.1.2v.1s-.2 0-.3-.1c-.1 0-.4-.1-.5-.1l-.4-.2",
    className: "st3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "path3421",
    d: "M50.4 16.8c.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3l.4-.2c.2-.1.5-.1.5-.1.1 0 .3-.1.3-.1v.1c0 .1-.1.2-.1.2.3 0 .6.2.8.4-.2.2-.5.4-.8.4 0 0 0 .1.1.2v.1s-.2 0-.3-.1c-.1 0-.4-.1-.5-.1l-.4-.2z",
    className: "st2"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "path3423",
    d: "M55.2 14.9c-.2.1-.4.4-.5.7 0 0 0-.1-.1-.1-.1-.1-.2-.1-.2-.1s0 .2.1.3c0 .1 0 .3.1.5 0 .2.1.4.1.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2l.3-.3c.1-.2.2-.4.2-.5 0-.1.1-.3.1-.3h-.2c-.1 0-.2.1-.2.1 0-.2-.1-.5-.3-.8",
    className: "st3"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "path3425",
    d: "M55.2 14.9c-.2.1-.4.4-.5.7 0 0 0-.1-.1-.1-.1-.1-.2-.1-.2-.1s0 .2.1.3c0 .1 0 .3.1.5 0 .2.1.4.1.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2l.3-.3c.1-.2.2-.4.2-.5 0-.1.1-.3.1-.3h-.2c-.1 0-.2.1-.2.1 0-.2-.1-.5-.3-.8z",
    className: "st2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "path3427",
    d: "M55.1 17.2c.1-.1.1-.1.1-.2v-.3l.4-.2h.7l-.1.1c-.1.1-.1.2-.1.2.3.1.5.3.6.5-.2.2-.5.2-.8.2V17.8l-.2-.1c-.1 0-.3-.1-.5-.2.1-.1-.1-.3-.1-.3",
    className: "st3"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "path3429",
    d: "M55.1 17.2c.1-.1.1-.1.1-.2v-.3l.4-.2h.7l-.1.1c-.1.1-.1.2-.1.2.3.1.5.3.6.5-.2.2-.5.2-.8.2V17.8l-.2-.1c-.1 0-.3-.1-.5-.2.1-.1-.1-.3-.1-.3z",
    className: "st2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "path3431",
    d: "M54.5 17.1c0-.1-.1-.2-.1-.3 0-.1.1-.2.1-.2s-.1-.2-.3-.3c-.1-.1-.4-.2-.5-.2-.1 0-.2-.1-.2-.1V16.3c-.3 0-.5.1-.8.2.1.2.4.4.6.5 0 0 0 .1-.1.2 0 .1-.1.1-.1.1h.7c.5-.1.7-.2.7-.2",
    className: "st3"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "path3433",
    d: "M54.5 17.1c0-.1-.1-.2-.1-.3 0-.1.1-.2.1-.2s-.1-.2-.3-.3c-.1-.1-.4-.2-.5-.2-.1 0-.2-.1-.2-.1V16.3c-.3 0-.5.1-.8.2.1.2.4.4.6.5 0 0 0 .1-.1.2 0 .1-.1.1-.1.1h.7c.5-.1.7-.2.7-.2z",
    className: "st2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "path3435",
    d: "M54.4 16.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5",
    className: "st1"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "path3437",
    d: "M54.4 16.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5z",
    className: "st2"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "path3439",
    d: "M59.5 17.9c-.1-.1-.3-.1-.5.1-.2.1-.2.4-.1.5.1.1.3.1.5-.1.1-.2.2-.4.1-.5",
    className: "st1"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "path3441",
    d: "M59.5 17.9c-.1-.1-.3-.1-.5.1-.2.1-.2.4-.1.5.1.1.3.1.5-.1.1-.2.2-.4.1-.5z",
    className: "st2"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "path3443",
    d: "M58.8 18.2c0-.1.1-.2.2-.2.2-.1.4-.2.5-.1v.1s.2-.5.5-.6c.3-.2.7-.1.7-.1 0-.4-.3-.6-.6-.6-.2 0-.4.1-.5.2v-.2s-.3.1-.4.4c-.1.3 0 .8 0 .8l-.2-.4c-.1-.1-.4-.3-.5-.4-.1-.1-.3-.2-.3-.2V17.2c-.3 0-.6 0-.8.1.1.2.3.4.5.5l-.2.2-.1.1h.3c.1 0 .4.1.6 0 .1.1.3.1.3.1",
    className: "st3"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "path3445",
    d: "M58.8 18.2c0-.1.1-.2.2-.2.2-.1.4-.2.5-.1v.1s.2-.5.5-.6c.3-.2.7-.1.7-.1 0-.4-.3-.6-.6-.6-.2 0-.4.1-.5.2v-.2s-.3.1-.4.4c-.1.3 0 .8 0 .8l-.2-.4c-.1-.1-.4-.3-.5-.4-.1-.1-.3-.2-.3-.2V17.2c-.3 0-.6 0-.8.1.1.2.3.4.5.5l-.2.2-.1.1h.3c.1 0 .4.1.6 0 .1.1.3.1.3.1z",
    className: "st2"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "path3447",
    d: "M40.7 17.9c.1-.1.3-.1.5.1.2.1.2.4.1.5-.1.1-.3.1-.5-.1s-.2-.4-.1-.5",
    className: "st1"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "path3449",
    d: "M40.7 17.9c.1-.1.3-.1.5.1.2.1.2.4.1.5-.1.1-.3.1-.5-.1s-.2-.4-.1-.5z",
    className: "st2"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "path3451",
    d: "M41.3 18.2c0-.1-.1-.2-.2-.2-.2-.1-.4-.2-.5-.1v.1s-.2-.5-.5-.6c-.3-.2-.7-.1-.7-.1 0-.4.3-.6.6-.6.2 0 .4.1.5.2v-.2s.3.1.4.4c.1.3 0 .8 0 .8l.2-.4c.1-.1.4-.3.5-.4.1-.1.3-.2.3-.2V17.2c.3 0 .6 0 .8.1-.1.2-.3.4-.5.5l.2.2.1.1h-.3c-.1 0-.4.1-.6 0-.1.1-.2.1-.3.1",
    className: "st3"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "path3453",
    d: "M41.3 18.2c0-.1-.1-.2-.2-.2-.2-.1-.4-.2-.5-.1v.1s-.2-.5-.5-.6c-.3-.2-.7-.1-.7-.1 0-.4.3-.6.6-.6.2 0 .4.1.5.2v-.2s.3.1.4.4c.1.3 0 .8 0 .8l.2-.4c.1-.1.4-.3.5-.4.1-.1.3-.2.3-.2V17.2c.3 0 .6 0 .8.1-.1.2-.3.4-.5.5l.2.2.1.1h-.3c-.1 0-.4.1-.6 0-.1.1-.2.1-.3.1z",
    className: "st2"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "path3455",
    d: "M49.6 16.5c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5",
    className: "st1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "path3457",
    d: "M49.6 16.5c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5c-.3-.1-.5-.3-.5-.5z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3486"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g3460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145753218053587083750000017190635187690965426_",
    d: "M49.1 9.5c0-.5.4-.9.9-.9.6 0 1 .4 1 .9s-.4.9-.9.9c-.6.1-1-.3-1-.9",
    className: "st15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3470"
  }, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034047306740528969550000017535062354784154261_",
    d: "M49.1 9.5c0-.5.4-.9.9-.9.6 0 1 .4 1 .9s-.4.9-.9.9c-.6.1-1-.3-1-.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048472451968610938730000011620649787372408212_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034047306740528969550000017535062354784154261_",
    id: "use3465",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon3468",
    d: "M49.8 7.9h-.5v-.5h.5v-.5h.5v.5h.5v.5h-.5v1.5h.8v.5H49v-.5h.8z",
    clipPath: "url(#SVGID_00000048472451968610938730000011620649787372408212_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3482"
  }, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181080016908703776540000015904459189209211057_",
    d: "M49.1 9.5c0-.5.4-.9.9-.9.6 0 1 .4 1 .9s-.4.9-.9.9c-.6.1-1-.3-1-.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067218624056834482350000008093928061332770989_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181080016908703776540000015904459189209211057_",
    id: "use3477",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon3480",
    d: "M49.8 7.9h-.5v-.5h.5v-.5h.5v.5h.5v.5h-.5v1.5h.8v.5H49v-.5h.8z",
    clipPath: "url(#SVGID_00000067218624056834482350000008093928061332770989_)",
    style: {
      fill: "none"
    }
  })))), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3488",
    d: "M49.8 7.9h-.5v-.5h.5v-.5h.5v.5h.5v.5h-.5v1.5h.5v.5h-1.5v-.5h.5z",
    className: "st3"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3490",
    d: "M49.8 7.9h-.5v-.5h.5v-.5h.5v.5h.5v.5h-.5v1.5h.5v.5h-1.5v-.5h.5z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3500"
  }, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000137105621737322608310000010296819269594264711_",
    d: "M49.1 9.5c0-.5.4-.9.9-.9.6 0 1 .4 1 .9s-.4.9-.9.9c-.6.1-1-.3-1-.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012472669346678182180000002412899051013283246_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137105621737322608310000010296819269594264711_",
    id: "use3495",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon3498",
    d: "M49.8 7.9h-.5v-.5h.5v-.5h.5v.5h.5v.5h-.5v1.5h.8v.5H49v-.5h.8z",
    clipPath: "url(#SVGID_00000012472669346678182180000002412899051013283246_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3512"
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000084502517944309408310000015244512555307602609_",
    d: "M49.1 9.5c0-.5.4-.9.9-.9.6 0 1 .4 1 .9s-.4.9-.9.9c-.6.1-1-.3-1-.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173148280431733826050000010184569313269904017_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084502517944309408310000015244512555307602609_",
    id: "use3507",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon3510",
    d: "M49.8 7.9h-.5v-.5h.5v-.5h.5v.5h.5v.5h-.5v1.5h.8v.5H49v-.5h.8z",
    clipPath: "url(#SVGID_00000173148280431733826050000010184569313269904017_)",
    style: {
      fill: "none"
    }
  })))), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "path3518",
    d: "M50.3 8.7c.4.1.7.4.7.8 0 .5-.4.9-.9.9s-.9-.4-.9-.9c0-.4.3-.8.7-.9",
    className: "st2"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "path3520",
    d: "M50.1 48.8c-2.7 0-5.5-.7-7.7-1.9-1.7-.9-2.8-2.7-2.8-4.7v-7.4h21v7.4c0 2-1.1 3.8-2.8 4.7-2.2 1.1-4.9 1.9-7.7 1.9",
    className: "st16"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "path3522",
    d: "M50.1 48.8c-2.7 0-5.5-.7-7.7-1.9-1.7-.9-2.8-2.7-2.8-4.7v-7.4h21v7.4c0 2-1.1 3.8-2.8 4.7-2.2 1.1-4.9 1.9-7.7 1.9z",
    className: "st2"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "rect3524",
    d: "M50.1 22.4h10.6v12.3H50.1z",
    className: "st16"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "rect3526",
    d: "M50.1 22.4h10.6v12.3H50.1z",
    className: "st2"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "rect3528",
    d: "M39.6 22.4h10.5v12.3H39.6z",
    className: "st1"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "rect3530",
    d: "M39.6 22.4h10.5v12.3H39.6z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3655"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g3533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158016347687507178710000010711192670704256677_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3543"
  }, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170278299582670695350000018057686210087386781_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005945020861727469000000012491571614071924897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170278299582670695350000018057686210087386781_",
    id: "use3538",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3541",
    d: "M41.9 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000005945020861727469000000012491571614071924897_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3555"
  }, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000094582556268357569630000012415096440092194988_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011029333950916707360000017326397352832401564_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094582556268357569630000012415096440092194988_",
    id: "use3550",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3553",
    d: "M41.9 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000011029333950916707360000017326397352832401564_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3567"
  }, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034785117136933271290000013338806965902615187_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054945372089542204320000007332908929665169324_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034785117136933271290000013338806965902615187_",
    id: "use3562",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3565",
    d: "M39.5 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000054945372089542204320000007332908929665169324_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3579"
  }, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005957165714340144140000010836856214040044160_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034052786120791112060000012142220657971302045_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005957165714340144140000010836856214040044160_",
    id: "use3574",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3577",
    d: "M39.5 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000034052786120791112060000012142220657971302045_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3591"
  }, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075873676344174669990000004181269932899610003_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131345784318999258610000010479195744915543215_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075873676344174669990000004181269932899610003_",
    id: "use3586",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3589",
    d: "M44.2 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000131345784318999258610000010479195744915543215_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3603"
  }, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132046598930155883890000015769760954023334576_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073723924675622154090000012211669037967974564_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132046598930155883890000015769760954023334576_",
    id: "use3598",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3601",
    d: "M44.2 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000073723924675622154090000012211669037967974564_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3615"
  }, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029734452052921408600000016686275378868557197_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065785390483149302570000001272523136077349249_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029734452052921408600000016686275378868557197_",
    id: "use3610",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3613",
    d: "M46.6 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000065785390483149302570000001272523136077349249_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3627"
  }, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114037940756222528740000001751204825438704531_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070806300734465838410000003829850130101757351_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114037940756222528740000001751204825438704531_",
    id: "use3622",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3625",
    d: "M46.6 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000070806300734465838410000003829850130101757351_)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3639"
  }, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119092791964161451500000007882456121609854864_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057106381854680204730000009084774156132113798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119092791964161451500000007882456121609854864_",
    id: "use3634",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3637",
    d: "M48.9 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000057106381854680204730000009084774156132113798_)",
    style: {
      fill: "#caae17"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3651"
  }, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", {
    id: "defs3644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034792625501268785900000008750693854713139087_",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141441828186014756910000010292705680587931818_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034792625501268785900000008750693854713139087_",
    id: "use3646",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3649",
    d: "M48.9 34.5h1.2v13.7h-1.2z",
    clipPath: "url(#SVGID_00000141441828186014756910000010292705680587931818_)",
    style: {
      fill: "none"
    }
  })))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "path3657",
    d: "M50.1 42.2c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3v-7.4H50Z",
    className: "st2"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "path3659",
    d: "M60.7 34.8v7.4c0 2.9-2.4 5.3-5.3 5.3s-5.3-2.4-5.3-5.3v-7.4z",
    className: "st1"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "path3661",
    d: "M60.7 34.8v7.4c0 2.9-2.4 5.3-5.3 5.3s-5.3-2.4-5.3-5.3v-7.4z",
    className: "st2"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "path3663",
    d: "M55.5 25.5v-.2H55c-.2-.1-.3-.1-.5-.3-.2-.1-.2-.2-.3-.3-.3 0-.5.1-.5.1s.2.1.4.3c.2.2.3.3.4.3h.7l.3.1",
    className: "st1"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "path3665",
    d: "M55.5 25.5v-.2H55c-.2-.1-.3-.1-.5-.3-.2-.1-.2-.2-.3-.3-.3 0-.5.1-.5.1s.2.1.4.3c.2.2.3.3.4.3h.7l.3.1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3667",
    d: "M57.1 25v.7c0 .1 0 .1.1.2v.2l-.2-.2-.1-.1v.2c0 .1 0 .2.1.3.1.1.2.2.2.3v.3s-.1-.2-.2-.2-.3-.1-.3-.1.3.2.3.4-.1.4-.1.4-.1-.2-.2-.3l-.2-.2s.1.3.1.4v.5l-.2-.2c-.1-.1-.2-.1-.2-.2 0 0 .1.1.1.3 0 .1.1.5.4 1 .2.3.5.8 1.2.7.7-.2.4-1.1.3-1.5-.1-.4-.2-.9-.2-1.1 0-.2.1-.7.1-.8 0-.1-.1-.4 0-.7.1-.3.2-.4.2-.5 0-.1.1-.2.1-.3v-.3s.1.2.2.3v.3s0-.2.2-.4c.2-.1.4-.3.4-.3l.1-.1s0 .4-.1.6c-.1.1-.4.5-.4.5s.2-.1.3-.1h.2s-.1.1-.3.4c-.2.3-.1.3-.2.5s-.2.2-.4.3c-.2.2-.1 1-.1 1.1 0 .1.4 1.1.4 1.3 0 .2 0 .7-.3 1.1-.2.2-.6.2-.7.3-.1.1-.3.2-.3.6 0 .4.1.5.2.6.1.1.2 0 .3.1 0 .1 0 .1.1.2 0 0 .1.1.1.2s-.2.3-.3.4c-.1.1-.2.5-.2.5v.3s.2.2.1.3c-.1 0-.2-.1-.2 0-.1 0-.2.1-.2.1-.1 0-.1-.1-.1-.2v-.2s-.1 0-.1.1 0 .2-.1.2-.1-.1-.2-.1c0 0-.2 0-.2-.1s.1-.2.2-.2.2-.1.1-.1h-.2c-.1 0-.2 0-.2-.1v-.2s-.1-.1 0-.2.2.1.3 0c.1 0 .2-.1.2-.1v-.3c-.1-.1-.2-.1-.2-.2s-.1-.2-.1-.2v.5l-.2-.2c-.1-.1-.1-.3-.1-.3v.3c0 .1.1.2.1.2l-.2-.2s-.2-.1-.2-.2c-.1-.1-.1-.3-.1-.3v-.4c0-.1.1-.3.1-.3h-.3c-.2 0-.3-.1-.3.1-.1.1 0 .3 0 .6.1.3.1.4.1.5 0 .1-.1.2-.2.2h-.2s-.1-.1-.3-.1h-.3c-.1 0-.2-.1-.2-.1-.1 0-.2.1-.1.2 0 .1 0 .2-.1.2s-.1 0-.2-.1c-.1 0-.2 0-.2-.1s0-.1.1-.2c0-.1.1-.1 0-.1h-.1s-.1.1-.2.1-.1-.1-.1-.2-.1-.3 0-.3.3.1.3 0 0-.1-.1-.2-.2-.1-.1-.2.1-.1.2-.1c0 0 .1-.2.2-.1s0 .2.1.3c.1.2.2.2.4.2s.3-.1.3-.1v-.4l-.1.1c0 .1-.1.2-.1.2V30.3s0 .2-.1.2v.2s-.1-.1-.1-.3v-.5c0-.1.2-.4.4-.4h.6c.1 0 .4-.1.4-.1L55 29c-.1-.1-.4-.4-.4-.5-.1-.1-.1-.3-.1-.3s-.1 0-.2.1-.2.1-.3.2l-.2.2v-.5s-.1.3-.2.4l-.3.3v-.4s-.1.2-.3.2c-.2 0-.4 0-.4.1v.3c0 .1-.1.1-.1.1s-.1-.1-.2-.1h-.1s-.1-.1 0-.1c0-.1.1-.1.1-.2h-.2c-.1 0-.2.1-.2 0V28.5h.3s0-.1-.2-.1c-.1 0-.2-.1-.1-.2l.1-.1c0-.1 0-.2.2-.1.1.1.1.2.2.2s.4 0 .5-.1c.1 0 .2-.2.3-.2.1 0 .3-.3.3-.3s-.2-.1-.2-.2l-.2-.2c-.1 0-.3-.1-.4-.1-.1 0-.4-.1-.4-.1s.1 0 .2-.1c0 0 .1-.1.2-.1h.1-.3c-.1 0-.2-.1-.3-.1H52s.2-.1.3-.1h.2l-.2-.1c0-.1-.1-.2-.1-.2l-.1-.1c-.1 0-.2.1-.2.1-.1 0-.1 0-.1-.1v-.1c0-.1-.1-.2 0-.2h.3l-.2-.2c-.1 0-.2-.1-.1-.2s.1-.1.2-.1c0-.1.1-.2.2-.2s.2.3.2.3c.1 0 .1-.2.1-.3 0-.1 0-.2.1-.2s.1.1.2.1h.2c0 .1-.1.2-.1.2-.1.1-.1.2-.1.3 0 .1.1.3.2.3.1.1.3.1.4.2.1.1.4.3.5.3.1 0 .2.1.2.1h.8c.1-.1.3-.1.2-.3 0-.1-.3-.2-.3-.3 0-.1.1-.1.3-.1.2 0 .4 0 .4-.2s.1-.4-.2-.4c-.2-.1-.4-.1-.4-.2 0-.2-.1-.2 0-.3 0 0 .1-.1.3-.1.2 0 .4 0 .4-.1.1 0 .1-.2.1-.2.1 0 .3-.1.3-.1l.6.4c.2.1.5.4.5.4",
    style: {
      fill: "#cf7eac"
    }
  }), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "path3669",
    d: "M57.1 25v.7c0 .1 0 .1.1.2v.2l-.2-.2-.1-.1v.2c0 .1 0 .2.1.3.1.1.2.2.2.3v.3s-.1-.2-.2-.2-.3-.1-.3-.1.3.2.3.4-.1.4-.1.4-.1-.2-.2-.3l-.2-.2s.1.3.1.4v.5l-.2-.2c-.1-.1-.2-.1-.2-.2 0 0 .1.1.1.3 0 .1.1.5.4 1 .2.3.5.8 1.2.7.7-.2.4-1.1.3-1.5-.1-.4-.2-.9-.2-1.1 0-.2.1-.7.1-.8 0-.1-.1-.4 0-.7.1-.3.2-.4.2-.5 0-.1.1-.2.1-.3v-.3s.1.2.2.3v.3s0-.2.2-.4c.2-.1.4-.3.4-.3l.1-.1s0 .4-.1.6c-.1.1-.4.5-.4.5s.2-.1.3-.1h.2s-.1.1-.3.4c-.2.3-.1.3-.2.5s-.2.2-.4.3c-.2.2-.1 1-.1 1.1 0 .1.4 1.1.4 1.3 0 .2 0 .7-.3 1.1-.2.2-.6.2-.7.3-.1.1-.3.2-.3.6 0 .4.1.5.2.6.1.1.2 0 .3.1 0 .1 0 .1.1.2 0 0 .1.1.1.2s-.2.3-.3.4c-.1.1-.2.5-.2.5v.3s.2.2.1.3c-.1 0-.2-.1-.2 0-.1 0-.2.1-.2.1-.1 0-.1-.1-.1-.2v-.2s-.1 0-.1.1 0 .2-.1.2-.1-.1-.2-.1c0 0-.2 0-.2-.1s.1-.2.2-.2.2-.1.1-.1h-.2c-.1 0-.2 0-.2-.1v-.2s-.1-.1 0-.2.2.1.3 0c.1 0 .2-.1.2-.1v-.3c-.1-.1-.2-.1-.2-.2s-.1-.2-.1-.2v.5l-.2-.2c-.1-.1-.1-.3-.1-.3v.3c0 .1.1.2.1.2l-.2-.2s-.2-.1-.2-.2c-.1-.1-.1-.3-.1-.3v-.4c0-.1.1-.3.1-.3h-.3c-.2 0-.3-.1-.3.1-.1.1 0 .3 0 .6.1.3.1.4.1.5 0 .1-.1.2-.2.2h-.2s-.1-.1-.3-.1h-.3c-.1 0-.2-.1-.2-.1-.1 0-.2.1-.1.2 0 .1 0 .2-.1.2s-.1 0-.2-.1c-.1 0-.2 0-.2-.1s0-.1.1-.2c0-.1.1-.1 0-.1h-.1s-.1.1-.2.1-.1-.1-.1-.2-.1-.3 0-.3.3.1.3 0 0-.1-.1-.2-.2-.1-.1-.2.1-.1.2-.1c0 0 .1-.2.2-.1s0 .2.1.3c.1.2.2.2.4.2s.3-.1.3-.1v-.4l-.1.1c0 .1-.1.2-.1.2V30.3s0 .2-.1.2v.2s-.1-.1-.1-.3v-.5c0-.1.2-.4.4-.4h.6c.1 0 .4-.1.4-.1L55 29c-.1-.1-.4-.4-.4-.5-.1-.1-.1-.3-.1-.3s-.1 0-.2.1-.2.1-.3.2l-.2.2v-.5s-.1.3-.2.4l-.3.3v-.4s-.1.2-.3.2c-.2 0-.4 0-.4.1v.3c0 .1-.1.1-.1.1s-.1-.1-.2-.1h-.1s-.1-.1 0-.1c0-.1.1-.1.1-.2h-.2c-.1 0-.2.1-.2 0V28.5h.3s0-.1-.2-.1c-.1 0-.2-.1-.1-.2l.1-.1c0-.1 0-.2.2-.1.1.1.1.2.2.2s.4 0 .5-.1c.1 0 .2-.2.3-.2.1 0 .3-.3.3-.3s-.2-.1-.2-.2l-.2-.2c-.1 0-.3-.1-.4-.1-.1 0-.4-.1-.4-.1s.1 0 .2-.1c0 0 .1-.1.2-.1h.1-.3c-.1 0-.2-.1-.3-.1H52s.2-.1.3-.1h.2l-.2-.1c0-.1-.1-.2-.1-.2l-.1-.1c-.1 0-.2.1-.2.1-.1 0-.1 0-.1-.1v-.1c0-.1-.1-.2 0-.2h.3l-.2-.2c-.1 0-.2-.1-.1-.2s.1-.1.2-.1c0-.1.1-.2.2-.2s.2.3.2.3c.1 0 .1-.2.1-.3 0-.1 0-.2.1-.2s.1.1.2.1h.2c0 .1-.1.2-.1.2-.1.1-.1.2-.1.3 0 .1.1.3.2.3.1.1.3.1.4.2.1.1.4.3.5.3.1 0 .2.1.2.1h.8c.1-.1.3-.1.2-.3 0-.1-.3-.2-.3-.3 0-.1.1-.1.3-.1.2 0 .4 0 .4-.2s.1-.4-.2-.4c-.2-.1-.4-.1-.4-.2 0-.2-.1-.2 0-.3 0 0 .1-.1.3-.1.2 0 .4 0 .4-.1.1 0 .1-.2.1-.2.1 0 .3-.1.3-.1l.6.4c.2.1.5.4.5.4z",
    className: "st2"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "path3671",
    d: "M54.9 24.8v-.2s.2 0 .2.1c-.1 0-.2 0-.2.1",
    className: "st61"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "path3673",
    d: "M54.9 24.8v-.2s.2 0 .2.1c-.1 0-.2 0-.2.1z",
    className: "st2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "path3675",
    d: "M55.7 24.5c0-.1.1-.1.2 0l.2.2s-.1-.1-.2-.1h-.1l-.1-.1c.1.1.1 0 0 0z",
    className: "st61"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "path3677",
    d: "M55.7 24.5c0-.1.1-.1.2 0l.2.2s-.1-.1-.2-.1h-.1l-.1-.1c.1.1.1 0 0 0z",
    className: "st2"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "path3679",
    d: "m56.9 25.8-.1-.1v-.1",
    className: "st2"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "path3681",
    d: "M52.5 24.8s.1.1.2.1h.2v-.2c0-.3-.3-.3-.3-.3s.1.2 0 .2c0 .1-.1.2-.1.2",
    className: "st1"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "path3683",
    d: "M52.5 24.8s.1.1.2.1h.2v-.2c0-.3-.3-.3-.3-.3s.1.2 0 .2c0 .1-.1.2-.1.2z",
    className: "st2"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "path3685",
    d: "M52.1 25s-.1-.2-.3-.1c-.2 0-.3.2-.3.2h.3c.1.1.1.2.1.2l.1-.1c0-.1.1-.2.1-.2",
    className: "st1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "path3687",
    d: "M52.1 25s-.1-.2-.3-.1c-.2 0-.3.2-.3.2h.3c.1.1.1.2.1.2l.1-.1c0-.1.1-.2.1-.2Z",
    className: "st2"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "path3689",
    d: "M51.8 25.7s-.2 0-.2.1c-.1.1-.1.3-.1.3s.1-.1.2-.1h.2v-.2l-.1-.1",
    className: "st1"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "path3691",
    d: "M51.8 25.7s-.2 0-.2.1c-.1.1-.1.3-.1.3s.1-.1.2-.1h.2v-.2z",
    className: "st2"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3693",
    d: "M55 25.7h-.1l.1-.1z",
    className: "st61"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3695",
    d: "M55 25.7h-.1l.1-.1z",
    className: "st2"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3697",
    d: "M55.2 25.7h-.1v-.1z",
    className: "st61"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3699",
    d: "M55.2 25.7h-.1v-.1z",
    className: "st2"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3701",
    d: "M55 25.1v-.2l.1.1z",
    className: "st61"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3703",
    d: "M55 25.1v-.2l.1.1z",
    className: "st2"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3705",
    d: "M55.2 25.1V25h.1z",
    className: "st61"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3707",
    d: "M55.2 25.1V25h.1z",
    className: "st2"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "path3709",
    d: "M54.7 28.2s.2-.1.3-.2l.2-.2m-1.4-.2s.1-.2.2-.2c.1-.1.2-.2.3-.2l.2-.1m-.5-.7-.2.1c-.1.1-.1.2-.1.2s.1-.1.3-.1c.2.1.2.1.3.1.1 0 .3-.1.3-.1s-.2.2-.1.3v.3c0 .2-.1.4-.1.4s.1 0 .2-.1c.2 0 .3-.1.4-.2l.2-.2v.7s.1-.1.2-.1l.2-.2c0-.1.1-.2.1-.2s0 .2.1.3c.1.1.1.4.1.4s.1-.2.1-.3c.1-.1.1-.2.1-.2v-.2l.1.2",
    className: "st2"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "path3711",
    d: "M52.4 27.9s-.1-.1-.2-.1c-.2 0-.3.2-.3.2h.2c.1 0 .1.1.1.1l.1-.1.1-.1",
    className: "st1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "path3713",
    d: "M52.4 27.9s-.1-.1-.2-.1c-.2 0-.3.2-.3.2h.2c.1 0 .1.1.1.1l.1-.1Z",
    className: "st2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "path3715",
    d: "M52.2 28.6s-.1 0-.2.1-.1.3-.1.3.1-.1.2-.1.2.1.2.1v-.1c-.1-.2-.1-.3-.1-.3",
    className: "st1"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "path3717",
    d: "M52.2 28.6s-.1 0-.2.1-.1.3-.1.3.1-.1.2-.1.2.1.2.1v-.1c-.1-.2-.1-.3-.1-.3z",
    className: "st2"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "path3719",
    d: "M52.5 29.2s0 .2.1.3c.1.1.2.1.2.1s0-.1-.1-.2c0-.1.1-.2.1-.2s-.1-.1-.2-.1c0 .1-.1.1-.1.1",
    className: "st1"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "path3721",
    d: "M52.5 29.2s0 .2.1.3c.1.1.2.1.2.1s0-.1-.1-.2c0-.1.1-.2.1-.2s-.1-.1-.2-.1c0 .1-.1.1-.1.1z",
    className: "st2"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "path3723",
    d: "M56 29.5s.4.3.4.5-.2.5-.2.5",
    className: "st2"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "path3725",
    d: "M54 30.8s-.1-.1-.3-.1c-.1 0-.3.2-.3.2h.2c0 .1.1.1.1.1s.1 0 .1-.1c.1 0 .2-.1.2-.1",
    className: "st1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "path3727",
    d: "M54 30.8s-.1-.1-.3-.1c-.1 0-.3.2-.3.2h.2c0 .1.1.1.1.1s.1 0 .1-.1c.1 0 .2-.1.2-.1z",
    className: "st2"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "path3729",
    d: "M53.6 31.4s-.2 0-.3.1c-.1.1-.1.3-.1.3s.1-.1.2-.1.2.1.2.1v-.4",
    className: "st1"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "path3731",
    d: "M53.6 31.4s-.2 0-.3.1c-.1.1-.1.3-.1.3s.1-.1.2-.1.2.1.2.1v-.4z",
    className: "st2"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "path3733",
    d: "M54 32s-.1.1 0 .3l.2.2s-.1-.1 0-.2c0-.1.1-.2.1-.2z",
    className: "st1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "path3735",
    d: "M54 32s-.1.1 0 .3l.2.2s-.1-.1 0-.2c0-.1.1-.2.1-.2z",
    className: "st2"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "path3737",
    d: "M56.6 32.3h-.3c-.1.1-.2.3-.2.3s.2-.1.3-.1c.1 0 .2.1.2.1v-.3c0 .1 0 0 0 0",
    className: "st1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "path3739",
    d: "M56.6 32.3h-.3c-.1.1-.2.3-.2.3s.2-.1.3-.1c.1 0 .2.1.2.1v-.3c0 .1 0 0 0 0z",
    className: "st2"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "path3741",
    d: "M56.7 33s-.1.1-.1.3c0 .1.1.2.1.2v-.2c.1-.1.2-.1.2-.1l-.1-.1c0-.1-.1-.1-.1-.1",
    className: "st1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "path3743",
    d: "M56.7 33s-.1.1-.1.3c0 .1.1.2.1.2v-.2c.1-.1.2-.1.2-.1l-.1-.1c0-.1-.1-.1-.1-.1Z",
    className: "st2"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "path3745",
    d: "M57.3 33.2s-.1.2.1.3c.1.1.2.1.2.1s-.1-.2-.1-.3c0-.1.1-.2.1-.2s-.2-.1-.2 0c.1 0-.1.1-.1.1",
    className: "st1"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "path3747",
    d: "M57.3 33.2s-.1.2.1.3c.1.1.2.1.2.1s-.1-.2-.1-.3c0-.1.1-.2.1-.2s-.2-.1-.2 0c.1 0-.1.1-.1.1z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3749",
    d: "M50.7 45.5c.4.1.7.5.7.9 0 .5-.5.9-1.1.9-.6 0-1.1-.4-1.1-.9 0-.4.2-.8.6-.9l-.1-.1c0-.1-.1-.1-.1-.1h.3c.1 0 .2.1.2.1s0-.1.1-.2l.1-.1.1.1c0 .1.1.1.1.1s.1-.1.2-.1.2-.1.2-.1v.2c-.2.1-.2.2-.2.2",
    style: {
      fill: "#f7e9ad"
    }
  }), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "path3751",
    d: "M50.7 45.5c.4.1.7.5.7.9 0 .5-.5.9-1.1.9-.6 0-1.1-.4-1.1-.9 0-.4.2-.8.6-.9l-.1-.1c0-.1-.1-.1-.1-.1h.3c.1 0 .2.1.2.1s0-.1.1-.2l.1-.1.1.1c0 .1.1.1.1.1s.1-.1.2-.1.2-.1.2-.1v.2c-.2.1-.2.2-.2.2z",
    className: "st2"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "path3753",
    d: "M50.1 47.9s-.8-.6-1.2-.7c-.5-.1-1 0-1.2 0 0 0 .3.2.4.3.1.1.5.4.7.4.7.2 1.3 0 1.3 0",
    className: "st7"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "path3755",
    d: "M50.1 47.9s-.8-.6-1.2-.7c-.5-.1-1 0-1.2 0 0 0 .3.2.4.3.1.1.5.4.7.4.7.2 1.3 0 1.3 0z",
    className: "st2"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "path3757",
    d: "M50.3 47.9s.5-.6 1.1-.7c.7-.1 1.1.1 1.3.1 0 0-.2.1-.3.2-.1.1-.4.3-.9.4h-1.2",
    className: "st7"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "path3759",
    d: "M50.3 47.9s.5-.6 1.1-.7c.7-.1 1.1.1 1.3.1 0 0-.2.1-.3.2-.1.1-.4.3-.9.4h-1.2z",
    className: "st2"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "path3761",
    d: "M50.2 47.2c-.2-.2-.3-.5-.3-.8 0-.3.1-.6.3-.8.2.2.3.5.3.8 0 .3-.1.6-.3.8",
    className: "st1"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "path3763",
    d: "M50.2 47.2c-.2-.2-.3-.5-.3-.8 0-.3.1-.6.3-.8.2.2.3.5.3.8 0 .3-.1.6-.3.8z",
    className: "st2"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "path3765",
    d: "M50 48.4s.1-.3.1-.6v-.5h.2s.1.3.1.5v.5h-.2c-.1 0-.2.1-.2.1",
    className: "st7"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "path3767",
    d: "M50 48.4s.1-.3.1-.6v-.5h.2s.1.3.1.5v.5h-.2c-.1 0-.2.1-.2.1z",
    className: "st2"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "path3769",
    d: "M60.5 16.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "path3771",
    d: "M60.5 16.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "path3773",
    d: "M60.8 15.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "path3775",
    d: "M60.8 15.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "path3777",
    d: "M61.1 15.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "path3779",
    d: "M61.1 15.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "path3781",
    d: "M61.1 14.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "path3783",
    d: "M61.1 14.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "path3785",
    d: "M60.9 13.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "path3787",
    d: "M60.9 13.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "path3789",
    d: "M60.6 13.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "path3791",
    d: "M60.6 13.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "path3793",
    d: "M60.1 12.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "path3795",
    d: "M60.1 12.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "path3797",
    d: "M59.5 12.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "path3799",
    d: "M59.5 12.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "path3801",
    d: "M58.9 11.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "path3803",
    d: "M58.9 11.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "path3805",
    d: "M58.2 11.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "path3807",
    d: "M58.2 11.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "path3809",
    d: "M57.4 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "path3811",
    d: "M57.4 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "path3813",
    d: "M56.7 11.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "path3815",
    d: "M56.7 11.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "path3817",
    d: "M56 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "path3819",
    d: "M56 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "path3821",
    d: "M55.3 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "path3823",
    d: "M55.3 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "path3825",
    d: "M55.7 12c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "path3827",
    d: "M55.7 12c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "path3829",
    d: "M55.8 12.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "path3831",
    d: "M55.8 12.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "path3833",
    d: "M55.8 13.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "path3835",
    d: "M55.8 13.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "path3837",
    d: "M55.6 14.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "path3839",
    d: "M55.6 14.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "path3841",
    d: "M55.2 14.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "path3843",
    d: "M55.2 14.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "path3845",
    d: "M54.8 10.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "path3847",
    d: "M54.8 10.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "path3849",
    d: "M54.1 10.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "path3851",
    d: "M54.1 10.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "path3853",
    d: "M53.4 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c0 .1-.2 0-.2-.2",
    className: "st6"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "path3855",
    d: "M53.4 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c0 .1-.2 0-.2-.2z",
    className: "st2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "path3857",
    d: "M52.7 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "path3859",
    d: "M52.7 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "path3861",
    d: "M52 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "path3863",
    d: "M52 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "path3865",
    d: "M51.3 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "path3867",
    d: "M51.3 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "path3869",
    d: "M50.6 10.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "path3871",
    d: "M50.6 10.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "path3873",
    d: "M39.1 16.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "path3875",
    d: "M39.1 16.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "path3877",
    d: "M38.8 15.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "path3879",
    d: "M38.8 15.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "path3881",
    d: "M38.6 15.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "path3883",
    d: "M38.6 15.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "path3885",
    d: "M38.6 14.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "path3887",
    d: "M38.6 14.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "path3889",
    d: "M38.7 13.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "path3891",
    d: "M38.7 13.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "path3893",
    d: "M39.1 13.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2 0-.2-.2",
    className: "st6"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "path3895",
    d: "M39.1 13.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2 0-.2-.2z",
    className: "st2"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "path3897",
    d: "M39.5 12.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c0 0-.2-.1-.2-.2",
    className: "st6"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "path3899",
    d: "M39.5 12.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c0 0-.2-.1-.2-.2z",
    className: "st2"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "path3901",
    d: "M40.1 12.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "path3903",
    d: "M40.1 12.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "path3905",
    d: "M40.8 11.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "path3907",
    d: "M40.8 11.8c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "path3909",
    d: "M41.4 11.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "path3911",
    d: "M41.4 11.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "path3913",
    d: "M42.2 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "path3915",
    d: "M42.2 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "path3917",
    d: "M42.9 11.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "path3919",
    d: "M42.9 11.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "path3921",
    d: "M43.6 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "path3923",
    d: "M43.6 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "path3925",
    d: "M44.3 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "path3927",
    d: "M44.3 11.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "path3929",
    d: "M44 12c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "path3931",
    d: "M44 12c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2Z",
    className: "st2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "path3933",
    d: "M43.8 12.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "path3935",
    d: "M43.8 12.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "path3937",
    d: "M43.8 13.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "path3939",
    d: "M43.8 13.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "path3941",
    d: "M44 14.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "path3943",
    d: "M44 14.1c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "path3945",
    d: "M44.4 14.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "path3947",
    d: "M44.4 14.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "path3949",
    d: "M44.9 10.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "path3951",
    d: "M44.9 10.9c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "path3953",
    d: "M45.5 10.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "path3955",
    d: "M45.5 10.5c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "path3957",
    d: "M46.2 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "path3959",
    d: "M46.2 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "path3961",
    d: "M46.9 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "path3963",
    d: "M46.9 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "path3965",
    d: "M47.6 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "path3967",
    d: "M47.6 10.2c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "path3969",
    d: "M48.3 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2",
    className: "st6"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "path3971",
    d: "M48.3 10.3c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2c-.1.1-.2 0-.2-.2z",
    className: "st2"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "path3973",
    d: "M49 10.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2",
    className: "st6"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "path3975",
    d: "M49 10.6c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2z",
    className: "st2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3977",
    d: "M42.3 28.3v-1.5h.7v-1h-.3v-.7h.3v.2h.3v-.2h.3v.2h.3v-.2h.3v.7h-.4v1h.6v-2.2h-.3v-.8h.2v.2h.4v-.2h.4v.2h.3v-.2h.3v.8h-.4v2.2h.6v-1h-.3v-.7h.2v.2h.3v-.2h.4v.2h.2v-.2h.3v.7h-.3v1h.7v1.5H47v3.2h.8v1.6h-5.9v-1.6h.8v-3.2z",
    className: "st3"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3979",
    d: "M42.3 28.3v-1.5h.7v-1h-.3v-.7h.3v.2h.3v-.2h.3v.2h.3v-.2h.3v.7h-.4v1h.6v-2.2h-.3v-.8h.2v.2h.4v-.2h.4v.2h.3v-.2h.3v.8h-.4v2.2h.6v-1h-.3v-.7h.2v.2h.3v-.2h.4v.2h.2v-.2h.3v.7h-.3v1h.7v1.5H47v3.2h.8v1.6h-5.9v-1.6h.8v-3.2z",
    className: "st2"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "path3981",
    d: "M43.3 29.3c0-.1.1-.3.3-.3.1 0 .3.1.3.3v.7h-.5z",
    className: "st15"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "path3983",
    d: "M43.3 29.3c0-.1.1-.3.3-.3.1 0 .3.1.3.3v.7h-.5z",
    className: "st2"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "path3985",
    d: "M45.9 29.3c0-.1.1-.3.3-.3.1 0 .3.1.3.3v.7H46Z",
    className: "st15"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "path3987",
    d: "M45.9 29.3c0-.1.1-.3.3-.3.1 0 .3.1.3.3v.7H46Z",
    className: "st2"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "path3989",
    d: "M44.3 32.1c0-.3.2-.6.6-.6.3 0 .6.3.6.6v1h-1.1z",
    className: "st15"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "path3991",
    d: "M44.3 32.1c0-.3.2-.6.6-.6.3 0 .6.3.6.6v1h-1.1z",
    className: "st2"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "path3993",
    d: "M56.9 24c-.1 0-.1.1-.1.1-.1.1-.1.1-.2 0V24h-.1c-.1 0-.1-.1 0-.2v-.1h-.1c0 .1-.1.1-.1 0v-.1c-.1 0-.2-.2-.2-.3v.4c0 .1-.1.3-.1.3.2 0 .4.2.6.4l.5.5s.1-.1.2-.1h.3c-.1 0-.3 0-.3-.1h-.1V24.4h-.1c-.1.1-.1.1-.2 0v-.1h-.1c-.1 0-.1-.1.1-.3 0 .1 0 .1 0 0z",
    className: "st3"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "path3995",
    d: "M56.9 24c-.1 0-.1.1-.1.1-.1.1-.1.1-.2 0V24h-.1c-.1 0-.1-.1 0-.2v-.1h-.1c0 .1-.1.1-.1 0v-.1c-.1 0-.2-.2-.2-.3v.4c0 .1-.1.3-.1.3.2 0 .4.2.6.4l.5.5s.1-.1.2-.1h.3c-.1 0-.3 0-.3-.1h-.1V24.4h-.1c-.1.1-.1.1-.2 0v-.1h-.1c-.1 0-.1-.1.1-.3 0 .1 0 .1 0 0z",
    className: "st2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "path3997",
    d: "M56.5 24.2",
    className: "st61"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    d: "M56.5 24.2Z",
    className: "st2"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "path4001",
    d: "M56.7 24.4c-.1-.1-.1-.1 0 0-.1-.1-.1-.1 0 0 .1 0 .1 0 .1.1 0-.1-.1-.1-.1-.1z",
    className: "st61"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "path4003",
    d: "M56.7 24.4c-.1-.1-.1-.1 0 0-.1-.1-.1-.1 0 0 .1 0 .1 0 .1.1 0-.1-.1-.1-.1-.1z",
    className: "st2"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "path4005",
    d: "M56.3 24.1c-.1 0-.1-.1 0 0-.1-.1 0-.1 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0 0z",
    className: "st61"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "path4007",
    d: "M56.3 24.1c-.1 0-.1-.1 0 0-.1-.1 0-.1 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0 0z",
    className: "st2"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "path4009",
    d: "M56.1 23.9c0 .1.1.1 0 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0",
    className: "st61"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "path4011",
    d: "M56.1 23.9c0 .1.1.1 0 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0z",
    className: "st2"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "path4013",
    d: "M56.9 24.5s-.1 0 0 0c-.1 0-.1 0 0 0",
    className: "st61"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "path4015",
    d: "M56.9 24.5s-.1 0 0 0c-.1 0-.1 0 0 0z",
    className: "st2"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "path4017",
    d: "M57 24.7c.1 0 .1 0 0 0 .1 0 .1 0 0 0 0-.1 0-.1 0 0-.1-.1-.1-.1 0 0z",
    className: "st61"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "path4019",
    d: "M57 24.7c.1 0 .1 0 0 0 .1 0 .1 0 0 0 0-.1 0-.1 0 0-.1-.1-.1-.1 0 0z",
    className: "st2"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "path4021",
    d: "M57.2 24.8c-.1 0-.1 0 0 0 0 .1 0 .1 0 0",
    className: "st61"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "path4023",
    d: "M57.2 24.8c-.1 0-.1 0 0 0 0 .1 0 .1 0 0z",
    className: "st2"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4025",
    d: "m56.7 23.6-.1-.1h-.1v.2z",
    className: "st3"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4027",
    d: "m56.7 23.6-.1-.1h-.1v.2z",
    className: "st2"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4029",
    d: "M56.4 23.6h-.1v.1l.2.1v-.1z",
    className: "st3"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4031",
    d: "M56.4 23.6h-.1v.1l.2.1v-.1z",
    className: "st2"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4033",
    d: "M56.7 23.7v.2h-.1l-.1-.1v-.1z",
    className: "st3"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4035",
    d: "M56.7 23.7v.2h-.1l-.1-.1v-.1z",
    className: "st2"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "path4037",
    d: "M56.4 23.7c.1 0 .1 0 0 0 .1 0 .1 0 .1.1l-.1-.1c0 .1 0 0 0 0",
    className: "st3"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "path4039",
    d: "M56.4 23.7c.1 0 .1 0 0 0 .1 0 .1 0 .1.1l-.1-.1c0 .1 0 0 0 0z",
    className: "st2"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "path4041",
    d: "M56 23.5s0-.1-.1-.2l-.1-.1h.2c.1.1 0 .3 0 .3",
    className: "st3"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "path4043",
    d: "M56 23.5s0-.1-.1-.2l-.1-.1h.2c.1.1 0 .3 0 .3z",
    className: "st2"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4045",
    d: "M56.2 23.5v.1l-.1.1-.1-.2z",
    className: "st3"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4047",
    d: "M56.2 23.5v.1l-.1.1-.1-.2z",
    className: "st2"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "path4049",
    d: "M56 23.5s0-.1 0 0c0 0 .1 0 0 0 0 .1 0 .1 0 0 0 .1 0 0 0 0",
    className: "st3"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "path4051",
    d: "M56 23.5s0-.1 0 0c0 0 .1 0 0 0 0 .1 0 .1 0 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4053",
    d: "M57.1 23.9v-.1H57l-.1.2h.1z",
    className: "st3"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4055",
    d: "M57.1 23.9v-.1H57l-.1.2h.1z",
    className: "st2"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4057",
    d: "m56.9 23.8-.1.1-.1.1.2.1.1-.1z",
    className: "st3"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4059",
    d: "m56.9 23.8-.1.1-.1.1.2.1.1-.1z",
    className: "st2"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4061",
    d: "M57.1 24.1v.1H57l-.1-.2z",
    className: "st3"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4063",
    d: "M57.1 24.1v.1H57l-.1-.2z",
    className: "st2"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "path4065",
    d: "M56.9 24c.1 0 .1 0 0 0 .1.1 0 .1 0 0 0 .1 0 0 0 0",
    className: "st3"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "path4067",
    d: "M56.9 24c.1 0 .1 0 0 0 .1.1 0 .1 0 0 0 .1 0 0 0 0z",
    className: "st2"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4069",
    d: "M57.4 24.2h.1v.2h-.2z",
    className: "st3"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4071",
    d: "M57.4 24.2h.1v.2h-.2z",
    className: "st2"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4073",
    d: "M57.5 24.5v.1h-.1l-.1-.2z",
    className: "st3"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4075",
    d: "M57.5 24.5v.1h-.1l-.1-.2z",
    className: "st2"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4077",
    d: "M57.3 24.2h-.1l-.1.2h.2z",
    className: "st3"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4079",
    d: "M57.3 24.2h-.1l-.1.2h.2z",
    className: "st2"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "path4081",
    d: "M57.4 24.5c0-.1 0-.1 0 0-.1-.2-.1-.2 0 0-.1-.1-.1-.1 0 0-.1 0-.1 0 0 0",
    className: "st3"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "path4083",
    d: "M57.4 24.5c0-.1 0-.1 0 0-.1-.2-.1-.2 0 0-.1-.1-.1-.1 0 0-.1 0-.1 0 0 0z",
    className: "st2"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "path4085",
    d: "M57.7 24.9h.2l.1.1s0-.1-.1-.2-.2 0-.2.1c0-.1 0-.1 0 0",
    className: "st3"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "path4087",
    d: "M57.7 24.9h.2l.1.1s0-.1-.1-.2-.2 0-.2.1c0-.1 0-.1 0 0z",
    className: "st2"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4089",
    d: "M57.7 24.7h-.2v.1l.1.1h.1v-.1z",
    className: "st3"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4091",
    d: "M57.7 24.7h-.2v.1l.1.1h.1v-.1z",
    className: "st2"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "path4093",
    d: "M57.7 24.9s0-.1 0 0c0-.1 0-.1 0 0-.1-.1-.1 0 0 0-.1 0-.1 0 0 0",
    className: "st3"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "path4095",
    d: "M57.7 24.9s0-.1 0 0c0-.1 0-.1 0 0-.1-.1-.1 0 0 0-.1 0-.1 0 0 0z",
    className: "st2"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "path4097",
    d: "M55.1 45.7c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2m3.4-1.9c.1.1.1.3 0 .3-.1.1-.3.1-.3 0-.1-.1-.1-.3 0-.3.1-.1.2-.1.3 0m-6.4 0c.1-.1.2-.1.3 0 .1.1.1.2 0 .3-.1.1-.2.1-.3 0v-.3m3-7.4c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2m3.5 0c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2m-7 0c0-.1.1-.2.2-.2s.2.1.2.2-.1.2-.2.2-.2-.1-.2-.2m.5 4.1c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0-.1.2 0 .2.2zm7 0c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2zm.3 0c0-.3-.2-.5-.4-.5v-1l.4-.1v-1l-.4-.1v-.9c.2-.1.4-.3.4-.5 0-.3-.3-.6-.6-.6s-.5.2-.5.4h-.6l-.1-.4h-1l-.1.4h-.6c-.1-.2-.3-.4-.5-.4-.3 0-.5.2-.5.4h-.6l-.1-.4h-1l-.2.4h-.7c-.1-.2-.3-.4-.5-.4-.3 0-.6.3-.6.6s.2.5.4.5v.9l-.4.1v1l.4.1v.9c-.2.1-.4.3-.4.5 0 .3.2.5.4.5v.6l-.4.1.1 1 .4.1c0 .3.1.5.2.8-.2.2-.2.6.1.8.2.1.4.2.5.1.2.2.3.4.5.5l-.1.4c.3.2.6.3.9.5l.3-.3c.2.1.5.1.7.2.1.3.3.4.6.4s.5-.2.6-.5c.2 0 .4-.1.7-.2l.3.3c.3-.1.6-.3.9-.5l-.3-.2c.2-.2.4-.3.5-.5.2.1.4 0 .5-.1.2-.2.3-.6.1-.8.1-.3.2-.5.2-.8l.4-.1.1-1-.4-.1V41c.3-.1.4-.3.4-.5zm-.7-2.4h.3v.6h-.4v-.6zm-.1-1.2.1.9-.4.1v1l.4.1v.9c-.2.1-.3.2-.3.3h-.7l-.1-.4h-1l-.1.4h-.6s0-.1-.1-.1l.9-1 .3.2.6-.8-.2-.3zm-1.3 3.4v.4h-.6v-.4zm-.7-1.6.4-.4.3.2-.4.4zm.2-2.5h.6v.3h-.6zm-1.3.7c.2-.1.3-.2.3-.4h.6l.1.4h1l.1-.4h.7v.1L57.2 38l-.3-.2-.6.8.2.3-.9 1v-1.4l.4-.1v-1l-.4-.1zm-2.2-.7h.6v.3h-.6zm-.9.4h.6l.1.4h1l.1-.4h.6c.1.2.2.3.4.4v.4l-.4.1v1l.4.1V40l-.9-1 .2-.3-.6-.8-.5.1-1.1-1.3c0-.1.1-.1.1-.1zm1.6 2.1-.3.2-.4-.4.3-.2zm-2-1.8 1.2 1.3-.2.4.6.8.3-.2.9 1v.1h-.6l-.1-.4h-1l-.1.4h-.7c-.1-.2-.2-.3-.3-.4V39l.4-.1v-1l-.4-.1Zm1.9 3.4v.4h-.6v-.4Zm-2.3-2.2h.4v.6h-.3v-.6zm.1 4.4v-.6h.3v.6zm.8 1c-.1 0-.2-.1-.3 0-.1-.2-.1-.4-.2-.6l.4-.1v-1l-.4-.2V41c.2-.1.3-.2.3-.3h.7l.1.4h1l.1-.4h.6v.1l-.8 1-.3-.2-.7.7.2.3zm1.6-1.3-.4.4-.3-.2.4-.4zm-.3 3.3c-.2-.1-.3-.2-.5-.3l.2-.3c.2.1.3.2.5.3zm1.4-.4c-.2.1-.3.2-.3.3-.2 0-.4-.1-.6-.1l.1-.4c-.3-.1-.6-.3-.9-.5l-.3.2c-.2-.1-.3-.3-.4-.4.1-.2.1-.4 0-.6l.7-.8.3.2.6-.8-.1-.2.8-1v1.7l-.3.1v1l.4.1zm.3-1.5h-.3V43h.3zm0-5.4h-.4v-.6h.4zm1.3 7.3-.2-.3c.2-.1.3-.2.5-.3l.2.3c-.1.1-.3.2-.5.3zm.6-.8-.3-.2c-.3.2-.6.4-.9.5l.1.4c-.2.1-.3.1-.5.1-.1-.2-.2-.3-.4-.3V44l.4-.1v-1l-.4-.1V41l.8 1-.2.3.6.8.3-.2.7.8c-.1.2-.1.4 0 .6.1.2 0 .3-.2.4zm-.8-2.5.2-.2.4.4-.2.2zm2 .6c0 .2-.1.4-.2.7h-.3l-.7-.8.2-.3-.6-.8-.3.1-.8-1s0-.1.1-.1h.6l.1.4h1l.1-.4h.7c.1.2.2.3.3.3v.6l-.3.1v1zm.4-.6v.3h-.3v-.6h.3Z",
    className: "st3"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "path4099",
    d: "M46.7 34.7c0-2.2 1.5-4.1 3.4-4.1s3.4 1.8 3.4 4.1c0 2.2-1.5 4.1-3.4 4.1s-3.4-1.8-3.4-4.1",
    className: "st1"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "path4101",
    d: "M46.7 34.7c0-2.2 1.5-4.1 3.4-4.1s3.4 1.8 3.4 4.1c0 2.2-1.5 4.1-3.4 4.1s-3.4-1.8-3.4-4.1z",
    className: "st2"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "path4103",
    d: "M47.7 34.7c0-1.6 1.1-3 2.4-3 1.3 0 2.4 1.3 2.4 3 0 1.6-1.1 3-2.4 3-1.3 0-2.4-1.3-2.4-3",
    className: "st15"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "path4105",
    d: "M47.7 34.7c0-1.6 1.1-3 2.4-3 1.3 0 2.4 1.3 2.4 3 0 1.6-1.1 3-2.4 3-1.3 0-2.4-1.3-2.4-3z",
    className: "st2"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "path4107",
    d: "M49 32.7s-.3.3-.3.6.1.6.1.6c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.3 0 .1 0 .1.1.2l.1.2c0-.1.1-.1.2-.1s.2.1.2.2v.1h-.3v.2h.2l-.2.4.2-.1.2.2.2-.2.2.1-.2-.4h.2v-.2H49v-.1c0-.1.1-.2.2-.2s.2 0 .2.1l.1-.2s.1-.1.1-.2c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.2 0 0 .1-.3.1-.6.2-.3-.1-.6-.1-.6",
    className: "st3"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "path4109",
    d: "M49 32.7s-.3.3-.3.6.1.6.1.6c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.3 0 .1 0 .1.1.2l.1.2c0-.1.1-.1.2-.1s.2.1.2.2v.1h-.3v.2h.2l-.2.4.2-.1.2.2.2-.2.2.1-.2-.4h.2v-.2H49v-.1c0-.1.1-.2.2-.2s.2 0 .2.1l.1-.2s.1-.1.1-.2c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.2 0 0 .1-.3.1-.6.2-.3-.1-.6-.1-.6Z",
    className: "st2"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "rect4111",
    d: "M48.5 34.5h.9v.2h-.9z",
    className: "st3"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "rect4113",
    d: "M48.5 34.5h.9v.2h-.9z",
    className: "st2"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "path4115",
    d: "M51.2 32.7s-.3.3-.3.6.1.6.1.6c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.3 0 .1 0 .1.1.2l.1.2c0-.1.1-.1.2-.1s.2.1.2.2v.1h-.3v.2h.3l-.2.4.2-.1.2.2.2-.2.2.1-.2-.4h.2v-.2h-.3v-.1c0-.1.1-.2.2-.2s.2 0 .2.1l.1-.2s.1-.1.1-.2c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.2 0 0 .1-.3.1-.6.1-.3-.2-.6-.2-.6",
    className: "st3"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "path4117",
    d: "M51.2 32.7s-.3.3-.3.6.1.6.1.6c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.3 0 .1 0 .1.1.2l.1.2c0-.1.1-.1.2-.1s.2.1.2.2v.1h-.3v.2h.3l-.2.4.2-.1.2.2.2-.2.2.1-.2-.4h.2v-.2h-.3v-.1c0-.1.1-.2.2-.2s.2 0 .2.1l.1-.2s.1-.1.1-.2c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.2 0 0 .1-.3.1-.6.1-.3-.2-.6-.2-.6z",
    className: "st2"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "rect4119",
    d: "M50.8 34.5h.9v.2h-.9z",
    className: "st3"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "rect4121",
    d: "M50.8 34.5h.9v.2h-.9z",
    className: "st2"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "path4123",
    d: "M50.1 34.7s-.3.3-.3.6.1.6.1.6c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.3 0 .1 0 .1.1.2l.1.2c0-.1.1-.1.2-.1s.2.1.2.2v.1h-.3v.2h.2l-.2.4.2-.1.2.2.2-.2.2.1-.2-.4h.2v-.2h-.3v-.1c0-.1.1-.2.2-.2s.2 0 .2.1l.1-.2s.1-.1.1-.2c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.2 0 0 .1-.3.1-.6.2-.3-.1-.6-.1-.6",
    className: "st3"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "path4125",
    d: "M50.1 34.7s-.3.3-.3.6.1.6.1.6c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.3 0 .1 0 .1.1.2l.1.2c0-.1.1-.1.2-.1s.2.1.2.2v.1h-.3v.2h.2l-.2.4.2-.1.2.2.2-.2.2.1-.2-.4h.2v-.2h-.3v-.1c0-.1.1-.2.2-.2s.2 0 .2.1l.1-.2s.1-.1.1-.2c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.2 0 0 .1-.3.1-.6.2-.3-.1-.6-.1-.6z",
    className: "st2"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "rect4127",
    d: "M49.7 36.5h.9v.2h-.9z",
    className: "st3"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "rect4129",
    d: "M49.7 36.5h.9v.2h-.9z",
    className: "st2"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "path4131",
    d: "M54.8 40.5c0-.3.3-.6.6-.6s.6.3.6.6-.3.5-.6.5c-.4 0-.6-.2-.6-.5",
    className: "st7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4135",
    d: "M10 0h9.9v58.8H10z",
    style: {
      fill: "#fded00"
    }
  }), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "rect4137",
    d: "M10 0h9.9v14.8H10z",
    className: "st64"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "rect4139",
    d: "M10 44h9.9v14.8H10z",
    className: "st64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4143",
    d: "M.1 0h9.8v58.8H.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#001689"
    }
  }), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4145",
    d: "m6.1 20.3-1.6 1.1.6-1.8-1.6-1.2h2l.6-1.8.6 1.8h1.9L7 19.6l.6 1.8z",
    className: "st66"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4147",
    d: "m6.1 41.1-1.6 1.1.6-1.8-1.6-1.2h2l.6-1.8.6 1.8h1.9L7 40.4l.6 1.8z",
    className: "st66"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "polygon4149",
    d: "m4.1 30.7-1.6 1.1.6-1.8-1.6-1.2h2l.6-1.8.6 1.8h1.9L5 30l.7 1.8z",
    className: "st66"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g4189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4157",
    d: "M80.2 24.3h1.7v2.1c-.6.3-1.2.4-1.8.4-.8 0-1.5-.2-2-.7-.5-.5-.7-1.1-.7-1.8s.3-1.4.8-1.9 1.1-.7 1.9-.7c.3 0 .5 0 .8.1.3.1.6.2 1 .3v.7c-.6-.3-1.2-.5-1.8-.5-.5 0-1 .2-1.4.6-.4.4-.6.8-.6 1.4 0 .6.2 1 .6 1.4.4.4.9.5 1.4.5.3 0 .6-.1 1-.2h.1v-1h-1z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4159",
    d: "M85.5 21.7c.8 0 1.4.2 1.9.7.5.5.8 1.1.8 1.8s-.3 1.3-.8 1.8-1.2.7-1.9.7-1.4-.2-1.9-.7c-.5-.5-.7-1.1-.7-1.8s.3-1.4.8-1.8c.4-.5 1-.7 1.8-.7zm0 .7c-.6 0-1 .2-1.4.5-.4.4-.5.8-.5 1.4 0 .5.2 1 .5 1.3.4.4.8.5 1.4.5.6 0 1-.2 1.4-.5.4-.4.6-.8.6-1.4 0-.5-.2-1-.6-1.3-.4-.4-.8-.5-1.4-.5z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4161",
    d: "M90.9 26.7h-1.7v-5h1.3c.4 0 .7.1 1 .2.2.1.4.3.5.5.1.2.2.4.2.7 0 .5-.3.8-.8 1 .4.1.7.2.9.4.2.2.3.5.3.8 0 .3-.1.5-.2.7-.1.2-.3.4-.6.5-.2.2-.6.2-.9.2zm-.4-4.3h-.6v1.5h.5c.4 0 .6-.1.8-.2.2-.1.2-.3.2-.6 0-.5-.3-.7-.9-.7zm.1 2.1h-.7v1.6h.7c.4 0 .7 0 .8-.1l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4-.1-.1-.2-.2-.4-.3-.1-.1-.4-.1-.7-.1z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4163",
    d: "M93.4 21.8h.7v5h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4165",
    d: "M95.3 21.8h2.8v.6H96v1.5h2v.6h-2V26h2.2v.6h-2.9v-4.8z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4167",
    d: "M99.1 26.7v-5h1.2c.5 0 .9.1 1.2.4.3.2.4.6.4 1 0 .3-.1.5-.2.7-.1.2-.4.4-.6.5.2.1.3.2.5.4s.4.5.6.9c.2.3.3.5.4.6l.3.4h-.8l-.2-.3v-.1l-.1-.2-.2-.4-.2-.4c-.1-.2-.3-.4-.4-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.2v2.2h-.9zm1-4.3h-.2V24h.3c.4 0 .6 0 .7-.1l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4l-.3-.3c-.2-.1-.5-.1-.8-.1z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4169",
    d: "M107.6 21.8h.7v5h-.6l-3.3-3.8v3.8h-.7v-5h.6l3.3 3.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4171",
    d: "M111.9 21.7c.8 0 1.4.2 1.9.7.5.5.8 1.1.8 1.8s-.3 1.3-.8 1.8-1.2.7-1.9.7-1.4-.2-1.9-.7c-.5-.5-.7-1.1-.7-1.8s.3-1.4.8-1.8c.4-.5 1-.7 1.8-.7zm0 .7c-.6 0-1 .2-1.4.5-.4.4-.5.8-.5 1.4 0 .5.2 1 .5 1.3.4.4.8.5 1.4.5.6 0 1-.2 1.4-.5.4-.4.6-.8.6-1.4 0-.5-.2-1-.6-1.3-.4-.4-.9-.5-1.4-.5z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4173",
    d: "M77.6 34.5v-5h1.7c.7 0 1.2.1 1.6.3.4.2.7.5.9.9.2.4.3.8.3 1.3 0 .3-.1.6-.2 1-.1.3-.3.6-.5.8-.2.2-.5.4-.8.5-.2.1-.4.1-.5.1h-2.5zm1.6-4.4h-.9v3.7h.9c.4 0 .6 0 .8-.1.2 0 .4-.1.5-.2.1-.1.3-.2.4-.3.4-.4.5-.8.5-1.3s-.2-1-.5-1.3c-.1-.1-.3-.2-.5-.3-.2-.1-.3-.1-.5-.2h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4175",
    d: "M83.1 29.5H86v.6h-2.1v1.5h2v.6h-2v1.5H86v.6h-2.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4177",
    d: "M89.1 29.5h2.8v.6h-2.1v1.5h2v.6h-2v1.5H92v.6h-2.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4179",
    d: "m94 32.4-.5-.3c-.3-.2-.6-.4-.7-.6-.1-.2-.2-.4-.2-.7 0-.4.1-.7.4-1 .3-.2.6-.4 1.1-.4.4 0 .8.1 1.1.3v.8c-.4-.3-.7-.5-1.2-.5-.2 0-.4.1-.6.2-.1.1-.2.2-.2.4 0 .1.1.3.2.4.1.1.3.3.5.4l.5.3c.6.4.9.8.9 1.4 0 .4-.1.7-.4 1-.3.2-.6.4-1 .4-.5 0-.9-.2-1.3-.5v-.9c.4.5.8.7 1.3.7.2 0 .4-.1.6-.2.1-.1.2-.3.2-.5s-.2-.4-.7-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4181",
    d: "M96.2 34.5v-5h1.6c.5 0 .9.1 1.1.4.3.3.4.6.4 1 0 .3-.1.5-.2.8-.1.2-.3.4-.6.5-.3.1-.6.2-1.1.2h-.5v2.2zm1.5-4.4H97v1.6h.8c.3 0 .5-.1.7-.2.2-.1.2-.3.2-.6-.1-.5-.4-.8-1-.8z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4183",
    d: "M101.1 29.5h.5l2.2 5h-.7l-.7-1.5h-2.1l-.6 1.5H99Zm1 2.9-.8-1.8-.7 1.8z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4185",
    d: "M108.4 29.5h.7v5h-.6l-3.3-3.8v3.8h-.7v-5h.6l3.3 3.9zm-.5-1.4c0 .3-.1.5-.2.7-.1.1-.2.2-.4.2-.1 0-.3 0-.5-.1s-.4-.1-.5-.1c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2h-.3c0-.3.1-.6.2-.7.1-.1.2-.2.4-.2.1 0 .4.1.7.2.2.1.3.1.3.1.1 0 .1 0 .2-.1s.1-.1.1-.2h.3z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4187",
    d: "M111.9 29.5h.5l2.2 5h-.7l-.7-1.5h-2.1l-.6 1.5h-.7zm1 2.9-.8-1.8-.7 1.8z",
    className: "st67"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g4229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4191",
    d: "M138.7 21.8h.7v5h-.7v-3.9l-1.5 1.9h-.2l-1.5-1.9v3.9h-.7v-5h.7l1.6 2z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4193",
    d: "M140.5 21.8h.7v5h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4195",
    d: "M146.4 21.8h.7v5h-.6l-3.3-3.8v3.8h-.7v-5h.6l3.3 3.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197",
    d: "M148.3 21.8h.7v5h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4199",
    d: "m151.4 24.6-.5-.3c-.3-.2-.6-.4-.7-.6-.1-.2-.2-.4-.2-.7 0-.4.1-.7.4-1 .3-.2.6-.4 1.1-.4.4 0 .8.1 1.1.3v.8c-.4-.3-.7-.5-1.2-.5-.2 0-.4.1-.6.2-.1.1-.2.2-.2.4 0 .1.1.3.2.4.1.1.3.3.5.4l.5.3c.6.4.9.8.9 1.4 0 .4-.1.7-.4 1-.3.2-.6.4-1 .4-.5 0-.9-.2-1.3-.5v-.9c.4.5.8.7 1.3.7.2 0 .4-.1.6-.2.1-.1.2-.3.2-.5 0-.1-.2-.4-.7-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4201",
    d: "M153.2 21.7h4.1v.6h-1.7v4.3h-.7v-4.3h-1.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4203",
    d: "M158.2 21.8h2.8v.6h-2.1v1.5h2v.6h-2V26h2.2v.6h-2.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4205",
    d: "M162 26.7v-5h1.2c.5 0 .9.1 1.2.4.3.2.4.6.4 1 0 .3-.1.5-.2.7-.1.2-.4.4-.6.5.2.1.3.2.5.4s.4.5.6.9c.2.3.3.5.4.6l.3.4h-.8l-.2-.3v-.1l-.1-.2-.2-.4-.2-.4c-.1-.2-.3-.4-.4-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.2v2.2h-.9Zm.9-4.3h-.2V24h.3c.4 0 .6 0 .7-.1l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4l-.3-.3c-.2-.1-.5-.1-.8-.1z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4207",
    d: "M166.5 21.8h.7v5h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4209",
    d: "M170.8 21.7c.8 0 1.4.2 1.9.7.5.5.8 1.1.8 1.8s-.3 1.3-.8 1.8-1.2.7-1.9.7-1.4-.2-1.9-.7c-.5-.5-.7-1.1-.7-1.8s.3-1.4.8-1.8c.4-.5 1.1-.7 1.8-.7zm.1.7c-.6 0-1 .2-1.4.5-.4.4-.5.8-.5 1.4 0 .5.2 1 .5 1.3.4.4.8.5 1.4.5.6 0 1-.2 1.4-.5.4-.4.6-.8.6-1.4 0-.5-.2-1-.6-1.3-.4-.4-.9-.5-1.4-.5z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4211",
    d: "M134.7 34.5v-5h1.7c.7 0 1.2.1 1.6.3.4.2.7.5.9.9.2.4.3.8.3 1.3 0 .3-.1.6-.2 1-.1.3-.3.6-.5.8-.2.2-.5.4-.8.5-.2.1-.4.1-.5.1h-2.5zm1.6-4.4h-.9v3.7h.9c.4 0 .6 0 .8-.1.2 0 .4-.1.5-.2.1-.1.3-.2.4-.3.4-.4.5-.8.5-1.3s-.2-1-.5-1.3c-.1-.1-.3-.2-.5-.3-.2-.1-.3-.1-.5-.2h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4213",
    d: "M140.3 29.5h2.8v.6H141v1.5h2v.6h-2v1.5h2.2v.6h-2.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4215",
    d: "M146.2 34.5v-5h1.7c.7 0 1.2.1 1.6.3.4.2.7.5.9.9.2.4.3.8.3 1.3 0 .3-.1.6-.2 1-.1.3-.3.6-.5.8-.2.2-.5.4-.8.5-.2.1-.4.1-.5.1h-2.5zm1.6-4.4h-.9v3.7h.9c.4 0 .6 0 .8-.1.2 0 .4-.1.5-.2.1-.1.3-.2.4-.3.4-.4.5-.8.5-1.3s-.2-1-.5-1.3c-.1-.1-.3-.2-.5-.3-.2-.1-.3-.1-.5-.2h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4217",
    d: "M151.8 29.5h2.8v.6h-2.1v1.5h2v.6h-2v1.5h2.2v.6h-2.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4219",
    d: "M155.5 29.5h2.6v.6h-1.9v1.4h1.9v.6h-1.9v2.3h-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4221",
    d: "M159.1 29.5h2.8v.6h-2.1v1.5h2v.6h-2v1.5h2.2v.6h-2.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4223",
    d: "M166.8 29.5h.7v5h-.6l-3.3-3.8v3.8h-.7v-5h.6l3.3 3.9z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4225",
    d: "m169.9 32.4-.5-.3c-.3-.2-.6-.4-.7-.6-.1-.2-.2-.4-.2-.7 0-.4.1-.7.4-1 .3-.2.6-.4 1.1-.4.4 0 .8.1 1.1.3v.8c-.4-.3-.7-.5-1.2-.5-.2 0-.4.1-.6.2-.1.1-.2.2-.2.4 0 .1.1.3.2.4.1.1.3.3.5.4l.5.3c.6.4.9.8.9 1.4 0 .4-.1.7-.4 1-.3.2-.6.4-1 .4-.5 0-.9-.2-1.3-.5v-.9c.4.5.8.7 1.3.7.2 0 .4-.1.6-.2.1-.1.2-.3.2-.5-.1-.2-.3-.4-.7-.7z",
    className: "st67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4227",
    d: "M173.7 29.5h.5l2.2 5h-.7L175 33h-2.1l-.6 1.5h-.7zm1 2.9-.8-1.8-.7 1.8z",
    className: "st67"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g4378",
    transform: "translate(124)"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "g4361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4235",
    d: "M419.3 24.2V12h1.6v12.1h-1.6z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4237",
    d: "M422.9 24.2v-8.9h1.3l.1 1h.1c.3-.4.6-.6 1-.8.4-.2.8-.3 1.3-.3s.9.1 1.2.3c.4.2.7.5.9.9.2.4.3 1 .3 1.7v6.1h-1.6v-6c0-.6-.1-1-.4-1.3-.2-.2-.6-.3-1-.3-.2 0-.4 0-.6.1l-.6.3c-.2.2-.4.4-.5.6v6.6h-1.5z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4239",
    d: "M430.2 16.5v-1.3h5.3v1.3zm1.5 7.7V13.8c0-.7.1-1.2.3-1.6.2-.4.6-.8 1-1 .4-.2 1-.3 1.7-.3h.5c.2 0 .4 0 .5.1v1.3c-.2 0-.3 0-.4-.1h-.4c-.6 0-1 .1-1.3.4-.3.3-.4.7-.4 1.2v10.5z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4241",
    d: "M436.2 24.2v-8.9h1.3l.1 1.2h.1c.3-.5.6-.8 1-1 .4-.2.8-.3 1.3-.3h.5v1.5h-.6c-.3 0-.5 0-.8.1-.3.1-.5.2-.7.4-.2.2-.4.4-.5.6v6.4z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4243",
    d: "M443.3 24.3c-.7 0-1.3-.2-1.7-.6-.4-.4-.7-1-.7-1.8s.2-1.4.7-1.9c.5-.5 1.3-.7 2.3-.8l1.8-.2.2 1-1.9.2c-.5 0-1 .2-1.2.5-.3.3-.4.6-.4 1.1 0 .5.1.8.4 1.1.2.2.6.3 1 .3.3 0 .5-.1.8-.2.3-.1.6-.4.8-.7v-3.9c0-.5-.1-.8-.2-1.1-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1.1-.2-.3 0-.6 0-1 .1s-.7.1-1.1.3v-1.3c.3-.1.7-.2 1.1-.3.4-.1.8-.1 1.2-.1.7 0 1.3.1 1.8.3.5.2.8.5 1.1 1 .2.5.3 1.1.3 1.9v5.8h-1.3l-.1-1h-.1c-.2.4-.5.7-.9.8-.4.2-.8.3-1.2.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4245",
    d: "M452.3 24.3c-.9 0-1.6-.2-2.2-.5-.6-.3-1-.8-1.3-1.5-.3-.7-.4-1.6-.4-2.7s.1-1.9.4-2.6c.3-.7.7-1.2 1.1-1.5.5-.3 1.1-.5 1.8-.5s1.2.2 1.7.5.8.8 1.1 1.5c.2.7.4 1.6.4 2.6v.5h-5.3V19h4l-.3.2c0-.8-.1-1.5-.2-1.9-.1-.4-.3-.8-.6-.9-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.9.3-.3.2-.4.5-.6.9-.1.4-.2 1.1-.2 1.9v.8c0 .8.1 1.4.3 1.8.2.4.4.8.8.9.4.2.8.3 1.4.3.3 0 .6 0 .9-.1.3-.1.7-.1 1-.2V24c-.4.1-.8.2-1.1.2-.3.1-.7.1-1 .1z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4247",
    d: "M458.1 24.3c-.4 0-.7 0-1.1-.1-.4-.1-.7-.1-1-.3v-1.3c.4.1.7.2 1.1.3.3.1.7.1 1 .1.6 0 1-.1 1.3-.3.3-.2.4-.6.4-1s-.1-.7-.3-.8c-.2-.2-.4-.3-.8-.4l-1-.2c-.7-.2-1.2-.5-1.5-.9-.3-.4-.5-.9-.5-1.6 0-.8.3-1.4.8-1.9.6-.5 1.4-.7 2.4-.7.3 0 .7 0 1 .1.3 0 .6.1.8.2v1.3c-.3-.1-.6-.1-.9-.2h-.9c-.4 0-.8.1-1.1.2-.3.1-.5.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.6.3.8.2.2.4.3.8.4l1 .3c.7.2 1.3.5 1.6.9.3.4.5.9.5 1.6 0 .8-.3 1.5-.8 2-.6.1-1.3.3-2.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4249",
    d: "M461.6 16.5v-1.3h5.3v1.3zm4.1 7.8c-.8 0-1.5-.2-2-.7-.5-.5-.7-1.2-.7-2.2v-6.2l.3-3.2h1.3v9.2c0 .7.1 1.1.3 1.4.2.3.6.4 1.1.4h.4c.1 0 .3 0 .5-.1v1.3c-.2 0-.4.1-.6.1h-.6z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4251",
    d: "M468 24.2v-8.9h1.3l.1 1.2h.1c.3-.5.6-.8 1-1 .4-.2.8-.3 1.3-.3h.5v1.5h-.6c-.3 0-.5 0-.8.1-.3.1-.5.2-.7.4-.2.2-.4.4-.5.6v6.4z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4253",
    d: "M475.7 24.3c-.5 0-.9-.1-1.2-.3-.4-.2-.7-.5-.9-.9-.2-.4-.3-1-.3-1.7v-6.1h1.6v6.1c0 .6.1 1 .4 1.2.2.2.6.3.9.3.2 0 .4 0 .6-.1l.6-.3c.2-.1.4-.3.5-.6v-6.6h1.6v8.9h-1.3l-.1-1h-.1c-.3.4-.7.7-1 .8-.5.2-.9.3-1.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4255",
    d: "M484.6 24.3c-.8 0-1.4-.2-2-.5-.5-.3-.9-.8-1.2-1.5-.3-.7-.4-1.6-.4-2.7s.2-2 .5-2.7c.3-.7.8-1.2 1.3-1.5.6-.3 1.3-.5 2.1-.5h.8c.3 0 .5.1.8.1v1.3c-.2-.1-.4-.1-.7-.1h-.6c-.6 0-1.1.1-1.4.3-.4.2-.7.5-.8 1-.2.5-.3 1.1-.3 1.9 0 .8.1 1.5.3 2 .2.5.4.8.8 1 .3.2.7.3 1.2.3.2 0 .5 0 .7-.1.3-.1.5-.1.8-.2V24c-.3.1-.6.2-.9.2-.4.1-.7.1-1 .1z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4257",
    d: "M486.8 16.5v-1.3h5.3v1.3zm4.2 7.8c-.8 0-1.5-.2-2-.7-.5-.5-.7-1.2-.7-2.2v-6.2l.3-3.2h1.3v9.2c0 .7.1 1.1.3 1.4.2.3.6.4 1.1.4h.4c.1 0 .3 0 .5-.1v1.3c-.2 0-.4.1-.6.1h-.6z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4259",
    d: "M495.6 24.3c-.5 0-.9-.1-1.2-.3-.4-.2-.7-.5-.9-.9-.2-.4-.3-1-.3-1.7v-6.1h1.6v6.1c0 .6.1 1 .4 1.2.2.2.6.3.9.3.2 0 .4 0 .6-.1l.6-.3c.2-.1.4-.3.5-.6v-6.6h1.6v8.9h-1.3l-.1-1h-.1c-.3.4-.7.7-1 .8-.4.2-.8.3-1.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4261",
    d: "M501.4 24.2v-8.9h1.3l.1 1.2h.1c.3-.5.6-.8 1-1 .4-.2.8-.3 1.3-.3h.5v1.5h-.6c-.3 0-.5 0-.8.1-.3.1-.5.2-.7.4-.2.2-.4.4-.5.6v6.4z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4263",
    d: "M508.4 24.3c-.7 0-1.3-.2-1.7-.6-.4-.4-.7-1-.7-1.8s.2-1.4.7-1.9c.5-.5 1.3-.7 2.3-.8l1.8-.2.2 1-1.9.2c-.5 0-1 .2-1.2.5-.3.3-.4.6-.4 1.1 0 .5.1.8.4 1.1.2.2.6.3 1 .3.3 0 .5-.1.8-.2.3-.1.6-.4.8-.7v-3.9c0-.5-.1-.8-.2-1.1-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1.1-.2-.3 0-.6 0-1 .1s-.7.1-1.1.3v-1.3c.3-.1.7-.2 1.1-.3.4-.1.8-.1 1.2-.1.7 0 1.3.1 1.8.3.5.2.8.5 1.1 1 .2.5.3 1.1.3 1.9v5.8h-1.3l-.1-1h-.1c-.2.4-.5.7-.9.8-.3.2-.7.3-1.2.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4265",
    d: "M520.1 24.3c-.5 0-1-.1-1.5-.4-.5-.3-.8-.8-1.1-1.4-.3-.6-.4-1.5-.4-2.6s.2-2 .5-2.7c.3-.7.8-1.2 1.4-1.6.6-.3 1.4-.5 2.3-.5h.8v-4.3h1.6v13.3h-1.4l-.1-.9h-.1c-.2.3-.4.6-.8.8-.3.2-.7.3-1.2.3zm.4-1.3c.3 0 .6-.1.8-.2.3-.1.5-.4.7-.6v-5.6c-.1 0-.3 0-.5-.1h-.5c-.8 0-1.4.2-1.8.7-.4.5-.6 1.4-.6 2.6 0 .9.1 1.6.2 2 .2.5.4.8.7 1 .4.1.7.2 1 .2z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4267",
    d: "M529 24.3c-.9 0-1.6-.2-2.2-.5-.6-.3-1-.8-1.3-1.5-.3-.7-.4-1.6-.4-2.7s.1-1.9.4-2.6c.3-.7.7-1.2 1.1-1.5.5-.3 1.1-.5 1.8-.5s1.2.2 1.7.5.8.8 1.1 1.5c.2.7.4 1.6.4 2.6v.5h-5.3V19h4l-.3.2c0-.8-.1-1.5-.2-1.9-.1-.4-.3-.8-.6-.9-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.9.3-.3.2-.4.5-.6.9-.1.4-.2 1.1-.2 1.9v.8c0 .8.1 1.4.3 1.8.2.4.4.8.8.9.4.2.8.3 1.4.3.3 0 .6 0 .9-.1.3-.1.7-.1 1-.2V24c-.4.1-.8.2-1.1.2-.3.1-.6.1-1 .1z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4269",
    d: "M539.1 24.3h-1.6c-.3 0-.6 0-.9-.1v-12c.3-.1.6-.1.9-.1.3 0 .6-.1.9-.1h1c1.8 0 3.2.5 4.1 1.5.9 1 1.4 2.6 1.4 4.7 0 1.5-.2 2.6-.7 3.5-.4.9-1.1 1.6-1.9 2-.8.4-1.9.6-3.2.6zm.4-1.4c.8 0 1.5-.2 2.1-.5.6-.3 1-.8 1.3-1.5.3-.7.4-1.6.4-2.8 0-1.2-.1-2.1-.4-2.8-.3-.7-.7-1.2-1.2-1.5-.5-.3-1.2-.5-2.1-.5h-.7c-.2 0-.5 0-.7.1v9.5H539.5z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4271",
    d: "M548.5 24.3c-.7 0-1.3-.2-1.7-.6-.4-.4-.7-1-.7-1.8s.2-1.4.7-1.9c.5-.5 1.3-.7 2.3-.8l1.8-.2.2 1-1.9.2c-.5 0-1 .2-1.2.5-.3.3-.4.6-.4 1.1 0 .5.1.8.4 1.1.2.2.6.3 1 .3.3 0 .5-.1.8-.2.3-.1.6-.4.8-.7v-3.9c0-.5-.1-.8-.2-1.1-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1.1-.2-.3 0-.6 0-1 .1s-.7.1-1.1.3v-1.3c.3-.1.7-.2 1.1-.3.4-.1.8-.1 1.2-.1.7 0 1.3.1 1.8.3.5.2.8.5 1.1 1 .2.5.3 1.1.3 1.9v5.8h-1.3l-.1-1h-.1c-.2.4-.5.7-.9.8-.4.2-.8.3-1.2.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4273",
    d: "M553 16.5v-1.3h5.3v1.3zm4.2 7.8c-.8 0-1.5-.2-2-.7-.5-.5-.7-1.2-.7-2.2v-6.2l.3-3.2h1.3v9.2c0 .7.1 1.1.3 1.4.2.3.6.4 1.1.4h.4c.1 0 .3 0 .5-.1v1.3c-.2 0-.4.1-.6.1h-.6z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4275",
    d: "M562.4 24.3c-.7 0-1.3-.2-1.8-.5s-.9-.8-1.2-1.5c-.3-.7-.4-1.6-.4-2.6 0-1.1.1-2 .4-2.7.3-.7.7-1.2 1.2-1.5.5-.3 1.1-.5 1.8-.5s1.3.2 1.8.5.9.8 1.2 1.5c.3.7.4 1.6.4 2.7s-.1 2-.4 2.7c-.3.7-.7 1.2-1.2 1.5-.4.3-1.1.4-1.8.4zm0-1.2c.4 0 .7-.1 1-.3.3-.2.5-.5.6-1a10.61 10.61 0 0 0 0-4.1c-.1-.5-.4-.8-.6-1-.3-.2-.6-.3-1-.3s-.7.1-1 .3c-.3.2-.5.5-.6 1-.1.5-.2 1.2-.2 2.1 0 .9.1 1.6.2 2.1s.4.8.6 1c.3.1.7.2 1 .2z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4277",
    d: "M569.2 24.3c-.4 0-.7 0-1.1-.1-.4-.1-.7-.1-1-.3v-1.3c.4.1.7.2 1.1.3.3.1.7.1 1 .1.6 0 1-.1 1.3-.3.3-.2.4-.6.4-1s-.1-.7-.3-.8c-.2-.2-.4-.3-.8-.4l-1-.2c-.7-.2-1.2-.5-1.5-.9-.3-.4-.5-.9-.5-1.6 0-.8.3-1.4.8-1.9.6-.5 1.4-.7 2.4-.7.3 0 .7 0 1 .1.3 0 .6.1.8.2v1.3c-.3-.1-.6-.1-.9-.2h-.9c-.4 0-.8.1-1.1.2-.3.1-.5.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.6.3.8.2.2.4.3.8.4l1 .3c.7.2 1.3.5 1.6.9.3.4.5.9.5 1.6 0 .8-.3 1.5-.8 2-.5.1-1.3.3-2.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4279",
    d: "M577.4 24.2V12h6.8v1.4H579v9.3h5.3v1.4h-6.9zm1.2-5.5v-1.4h4.8v1.4z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4281",
    d: "M587.2 24.3c-.4 0-.7 0-1.1-.1-.4-.1-.7-.1-1-.3v-1.3c.4.1.7.2 1.1.3.3.1.7.1 1 .1.6 0 1-.1 1.3-.3.3-.2.4-.6.4-1s-.1-.7-.3-.8c-.2-.2-.4-.3-.8-.4l-1-.2c-.7-.2-1.2-.5-1.5-.9-.3-.4-.5-.9-.5-1.6 0-.8.3-1.4.8-1.9.6-.5 1.4-.7 2.4-.7.3 0 .7 0 1 .1.3 0 .6.1.8.2v1.3c-.3-.1-.6-.1-.9-.2h-.9c-.4 0-.8.1-1.1.2-.3.1-.5.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.6.3.8.2.2.4.3.8.4l1 .3c.7.2 1.3.5 1.6.9.3.4.5.9.5 1.6 0 .8-.3 1.5-.8 2s-1.3.3-2.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4283",
    d: "M591.7 27.8V15.3h1.4l.1.9h.1c.2-.3.4-.6.8-.8.3-.2.7-.3 1.2-.3s1 .1 1.5.4c.5.3.8.8 1.1 1.4.3.6.4 1.5.4 2.6s-.2 2-.5 2.7c-.3.7-.8 1.2-1.4 1.6-.6.3-1.4.5-2.3.5h-.8v3.5h-1.6zm2.6-4.7c.8 0 1.4-.2 1.8-.7.4-.5.6-1.4.6-2.6 0-.9-.1-1.6-.2-2-.2-.5-.4-.8-.7-1-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.8.2-.2.1-.5.4-.7.6V23c.1 0 .3 0 .5.1h.4z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4285",
    d: "M601.8 24.3c-.7 0-1.3-.2-1.7-.6-.4-.4-.7-1-.7-1.8s.2-1.4.7-1.9c.5-.5 1.3-.7 2.3-.8l1.8-.2.2 1-1.9.2c-.5 0-1 .2-1.2.5-.3.3-.4.6-.4 1.1 0 .5.1.8.4 1.1.2.2.6.3 1 .3.3 0 .5-.1.8-.2.3-.1.6-.4.8-.7v-3.9c0-.5-.1-.8-.2-1.1-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1.1-.2-.3 0-.6 0-1 .1s-.7.1-1.1.3v-1.3c.3-.1.7-.2 1.1-.3.4-.1.8-.1 1.2-.1.7 0 1.3.1 1.8.3.5.2.8.5 1.1 1 .2.5.3 1.1.3 1.9v5.8h-1.3l-.1-1c-.2.4-.5.7-.9.8-.4.2-.8.3-1.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4287",
    d: "M610.5 24.3c-.8 0-1.4-.2-2-.5-.5-.3-.9-.8-1.2-1.5-.3-.7-.4-1.6-.4-2.7s.2-2 .5-2.7c.3-.7.8-1.2 1.3-1.5.6-.3 1.3-.5 2.1-.5h.8c.3 0 .5.1.8.1v1.3c-.2-.1-.4-.1-.7-.1h-.6c-.6 0-1.1.1-1.4.3-.4.2-.7.5-.8 1-.2.5-.3 1.1-.3 1.9 0 .8.1 1.5.3 2 .2.5.4.8.8 1 .3.2.7.3 1.2.3.2 0 .5 0 .7-.1.3-.1.5-.1.8-.2V24c-.3.1-.6.2-.9.2-.4.1-.7.1-1 .1z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4289",
    d: "M614.4 13.5c-.3 0-.6-.1-.8-.3-.2-.2-.3-.4-.3-.7 0-.3.1-.6.3-.7.2-.2.4-.3.8-.3s.6.1.8.3c.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.8.3zm-.8 10.7v-8.9h1.6v8.9z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4291",
    d: "M619.1 24.3c-.7 0-1.3-.2-1.7-.6-.4-.4-.7-1-.7-1.8s.2-1.4.7-1.9c.5-.5 1.3-.7 2.3-.8l1.8-.2.2 1-1.9.2c-.5 0-1 .2-1.2.5-.3.3-.4.6-.4 1.1 0 .5.1.8.4 1.1.2.2.6.3 1 .3.3 0 .5-.1.8-.2.3-.1.6-.4.8-.7v-3.9c0-.5-.1-.8-.2-1.1-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1.1-.2-.3 0-.6 0-1 .1s-.7.1-1.1.3v-1.3c.3-.1.7-.2 1.1-.3.4-.1.8-.1 1.2-.1.7 0 1.3.1 1.8.3.5.2.8.5 1.1 1 .2.5.3 1.1.3 1.9v5.8h-1.3l-.1-1h-.1c-.2.4-.5.7-.9.8-.3.2-.7.3-1.2.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4293",
    d: "M624.7 24.2V10.9h1.6v13.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4295",
    d: "M631.7 24.3c-.9 0-1.6-.2-2.2-.5-.6-.3-1-.8-1.3-1.5-.3-.7-.4-1.6-.4-2.7s.1-1.9.4-2.6c.3-.7.7-1.2 1.1-1.5.5-.3 1.1-.5 1.8-.5s1.2.2 1.7.5.8.8 1.1 1.5c.2.7.4 1.6.4 2.6v.5H629V19h4l-.3.2c0-.8-.1-1.5-.2-1.9-.1-.4-.3-.8-.6-.9-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.9.3-.3.2-.4.5-.6.9-.1.4-.2 1.1-.2 1.9v.8c0 .8.1 1.4.3 1.8.2.4.4.8.8.9.4.2.8.3 1.4.3.3 0 .6 0 .9-.1.3-.1.7-.1 1-.2V24c-.4.1-.8.2-1.1.2-.4.1-.7.1-1 .1z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4297",
    d: "M637.4 24.3c-.4 0-.7 0-1.1-.1-.4-.1-.7-.1-1-.3v-1.3c.4.1.7.2 1.1.3.3.1.7.1 1 .1.6 0 1-.1 1.3-.3.3-.2.4-.6.4-1s-.1-.7-.3-.8c-.2-.2-.4-.3-.8-.4l-1-.2c-.7-.2-1.2-.5-1.5-.9-.3-.4-.5-.9-.5-1.6 0-.8.3-1.4.8-1.9.6-.5 1.4-.7 2.4-.7.3 0 .7 0 1 .1.3 0 .6.1.8.2v1.3c-.3-.1-.6-.1-.9-.2h-.9c-.4 0-.8.1-1.1.2-.3.1-.5.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.6.3.8.2.2.4.3.8.4l1 .3c.7.2 1.3.5 1.6.9.3.4.5.9.5 1.6 0 .8-.3 1.5-.8 2-.5.1-1.3.3-2.3.3z",
    className: "st68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4299",
    d: "M419 45.1V33h2.9v12.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4301",
    d: "M423.4 45.1v-9h2.3l.2.9h.1c.3-.4.6-.6 1-.8.4-.2.8-.3 1.2-.3.5 0 .9.1 1.3.3.4.2.7.6.9 1 .2.5.3 1.1.3 1.9V45H428v-5.7c0-.4-.1-.6-.2-.8-.1-.1-.3-.2-.6-.2-.1 0-.2 0-.4.1-.1 0-.2.1-.4.2l-.3.3v6.2h-2.7z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4303",
    d: "M434.5 45.3c-.4 0-.9 0-1.3-.1l-1.2-.3v-2.2c.4.1.7.2 1.1.3.4.1.8.1 1.2.1.4 0 .7-.1.9-.2.2-.1.3-.3.3-.5s0-.3-.1-.4c-.1-.1-.2-.2-.4-.2l-1.2-.3c-.7-.2-1.2-.4-1.5-.9-.4-.4-.5-1-.5-1.8 0-.9.3-1.6 1-2.1.6-.5 1.6-.8 2.9-.8.4 0 .8 0 1.1.1.3 0 .7.1 1 .2v2.2c-.3-.1-.6-.1-.9-.2-.3 0-.6-.1-1-.1s-.7 0-.9.1c-.2.1-.4.2-.4.3-.1.1-.1.2-.1.3 0 .1 0 .3.1.3.1.1.2.1.4.2l1.2.3c.7.2 1.2.4 1.5.8.3.4.5 1 .5 1.7 0 .9-.3 1.6-1 2.2-.7.7-1.6 1-2.7 1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4305",
    d: "M438.2 38.3v-2.2h6v2.2zm4.5 7c-1 0-1.8-.3-2.4-.8-.6-.5-.8-1.4-.8-2.7v-5.7l.5-3.1h2.3v8.5c0 .5.1.9.3 1.1.2.2.5.3.9.3h.4c.1 0 .3 0 .4-.1v2.3c-.2.1-.4.1-.7.1-.3.1-.6.1-.9.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4307",
    d: "M446.7 35c-.6 0-1-.1-1.3-.4-.3-.3-.4-.7-.4-1.1 0-.5.1-.9.4-1.1.3-.2.7-.4 1.3-.4.6 0 1 .1 1.3.4.3.3.4.7.4 1.1 0 .5-.1.9-.4 1.1-.3.3-.7.4-1.3.4zm-1.4 10.1v-9h2.8v9z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4309",
    d: "M448.8 38.3v-2.2h6v2.2zm4.5 7c-1 0-1.8-.3-2.4-.8-.6-.5-.8-1.4-.8-2.7v-5.7l.5-3.1h2.3v8.5c0 .5.1.9.3 1.1.2.2.5.3.9.3h.4c.1 0 .3 0 .4-.1v2.3c-.2.1-.4.1-.7.1-.4.1-.7.1-.9.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4311",
    d: "M458.3 45.3c-.5 0-.9-.1-1.3-.3-.4-.2-.7-.6-.9-1-.2-.5-.3-1.1-.3-1.9v-5.9h2.8v5.7c0 .4.1.6.2.8.1.1.3.2.5.2.1 0 .2 0 .3-.1.1 0 .2-.1.4-.2l.3-.3v-6.2h2.8v9h-2.3l-.2-.9h-.1c-.3.4-.6.6-1 .8-.4.2-.8.3-1.2.3z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4313",
    d: "M463.9 38.3v-2.2h6v2.2zm4.5 7c-1 0-1.8-.3-2.4-.8-.6-.5-.8-1.4-.8-2.7v-5.7l.5-3.1h2.3v8.5c0 .5.1.9.3 1.1.2.2.5.3.9.3h.4c.1 0 .3 0 .4-.1v2.3c-.2.1-.4.1-.7.1-.3.1-.6.1-.9.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4315",
    d: "M474.4 45.3c-.8 0-1.5-.2-2.1-.5-.6-.3-1-.8-1.3-1.5-.3-.7-.5-1.6-.5-2.6 0-1.1.2-2 .5-2.7.3-.7.7-1.2 1.3-1.5.6-.3 1.3-.5 2.1-.5s1.5.2 2.1.5c.6.3 1 .9 1.3 1.6.3.7.5 1.6.5 2.6 0 1.1-.2 1.9-.5 2.6-.3.7-.8 1.2-1.3 1.5-.6.3-1.3.5-2.1.5zm0-2.1c.2 0 .4-.1.6-.2.2-.1.3-.4.3-.7.1-.4.1-.9.1-1.6 0-.7 0-1.3-.1-1.7-.1-.4-.2-.6-.4-.8-.2-.1-.3-.2-.6-.2-.2 0-.4.1-.6.2-.2.1-.3.4-.4.8-.1.4-.1.9-.1 1.6 0 .7 0 1.3.1 1.6.1.4.2.6.3.7.4.2.6.3.8.3z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4317",
    d: "M483.1 45.1V33h2.9v4.6h3.7V33h2.9v12.1h-2.9v-4.9H486v4.9z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4319",
    d: "M495.5 35c-.6 0-1-.1-1.3-.4-.3-.3-.4-.7-.4-1.1 0-.5.1-.9.4-1.1.3-.2.7-.4 1.3-.4.6 0 1 .1 1.3.4.3.3.4.7.4 1.1 0 .5-.1.9-.4 1.1-.3.3-.7.4-1.3.4zM494 45.1v-9h2.8v9z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4321",
    d: "M501.1 45.3c-.6 0-1.1-.2-1.6-.5s-.9-.8-1.2-1.5c-.3-.7-.4-1.5-.4-2.6 0-1 .2-1.9.5-2.6.3-.7.8-1.3 1.5-1.6.7-.4 1.6-.5 2.7-.5h.2v-4.1h2.8v13.3h-2.4l-.2-1c-.2.4-.4.6-.7.8-.3.2-.7.3-1.2.3zm1-2.4c.2 0 .3 0 .5-.1.1-.1.3-.1.4-.2v-4.4h-.5c-.5 0-.9.2-1.2.5-.3.3-.4 1-.4 1.9 0 .7.1 1.2.2 1.5.1.3.2.6.4.7.1.1.3.1.6.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4323",
    d: "M507.1 45.1v-9h2.3l.2 1.3h.1c.2-.5.5-.9.8-1.1.4-.2.8-.3 1.2-.3h.6v2.6c-.1 0-.3 0-.4-.1h-.4c-.2 0-.5 0-.7.1-.2.1-.4.1-.6.3-.2.1-.3.2-.4.4v5.8z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4325",
    d: "M516.8 45.3c-.8 0-1.5-.2-2.1-.5-.6-.3-1-.8-1.3-1.5-.3-.7-.5-1.6-.5-2.6 0-1.1.2-2 .5-2.7.3-.7.7-1.2 1.3-1.5.6-.3 1.3-.5 2.1-.5s1.5.2 2.1.5c.6.3 1 .9 1.3 1.6.3.7.5 1.6.5 2.6 0 1.1-.2 1.9-.5 2.6-.3.7-.8 1.2-1.3 1.5-.5.3-1.2.5-2.1.5zm0-2.1c.2 0 .4-.1.6-.2.2-.1.3-.4.3-.7.1-.4.1-.9.1-1.6 0-.7 0-1.3-.1-1.7-.1-.4-.2-.6-.4-.8-.2-.2-.3-.2-.6-.2-.2 0-.4.1-.6.2-.2.1-.3.4-.4.8-.1.4-.1.9-.1 1.6 0 .7 0 1.3.1 1.6.1.4.2.6.3.7.4.2.6.3.8.3z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4327",
    d: "M524.8 48.9c-.4 0-.8 0-1.2-.1-.5 0-.9-.1-1.3-.2v-2.2c.4.1.8.2 1.1.2.4 0 .8.1 1.1.1.7 0 1.2-.1 1.5-.4.3-.3.5-.8.5-1.5v-.5h-.1c-.2.3-.4.6-.7.8-.3.2-.7.3-1.1.3-.5 0-1-.2-1.4-.5-.5-.3-.8-.8-1.1-1.4-.3-.7-.4-1.5-.4-2.5 0-1.6.4-2.8 1.1-3.6.7-.8 1.9-1.2 3.5-1.2.3 0 .7 0 1.1.1.4 0 .7.1 1.1.2.3.1.7.2 1 .3v7.7c0 1.7-.4 2.9-1.2 3.6-.8.4-2 .8-3.5.8zm1.1-6c.1 0 .3 0 .4-.1.1 0 .2-.1.3-.2v-4.5h-.6c-.5 0-.9.2-1.1.5-.3.3-.4 1-.4 1.9 0 .6 0 1.1.1 1.5.1.3.2.6.4.7.3.1.6.2.9.2z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4329",
    d: "M530.8 45.1v-9h2.3l.2 1.3h.1c.2-.5.5-.9.8-1.1.4-.2.8-.3 1.2-.3h.6v2.6c-.1 0-.3 0-.4-.1h-.4c-.2 0-.5 0-.7.1-.2.1-.4.1-.6.3-.2.1-.3.2-.4.4v5.8z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4331",
    d: "M538.9 45.3c-.7 0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9 0-.9.3-1.6.8-2.1s1.4-.8 2.7-.9l1.2-.1.4 1.6-1.3.1c-.4 0-.6.1-.8.3-.2.2-.3.4-.3.7 0 .3.1.5.2.7.2.1.3.2.6.2.1 0 .3 0 .4-.1.1-.1.3-.2.4-.3v-3.3c0-.3 0-.6-.1-.8-.1-.2-.3-.3-.5-.4-.2-.1-.6-.1-1-.1-.3 0-.7 0-1 .1-.3.1-.7.1-1.1.2v-2.2c.4-.1.8-.2 1.3-.2.5-.1.9-.1 1.4-.1.9 0 1.6.1 2.1.4.6.2 1 .6 1.2 1.2.3.5.4 1.3.4 2.2v5.4h-2.3l-.2-.9h-.1c-.2.4-.5.7-.8.8-.3.1-.7.2-1.1.2zm-.1-10.2 1.6-3.2h2.8l-2 3.2z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4333",
    d: "M544.2 38.3v-2.2h5.9v2.2zm1.2 6.8v-9.6c0-.8.1-1.5.4-2.1.3-.6.7-1 1.3-1.3.6-.3 1.3-.5 2.2-.5h.6c.2 0 .4 0 .6.1V34h-.8c-.6 0-1 .1-1.2.3-.2.2-.4.6-.4 1v9.8z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4335",
    d: "M552.6 35c-.6 0-1-.1-1.3-.4-.3-.3-.4-.7-.4-1.1 0-.5.1-.9.4-1.1.3-.2.7-.4 1.3-.4.6 0 1 .1 1.3.4.3.3.4.7.4 1.1 0 .5-.1.9-.4 1.1-.3.3-.7.4-1.3.4zm-1.4 10.1v-9h2.8v9z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4337",
    d: "M559.2 45.3c-.9 0-1.6-.2-2.3-.5-.6-.3-1.1-.8-1.4-1.5-.3-.7-.5-1.6-.5-2.6 0-1.1.2-2 .5-2.7.4-.7.9-1.2 1.5-1.5.7-.3 1.5-.5 2.4-.5h.8c.3 0 .5.1.8.1v2.3c-.2 0-.4-.1-.6-.1h-.5c-.5 0-.9.1-1.2.2-.3.1-.5.4-.7.7-.2.3 0 .8 0 1.4 0 .6.1 1.1.2 1.4.1.3.3.6.6.7.3.1.6.2 1 .2.2 0 .4 0 .6-.1.2 0 .4-.1.7-.2V45c-.3.1-.6.2-1 .2-.2.1-.5.1-.9.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4339",
    d: "M565.7 45.3c-.8 0-1.5-.2-2.1-.5-.6-.3-1-.8-1.3-1.5-.3-.7-.5-1.6-.5-2.6 0-1.1.2-2 .5-2.7.3-.7.7-1.2 1.3-1.5.6-.3 1.3-.5 2.1-.5s1.5.2 2.1.5c.6.3 1 .9 1.3 1.6.3.7.5 1.6.5 2.6 0 1.1-.2 1.9-.5 2.6-.3.7-.8 1.2-1.3 1.5-.6.3-1.3.5-2.1.5zm0-2.1c.2 0 .4-.1.6-.2.2-.1.3-.4.3-.7.1-.4.1-.9.1-1.6 0-.7 0-1.3-.1-1.7-.1-.4-.2-.6-.4-.8-.2-.1-.3-.2-.6-.2-.2 0-.4.1-.6.2-.2.1-.3.4-.4.8-.1.4-.1.9-.1 1.6 0 .7 0 1.3.1 1.6.1.4.2.6.3.7.4.2.6.3.8.3z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4341",
    d: "M577.1 45.3c-.6 0-1.1-.2-1.6-.5s-.9-.8-1.2-1.5c-.3-.7-.4-1.5-.4-2.6 0-1 .2-1.9.5-2.6.3-.7.8-1.3 1.5-1.6.7-.4 1.6-.5 2.7-.5h.2v-4.1h2.8v13.3h-2.4l-.2-1c-.2.4-.4.6-.7.8-.3.2-.7.3-1.2.3zm1-2.4c.2 0 .3 0 .5-.1.1-.1.3-.1.4-.2v-4.4h-.5c-.5 0-.9.2-1.2.5-.3.3-.4 1-.4 1.9 0 .7.1 1.2.2 1.5.1.3.2.6.4.7.1.1.3.1.6.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4343",
    d: "M587.3 45.3c-1.1 0-1.9-.2-2.6-.5-.7-.3-1.2-.8-1.5-1.5-.3-.7-.5-1.6-.5-2.7 0-1 .1-1.8.4-2.5.3-.7.7-1.2 1.3-1.6.6-.4 1.3-.5 2.1-.5s1.4.2 1.9.5c.5.4.9.9 1.2 1.6.3.7.4 1.6.4 2.6v.8h-5.3v-1.7h3.1l-.4.1c0-.6 0-1-.1-1.3-.1-.3-.2-.5-.3-.6-.1-.1-.3-.2-.5-.2s-.4.1-.5.2c-.1.1-.2.3-.3.6-.1.3-.1.7-.1 1.3v1.3c0 .5.1.9.2 1.1.1.3.3.5.6.6.3.1.7.2 1.2.2.3 0 .7 0 1-.1.3-.1.7-.1 1-.2V45c-.4.1-.8.2-1.2.2-.3.1-.7.1-1.1.1z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4345",
    d: "M594.7 45.1V31.9h2.8v13.3h-2.8z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4347",
    d: "M601.1 45.3c-.7 0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9 0-.9.3-1.6.8-2.1s1.4-.8 2.7-.9l1.2-.1.4 1.6-1.3.1c-.4 0-.6.1-.8.3-.2.2-.3.4-.3.7 0 .3.1.5.2.7.2.1.3.2.6.2.1 0 .3 0 .4-.1.1-.1.3-.2.4-.3v-3.3c0-.3 0-.6-.1-.8-.1-.2-.3-.3-.5-.4-.2-.1-.6-.1-1-.1-.3 0-.7 0-1 .1-.3.1-.7.1-1.1.2v-2.2c.4-.1.8-.2 1.3-.2.5-.1.9-.1 1.4-.1.9 0 1.6.1 2.1.4.6.2 1 .6 1.2 1.2.2.6.4 1.3.4 2.2v5.4h-2.3l-.2-.9h-.1c-.2.4-.5.7-.8.8-.3.1-.7.2-1.1.2z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4349",
    d: "M610.8 45.1V33h3.5l2.8 7.5h-.2l2.7-7.5h3.5v12.1h-2.7v-9.4h.5l-2.9 7.6h-2.2l-3-7.6h.6v9.4z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4351",
    d: "M626.8 45.3c-.7 0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9 0-.9.3-1.6.8-2.1s1.4-.8 2.7-.9l1.2-.1.4 1.6-1.3.1c-.4 0-.6.1-.8.3-.2.2-.3.4-.3.7 0 .3.1.5.2.7.2.1.3.2.6.2.1 0 .3 0 .4-.1.1-.1.3-.2.4-.3v-3.3c0-.3 0-.6-.1-.8-.1-.2-.3-.3-.5-.4-.2-.1-.6-.1-1-.1-.3 0-.7 0-1 .1-.3.1-.7.1-1.1.2v-2.2c.4-.1.8-.2 1.3-.2.5-.1.9-.1 1.4-.1.9 0 1.6.1 2.1.4.6.2 1 .6 1.2 1.2.2.6.4 1.3.4 2.2v5.4H629l-.2-.9h-.1c-.2.4-.5.7-.8.8-.3.1-.7.2-1.1.2z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4353",
    d: "M632.7 45.1v-9h2.3l.2 1.3h.1c.2-.5.5-.9.8-1.1.4-.2.8-.3 1.2-.3h.6v2.6c-.1 0-.3 0-.4-.1h-.4c-.2 0-.5 0-.7.1-.2.1-.4.1-.6.3-.2.1-.3.2-.4.4v5.8z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4355",
    d: "M640.4 35c-.6 0-1-.1-1.3-.4-.3-.3-.4-.7-.4-1.1 0-.5.1-.9.4-1.1.3-.3.7-.4 1.3-.4.6 0 1 .1 1.3.4.3.3.4.7.4 1.1 0 .5-.1.9-.4 1.1-.3.2-.7.4-1.3.4zM639 45.1v-9h2.8v9z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4357",
    d: "M643.3 45.1v-9h2.3l.2.9h.1c.3-.4.6-.6 1-.8.4-.2.8-.3 1.2-.3.5 0 .9.1 1.3.3.4.2.7.6.9 1 .2.5.3 1.1.3 1.9V45h-2.8v-5.7c0-.4-.1-.6-.2-.8-.1-.1-.3-.2-.6-.2-.1 0-.2 0-.4.1-.1 0-.2.1-.4.2l-.3.3v6.2h-2.6z",
    className: "st69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4359",
    d: "M654.2 45.3c-.7 0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9 0-.9.3-1.6.8-2.1s1.4-.8 2.7-.9l1.2-.1.4 1.6-1.3.1c-.4 0-.6.1-.8.3-.2.2-.3.4-.3.7 0 .3.1.5.2.7.2.1.3.2.6.2.1 0 .3 0 .4-.1.1-.1.3-.2.4-.3v-3.3c0-.3 0-.6-.1-.8-.1-.2-.3-.3-.5-.4-.2-.1-.6-.1-1-.1-.3 0-.7 0-1 .1-.3.1-.7.1-1.1.2v-2.2c.4-.1.8-.2 1.3-.2.5-.1.9-.1 1.4-.1.9 0 1.6.1 2.1.4.6.2 1 .6 1.2 1.2.3.5.4 1.3.4 2.2v5.4h-2.3l-.2-.9h-.1c-.2.4-.5.7-.8.8-.2.1-.6.2-1.1.2z",
    className: "st69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4376"
  }, _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "path4363",
    d: "M358 36.8c-2.6 0-5.2.3-8 1.1-.5.1-.7.6-.6 1.1 4 11.5 14.9 19.8 27.8 19.8 11.3 0 21.1-6.4 26-15.8.4-.7-.3-1.4-1-1.2-3.6 1.1-7 1.5-10.3 1.5-12.5.1-22.4-6.5-33.9-6.5z",
    className: "st69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088095385449533399840000003309206723642592173_",
    x1: 377.186,
    x2: 377.186,
    y1: 18.119,
    y2: 57.656,
    gradientTransform: "matrix(1 0 0 -1 0 58.504)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4365",
    offset: 0,
    style: {
      stopColor: "#193062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4367",
    offset: 0.434,
    style: {
      stopColor: "#1b528f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4369",
    offset: 0.792,
    style: {
      stopColor: "#1c68ad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4371",
    offset: 0.994,
    style: {
      stopColor: "#1d71b8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4374",
    d: "M406.3 25c-.1-.4-.3-.7-.7-.8l-27.1-5.6c-.4-.1-.7-.5-.7-.9v-7.5c0-.4.3-.8.7-.9l14.7-3.1c.7-.2.9-1.1.3-1.5-2.3-1.5-4.9-2.7-7.6-3.5-20-5.7-38.1 9.1-38.1 28.1 0 1.4.1 2.7.3 4 .1.6.6.9 1.2.8 2.9-.8 5.7-1.2 8.7-1.2 1 0 2.1.1 3.1.2l1-11.3h-.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h11.2c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-.2l1.2 14.2c.3.1.5.2.8.2 5.4 1.6 10.9 3.3 16.9 3.3 4.5 0 8.9-.9 13.5-2.9.1 0 .2-.1.2-.2s.1-.2.2-.3c.8-3.5 1-7.2.5-11.1zm-33.4-8.3c0 .7-.6 1.2-1.2 1.2h-8.2c-.7 0-1.3-.6-1.3-1.3v-3.2c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3v3.3z",
    style: {
      fill: "url(#SVGID_00000088095385449533399840000003309206723642592173_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4400",
    style: {
      fill: "#193062",
      fillOpacity: 1
    },
    transform: "translate(124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4386",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4380",
    d: "M262.4 45.9V16.3h5.9v29.6z",
    className: "st69",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4382",
    d: "M272.8 45.9V16.3h5.9v11.8h10.2V16.3h5.9v29.6h-5.9V33.5h-10.2v12.4z",
    className: "st69",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4384",
    d: "M299.3 45.9V16.3h7.2l7.6 19.5h-.6l7.4-19.5h7.3v29.6h-5.5V22h1.1L316 41.6h-4.7L303.5 22h1.3v23.9z",
    className: "st69",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4398",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4396",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4388",
    d: "M245 35.4c-.1 3.4-.9 5.6-2.6 8.2 1.6-.1 2.1-.4 1 1.6-.5.7-1.1 1.6-1.7 2-2.1 1.5-5.9 1.6-8 .1-1.6-.9-2.6-2.5-3-4.5h-5c-.4 2-1.5 3.7-3 4.5-2.2 1.5-5.9 1.4-8-.1-.5-.4-1.2-1.2-1.7-2-1.1-2-.6-1.7 1-1.6-1.7-2.6-2.5-5-2.6-8.2-2.1 1.9-3.9 5.2-4.1 8 2.6 0 2.1.7 2.9 2.9.7 1.9 2 3.2 3.5 4.4 2.5 1.9 5.5 2.9 8.2 4 2.5 1 5 2.1 6 3.6.1.1.2.6.2.6s.2-.5.4-.6c.1-.1.2-.4.5-.5 1.2-1.1 3.4-2.1 5.5-3 2.9-1.1 5.7-2.1 8.2-4 1.5-1.1 2.7-2.5 3.5-4.4.9-2.1.2-3 2.9-2.9-.2-3-2-6.3-4.1-8.1z",
    className: "st69",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4392",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4390",
    d: "m235.9 39.2-7.4-12.7c-.2-.4-.6-.4-.9 0l-7.3 12.7c-.2.4 0 .7.4.7h14.7c.5.1.8-.4.5-.7zm-7.7-2.6c-1.1 0-1.9-.9-1.9-1.9 0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9 0 1.1-.9 1.9-1.9 1.9z",
    className: "st69",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4394",
    d: "m243.9 13.2-14-.7v-2.2c2-.7 3.5-2.6 3.5-5 0-2.9-2.4-5.2-5.2-5.2-2.8 0-5.2 2.4-5.2 5.3 0 2.2 1.5 4.2 3.5 5v2.2l-14.1 1.1c-.2 0-.4.2-.4.4v2.1c0 .2.1.4.4.4l13.8.7v6.2c.5-1 1.6-1.4 2.7-1.1.6.1 1 .6 1.4 1.1v-6.2l13.7-1c.2 0 .4-.2.4-.4v-2.2c-.1-.2-.2-.5-.5-.5zM228.2 2.9c1.4 0 2.4 1.1 2.4 2.4 0 1.4-1.1 2.4-2.4 2.4-1.4 0-2.4-1.1-2.4-2.4-.1-1.3 1-2.4 2.4-2.4z",
    className: "st69",
    style: {
      fill: "#193062",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g39142",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M235.135 39.292c.07-.23 1.11-3.599 2.312-7.486l2.185-7.068 1.858.026 1.859.026 2.28 7.383c1.254 4.06 2.28 7.416 2.28 7.457 0 .041-.738.075-1.639.075h-1.638l-.428-1.516-.428-1.516h-4.661l-.101.367c-.055.202-.245.873-.423 1.491l-.323 1.125-1.63.027-1.631.027zm7.136-7.875c-.4-1.386-.752-2.585-.783-2.666-.047-.124-.409 1.048-1.396 4.524l-.188.66h3.094zm6.811.806v-7.481l3.154.002c3.421.002 4.243.073 5.034.435.74.34 1.51 1.105 1.849 1.84.261.567.28.691.28 1.83.001 1.464-.153 2.06-.76 2.948-.23.335-.687.816-1.021 1.072l-.606.465 2.05 3.141c1.127 1.728 2.05 3.161 2.05 3.186 0 .024-.876.044-1.947.044h-1.946l-1.697-2.737-1.697-2.738h-.757l-.758-.001v5.476h-3.228zm6.018-.99c.213-.11.52-.387.68-.614.246-.348.297-.523.324-1.116.027-.584-.006-.776-.194-1.137-.357-.686-.737-.83-2.305-.871l-1.295-.034v4.052l1.2-.04c.966-.032 1.278-.079 1.59-.24zm6.794.99v-7.481h3.78l1.304 3.496c.717 1.923 1.356 3.6 1.42 3.727.102.207.256-.15 1.512-3.496l1.397-3.727H275V39.705h-3.129l-.004-4.963c-.002-3.104-.037-4.905-.094-4.808-.05.085-.538 1.406-1.083 2.934-.546 1.528-1.036 2.9-1.09 3.047l-.097.27h-1.104c-.795 0-1.118-.035-1.15-.123-.025-.067-.52-1.465-1.103-3.105-.581-1.64-1.094-3.025-1.139-3.076-.044-.051-.081 2.138-.081 4.866v4.958h-3.032zm14.415 7.069c.07-.23 1.11-3.599 2.312-7.486l2.185-7.068 1.858.026 1.859.026 2.28 7.383c1.254 4.06 2.28 7.416 2.28 7.457 0 .041-.738.075-1.639.075h-1.638l-.428-1.516-.428-1.516h-4.661l-.101.367c-.055.202-.245.873-.423 1.491l-.323 1.125-1.63.027-1.631.027zm7.136-7.875c-.4-1.386-.752-2.585-.783-2.666-.047-.124-.409 1.048-1.396 4.524l-.188.66h3.094zm6.811.806v-7.5l3.154.043c2.817.037 3.234.063 3.902.246 1.174.322 1.898.74 2.735 1.577.607.607.827.916 1.19 1.673.674 1.41.798 2.012.801 3.912.004 1.713-.08 2.216-.575 3.439-.563 1.394-1.66 2.697-2.769 3.288-1.228.654-1.767.733-5.284.78l-3.154.042zm6.337 4.305c1.45-.651 2.174-2.083 2.17-4.294-.005-2.216-.741-3.642-2.244-4.343-.46-.214-.708-.255-1.785-.294l-1.25-.045v9.343l1.247-.045c1.102-.04 1.318-.078 1.862-.322zm6.024 2.764c.07-.23 1.11-3.599 2.312-7.486l2.185-7.068 1.858.026 1.859.026 2.28 7.383c1.254 4.06 2.28 7.416 2.28 7.457 0 .041-.737.075-1.638.075h-1.638l-.429-1.516-.428-1.516h-4.662l-.1.367c-.055.202-.245.873-.423 1.491l-.323 1.125-1.63.027-1.63.027zm7.136-7.875a171.2 171.2 0 0 0-.783-2.666c-.047-.124-.409 1.048-1.396 4.524l-.188.66h3.094z",
    style: {
      fill: "#193062",
      fillOpacity: 1,
      strokeWidth: 0.0978009
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path357",
    d: "M211.01 58.097c0-.019-.179-.046-.397-.06-3.453-.236-6.588-1.72-9.27-4.392-3.155-3.142-5.268-7.844-5.684-12.644l-.075-.831c-.03-.306-.019-2.83.014-3.216.066-.778.176-1.721.236-2.023l.098-.561c.358-2.11 1.228-4.57 2.299-6.502 1.546-2.79 3.736-5.132 6.167-6.596 3.692-2.224 8.162-2.605 12.11-1.032 2.676 1.066 5.11 3.03 6.988 5.64.222.309.931 1.382.931 1.41 0 .008.067.126.148.261.85 1.41 1.696 3.514 2.167 5.388.267 1.062.413 1.884.569 3.19.161 1.36.169 3.812.015 4.95-.022.16-.075.568-.117.908-.326 2.588-1.275 5.42-2.586 7.714-2.843 4.978-7.304 8.009-12.27 8.336-.228.014-.415.042-.415.06 0 .019-.209.034-.464.034s-.464-.016-.464-.034zm1.833-1.765c3.686-.422 7.146-2.674 9.546-6.213a16.81 16.81 0 0 0 1.23-2.1c.956-1.9 1.565-3.83 1.928-6.109.048-.301.146-1.176.184-1.643.039-.475.039-2.739 0-3.19-.06-.698-.182-1.712-.24-1.992a22.214 22.214 0 0 1-.08-.444c-.269-1.562-.925-3.553-1.68-5.103-.888-1.82-1.935-3.307-3.286-4.663-.6-.602-.7-.693-1.18-1.082-1.96-1.586-4.318-2.59-6.626-2.82a17.135 17.135 0 0 0-2.292 0c-2.153.214-4.403 1.126-6.278 2.545-.764.579-1.918 1.689-2.5 2.403-1.1 1.353-1.83 2.545-2.642 4.314-.385.838-.936 2.49-1.142 3.42l-.136.599a25.4 25.4 0 0 0-.234 1.353l-.036.252c-.115.785-.149 1.428-.15 2.803 0 1.358.038 2.08.147 2.803l.04.271c.243 1.773.816 3.804 1.52 5.394.216.488.858 1.721 1.128 2.165 1.213 1.996 2.712 3.631 4.43 4.834 1.81 1.266 3.824 2.03 5.859 2.224.265.025.486.049.49.052.036.03 1.588-.026 2-.073zm3.585-2.242c-.512-.555-.773-1.266-.773-2.107 0-.648.105-1.046.444-1.683.244-.46.454-1.076.52-1.525.105-.723-.02-1.658-.314-2.326-.296-.676-.86-1.393-1.419-1.805a5.716 5.716 0 0 0-1.16-.632l-.242-.091v-.551c0-.303.01-.551.021-.551.057 0 .998.374 1.22.485.461.231.969.603 1.367 1.001.655.655 1.062 1.307 1.333 2.133.222.676.289 1.172.262 1.93-.033.922-.187 1.508-.627 2.38-.295.585-.374.865-.363 1.286.014.526.214 1.02.58 1.43.105.117.19.221.19.232 0 .02-.652.447-.798.523-.073.038-.102.023-.241-.129zm-4.858-.203c-.042-.08-.286-.355-.54-.612-.659-.663-1.542-1.25-3.133-2.085-.704-.37-1.501-.815-1.798-1.006-.969-.624-1.967-1.758-2.977-3.383a21.34 21.34 0 0 0-.35-.554c-.016-.017-.055.043-.088.136-.07.193-.358.903-.412 1.018-.02.042-.07.163-.11.269-.04.105-.09.197-.112.204-.072.024-.407-.9-.608-1.672-.184-.71-.26-1.366-.255-2.199.007-1.296.227-2.337.688-3.263.076-.154.15-.28.161-.28.013 0 .091.212.175.47.334 1.033.951 2.039 1.759 2.869.589.605 1.359 1.193 1.918 1.465.18.087.221.145.105.145-.21 0-1.967.165-1.99.187-.042.04.568.704.91.992.574.48 1.176.845 1.903 1.15.864.364 1.347.446 1.847.317.738-.191 1.33-.797 1.478-1.514.042-.206.06-.547.136-2.717.043-1.202.085-2.35.095-2.552.02-.437.134-3.238.135-3.335 0-.037.024-.068.052-.068.029 0 .216-.06.416-.132.76-.278 1.855-.65 1.869-.637.008.009.05 1.033.096 2.277.045 1.244.09 2.436.1 2.649.046 1.009.061 1.383.116 2.847.063 1.662.078 1.78.279 2.176.122.24.435.576.694.743.503.325 1.057.4 1.658.226.187-.054.363-.09.391-.079.077.03.065.517-.023.912-.084.38-.101.427-.527 1.43-.177.415-.333.806-.348.87-.04.167-.065.19-.436.39-.543.294-1.262.736-1.679 1.034-.461.33-1.08.924-1.285 1.235-.08.122-.166.222-.19.222-.024 0-.078-.065-.12-.145zm6.375-4.282a5.15 5.15 0 0 0 .089-.416c.074-.404.089-1.576.025-1.992l-.038-.243.274-.22c.465-.376 1.155-1.095 1.101-1.149a55.366 55.366 0 0 0-2.02-.176c-.12 0-.063-.061.155-.168.311-.153.817-.493 1.247-.839a7.59 7.59 0 0 0 2.421-3.536c.07-.213.142-.385.16-.383.12.016.571 1.228.706 1.9.239 1.185.197 2.597-.111 3.8-.176.687-.527 1.664-.606 1.69-.028.009-.158-.292-.662-1.53l-.053-.13-.292.478c-.59.966-1.372 2-1.98 2.618-.327.331-.468.431-.416.296zm-8.64-7.245c-.545-.221-.879-.433-1.185-.752-.553-.575-.82-1.242-.826-2.054a2.921 2.921 0 0 1 1.217-2.397c.386-.273.453-.301 2.233-.926 2.481-.871 2.638-.935 3.041-1.24a3.159 3.159 0 0 0 1.172-1.986l.048-.314.158-.02c.087-.01.32-.025.516-.032l.357-.014v.162c0 .442-.184 1.126-.444 1.641-.207.412-.337.59-.73.996-.557.577-.946.802-2.066 1.194-.398.139-.836.294-.974.344l-1.257.446c-1.173.413-1.38.514-1.68.816-.982.991-.577 2.659.765 3.148l.284.104-.024.41c-.032.532-.053.663-.11.659a5.555 5.555 0 0 1-.496-.185zm1.294-7.123.048-1.041c.054-1.117.075-1.8.055-1.822-.011-.013-1.3-.071-2.861-.129-1.563-.057-2.855-.113-2.872-.123-.016-.01-.03-.479-.03-1.041v-1.022h.222c.192 0 2.186-.085 3.18-.135.182-.009.8-.036 1.373-.06.575-.024 1.057-.055 1.071-.07.015-.014.04-.34.054-.723l.027-.698-.228-.087a3.306 3.306 0 0 1-.961-.592c-1.029-.94-1.247-2.566-.501-3.732.217-.34.398-.539.693-.764.339-.258.58-.38 1.013-.51.288-.088.415-.104.824-.106.499-.002.688.033 1.16.216.73.282 1.413 1.002 1.663 1.752.123.37.127.395.14.907.01.385-.004.544-.065.78-.139.542-.348.922-.724 1.316l-.215.226.548.808c.3.444.547.82.547.836 0 .025-.142.019-.908-.042-.415-.033-.398-.02-.768-.565-.321-.472-.349-.502-.445-.478a.69.69 0 0 0-.107.032c-.017.023.04 1.38.059 1.41.013.02.704.065 1.55.101.84.036 2.041.09 2.669.12.627.03 1.25.055 1.382.056l.242.001V31.1c0 .967-.005 1.041-.068 1.04-.16-.005-5.675.208-5.687.22-.007.006.006.513.03 1.126l.048 1.318c.004.111-.002.212-.015.224a7.639 7.639 0 0 1-.558.215l-1 .362c-.255.093-.497.182-.537.198-.07.028-.073.008-.048-.567zm2.157-8.23c.628-.45.918-1.225.727-1.945-.13-.488-.526-.942-1.032-1.183-.292-.138-.313-.142-.745-.142-.43 0-.454.005-.735.138-.421.201-.697.47-.899.878l-.164.331.002.448c0 .418.009.464.12.699.065.138.189.335.274.438.245.294.686.576.616.394-.046-.119.088-.434.243-.575a.771.771 0 0 1 1.3.468c.015.111.04.203.054.203.015 0 .123-.069.24-.152zM202.16 19.3l-.446-.934a18.388 18.388 0 0 1-.294-.63c0-.023.483-.24.967-.436 1.524-.618 3.211-1.11 4.698-1.373 1.732-.306 2.236-.347 4.215-.348 1.714-.001 2.638.058 3.615.23l.464.078c1.572.262 3.196.726 4.833 1.382.641.257 1.044.439 1.044.47 0 .016-.199.441-.631 1.35l-.254.533-.186-.093c-.287-.145-1.289-.542-1.867-.741-1.274-.44-2.928-.83-4.176-.985-1.823-.228-2.984-.252-4.756-.1-1.6.137-3.546.565-5.162 1.134-.564.2-1.52.582-1.769.709l-.144.073zm-2.665-3.858c-.435-.09-.853-.435-1.063-.878-.106-.224-.126-.314-.138-.62-.02-.541.125-.868.477-1.074.643-.377 1.555-.006 1.924.782.16.34.193.79.083 1.099-.09.247-.35.547-.547.625a1.533 1.533 0 0 1-.736.066zm23.166 0c-.575-.119-.896-.681-.785-1.376a1.602 1.602 0 0 1 1.285-1.332 1.034 1.034 0 0 1 1.174.668 1.7 1.7 0 0 1 .059.477c0 .333-.067.567-.25.88-.283.482-.957.793-1.483.683zm-18.111-1.365c-.57-.161-1.021-.679-1.119-1.284-.107-.664.268-1.364.89-1.659.233-.11.281-.119.678-.119.416 0 .435.004.723.146.477.236.768.63.84 1.139.103.73-.226 1.36-.876 1.68-.209.103-.296.122-.602.134a2.053 2.053 0 0 1-.534-.036zm12.64-.02c-.12-.04-.279-.11-.352-.156-.208-.128-.488-.45-.601-.693-.094-.2-.104-.264-.104-.665 0-.418.007-.46.116-.675.525-1.038 2.001-1.186 2.693-.27a1.57 1.57 0 0 1-.578 2.386 1.788 1.788 0 0 1-1.174.072zm-6.335-.386c-.706-.235-1.115-.849-1.075-1.614.03-.565.341-1.04.846-1.288.83-.409 1.784-.083 2.165.74.12.257.13.31.13.666.001.353-.009.409-.118.638-.173.364-.392.59-.731.759-.255.126-.326.143-.645.156-.275.01-.41-.002-.572-.057zm-13.447-1.06a4.634 4.634 0 0 1-.684-1.616c-.107-.504-.109-1.237-.005-1.72.367-1.7 1.818-2.82 4.063-3.134.462-.065 1.958-.102 2.01-.05.014.014-.047.118-.134.232-.204.266-.44.751-.534 1.096l-.074.271-.537.048c-.88.078-1.346.193-1.94.478-.58.279-1.04.81-1.186 1.367-.133.51-.045 1.177.227 1.717.076.15.138.283.138.294 0 .012-.049.02-.109.02s-.203.028-.319.062c-.383.113-.732.575-.732.97 0 .172-.051.162-.184-.036zm27.72-.097c-.103-.527-.54-.898-1.059-.9-.08 0-.145-.007-.145-.017a4.129 4.129 0 0 0 .28-.606c.119-.309.125-.349.124-.865 0-.529-.003-.548-.124-.808a3.012 3.012 0 0 0-.27-.456c-.468-.615-1.439-1.016-2.7-1.116-.317-.025-.582-.05-.587-.055a3.19 3.19 0 0 1-.09-.295 3.421 3.421 0 0 0-.523-1.063l-.171-.228.223-.032c.252-.036 1.254-.004 1.727.055a6.537 6.537 0 0 1 2.026.575c.478.231.672.36 1.046.69.59.524.974 1.244 1.128 2.116.045.259.037 1.156-.013 1.357-.134.543-.224.8-.417 1.193a4.719 4.719 0 0 1-.319.574l-.09.11zm-21.768-2.415a5.743 5.743 0 0 1-.135-.476 16.33 16.33 0 0 0-.068-.348 5.499 5.499 0 0 1-.045-.792c.004-1.118.298-1.823 1.108-2.66.754-.778 1.52-1.13 2.865-1.317.637-.088.81-.098 1.76-.1a26.18 26.18 0 0 1 2.145.086c.192.015.505.015.696 0 .826-.062 1.479-.089 2.166-.087.964.002 1.14.013 1.76.102 1.2.173 1.912.463 2.596 1.056.713.618 1.101 1.245 1.293 2.088.084.369.095 1.198.021 1.644-.041.252-.26 1.078-.293 1.112-.006.006-.115-.09-.241-.217a2.011 2.011 0 0 0-.382-.305 2.1 2.1 0 0 0-.71-.18c-.077-.002-.144-.022-.15-.043a2.606 2.606 0 0 1 .075-.406c.16-.695.097-1.357-.172-1.817-.164-.282-.612-.73-.878-.878-.287-.16-.724-.305-1.143-.378-.53-.093-1.67-.136-2.608-.097l-.84.036c-.007 0-.01.82-.01 1.82 0 1.009-.016 1.817-.034 1.817-.019 0-.119-.039-.223-.086-.266-.122-.83-.121-1.136.002a1.86 1.86 0 0 1-.241.084c-.016 0-.03-.816-.03-1.813V6.133l-.27-.028c-.44-.044-2.304-.032-2.745.017-1.095.124-1.75.419-2.22 1-.29.359-.397.592-.464 1.003-.05.308-.05.401 0 .755.03.222.08.494.108.604.028.11.038.208.022.218a.567.567 0 0 1-.178.013c-.395-.013-.933.26-1.178.598l-.106.147-.115-.36zm7.549-6.007c-.212-.079-.456-.292-.586-.514-.094-.16-.106-.218-.106-.528 0-.283.016-.377.084-.503a1.29 1.29 0 0 1 .564-.522l.183-.08v-.732h-.657v-.58h.657V.131h.58v.502h.661l-.011.28-.012.281-.319.011-.319.011v.755l.144.052c.078.028.234.143.345.254.157.157.217.252.268.427.079.273.054.612-.063.854a1.214 1.214 0 0 1-.533.505c-.204.086-.685.101-.88.029z",
    style: {
      fill: "#193062",
      fillOpacity: 1,
      strokeWidth: 0.0386668
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5637ef4cd92da04ebe8ff56a7e89aff4.svg";
export { ForwardRef as ReactComponent };